(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends2 = __webpack_require__(24);

	var _extends3 = _interopRequireDefault(_extends2);

	var _habitat = __webpack_require__(88);

	var _habitat2 = _interopRequireDefault(_habitat);

	var _widget = __webpack_require__(87);

	var _widget2 = _interopRequireDefault(_widget);

	var _TabNavigation = __webpack_require__(85);

	var _TabNavigation2 = _interopRequireDefault(_TabNavigation);

	__webpack_require__(158);

	__webpack_require__(157);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var iasFlightWidgetComp = void 0;
	var iasTabWidgetComp = void 0;

	window.IAStabWidget = {
	  init: function init(params) {
	    iasTabWidgetComp = (0, _habitat2.default)(_TabNavigation2.default);
	    iasTabWidgetComp.tabInit(params);
	  }
	};
	window.IASflightWidget = {
	  init: function init() {
	    iasFlightWidgetComp = (0, _habitat2.default)(_widget2.default);
	    iasFlightWidgetComp.render({
	      clientSpecified: true,
	      inline: false,
	      clean: true,
	      source: "init"
	    });
	  },
	  renderWidget: function renderWidget(params) {
	    /* console.log("rendering",params) */
	    iasFlightWidgetComp.render({
	      clientSpecified: true,
	      inline: false,
	      clean: true,
	      defaultProps: (0, _extends3.default)({}, params),
	      source: "render"
	    });
	  },
	  updateWidget: function updateWidget(params) {
	    iasFlightWidgetComp.render({
	      clientSpecified: true,
	      inline: false,
	      clean: true,
	      defaultProps: (0, _extends3.default)({}, params),
	      source: "update"
	    });
	  }

	  // in development, set up HMR:
	};if (false) {
	  require('preact/devtools'); // enables React DevTools, be careful on IE
	  module.hot.accept('./components/widget', function () {
	    return requestAnimationFrame(init);
	  });
	}

	window.IASflightWidget.init();
	window.IAStabWidget.init();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(43)('wks');
	var uid = __webpack_require__(31);
	var Symbol = __webpack_require__(1).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	var n,l,t,u,r,i,o,e,f,c,s,a,h,p,v,y,d={},w=[],_=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,g=Array.isArray;function x(n,l){for(var t in l)n[t]=l[t];return n}function m(n){n&&n.parentNode&&n.parentNode.removeChild(n)}function b(l,t,u){var r,i,o,e={};for(o in t)"key"==o?r=t[o]:"ref"==o?i=t[o]:e[o]=t[o];if(arguments.length>2&&(e.children=arguments.length>3?n.call(arguments,2):u),"function"==typeof l&&null!=l.defaultProps)for(o in l.defaultProps)void 0===e[o]&&(e[o]=l.defaultProps[o]);return k(l,e,r,i,null)}function k(n,u,r,i,o){var e={type:n,props:u,key:r,ref:i,__k:null,__:null,__b:0,__e:null,__c:null,constructor:void 0,__v:null==o?++t:o,__i:-1,__u:0};return null==o&&null!=l.vnode&&l.vnode(e),e}function M(n){return n.children}function S(n,l){this.props=n,this.context=l}function $(n,l){if(null==l)return n.__?$(n.__,n.__i+1):null;for(var t;l<n.__k.length;l++)if(null!=(t=n.__k[l])&&null!=t.__e)return t.__e;return"function"==typeof n.type?$(n):null}function C(n){if(n.__P&&n.__d){var t=n.__v,u=t.__e,r=[],i=[],o=x({},t);o.__v=t.__v+1,l.vnode&&l.vnode(o),N(n.__P,o,t,n.__n,n.__P.namespaceURI,32&t.__u?[u]:null,r,null==u?$(t):u,!!(32&t.__u),i),o.__v=t.__v,o.__.__k[o.__i]=o,q(r,o,i),t.__e=t.__=null,o.__e!=u&&I(o)}}function I(n){if(null!=(n=n.__)&&null!=n.__c)return n.__e=n.__c.base=null,n.__k.some(function(l){if(null!=l&&null!=l.__e)return n.__e=n.__c.base=l.__e}),I(n)}function P(n){(!n.__d&&(n.__d=!0)&&r.push(n)&&!A.__r++||i!=l.debounceRendering)&&((i=l.debounceRendering)||o)(A)}function A(){try{for(var n,l=1;r.length;)r.length>l&&r.sort(e),n=r.shift(),l=r.length,C(n)}finally{r.length=A.__r=0}}function H(n,l,t,u,r,i,o,e,f,c,s){var a,h,p,v,y,_,g=u&&u.__k||w,x=l.length;for(f=L(t,l,g,f,x),a=0;a<x;a++)null!=(p=t.__k[a])&&(h=-1!=p.__i&&g[p.__i]||d,p.__i=a,_=N(n,p,h,r,i,o,e,f,c,s),v=p.__e,p.ref&&h.ref!=p.ref&&(h.ref&&E(h.ref,null,p),s.push(p.ref,p.__c||v,p)),null==y&&null!=v&&(y=v),4&p.__u?(f=T(p,f,n),h.__e&&(h.__e=null)):"function"==typeof p.type&&void 0!==_?f=_:v&&(f=v.nextSibling),p.__u&=-7);return t.__e=y,f}function L(n,l,t,u,r){var i,o,e,f,c,s=t.length,a=s,h=0;for(n.__k=new Array(r),i=0;i<r;i++)null!=(o=l[i])&&"boolean"!=typeof o&&"function"!=typeof o?("string"==typeof o||"number"==typeof o||"bigint"==typeof o||o.constructor==String?o=n.__k[i]=k(null,o,null,null,null):g(o)?o=n.__k[i]=k(M,{children:o},null,null,null):void 0===o.constructor&&o.__b>0?o=n.__k[i]=k(o.type,o.props,o.key,o.ref?o.ref:null,o.__v):n.__k[i]=o,f=i+h,o.__=n,o.__b=n.__b+1,e=null,-1!=(c=o.__i=j(o,t,f,a))&&(a--,(e=t[c])&&(e.__u|=2)),null==e||null==e.__v?(-1==c&&(r>s?h--:r<s&&h++),"function"!=typeof o.type&&(o.__u|=4)):c!=f&&(c==f-1?h--:c==f+1?h++:(c>f?h--:h++,o.__u|=4))):n.__k[i]=null;if(a)for(i=0;i<s;i++)null!=(e=t[i])&&0==(2&e.__u)&&(e.__e==u&&(u=$(e)),G(e,e));return u}function T(n,l,t){var u,r;if("function"==typeof n.type){for(u=n.__k,r=0;u&&r<u.length;r++)u[r]&&(u[r].__=n,l=T(u[r],l,t));return l}n.__e!=l&&(l&&n.type&&!l.parentNode&&(l=$(n)),l=t.insertBefore(n.__e,l||null));do{l=l&&l.nextSibling}while(null!=l&&8==l.nodeType);return l}function j(n,l,t,u){var r,i,o,e=n.key,f=n.type,c=l[t],s=null!=c&&0==(2&c.__u);if(null===c&&null==e||s&&e==c.key&&f==c.type)return t;if(u>(s?1:0))for(r=t-1,i=t+1;r>=0||i<l.length;)if(null!=(c=l[o=r>=0?r--:i++])&&0==(2&c.__u)&&e==c.key&&f==c.type)return o;return-1}function F(n,l,t){"-"==l[0]?n.setProperty(l,null==t?"":t):n[l]=null==t?"":"number"!=typeof t||_.test(l)?t:t+"px"}function O(n,l,t,u,r){var i,o;n:if("style"==l)if("string"==typeof t)n.style.cssText=t;else{if("string"==typeof u&&(n.style.cssText=u=""),u)for(l in u)t&&l in t||F(n.style,l,"");if(t)for(l in t)u&&t[l]==u[l]||F(n.style,l,t[l])}else if("o"==l[0]&&"n"==l[1])i=l!=(l=l.replace(a,"$1")),o=l.toLowerCase(),l=o in n||"onFocusOut"==l||"onFocusIn"==l?o.slice(2):l.slice(2),n.l||(n.l={}),n.l[l+i]=t,t?u?t[s]=u[s]:(t[s]=h,n.addEventListener(l,i?v:p,i)):n.removeEventListener(l,i?v:p,i);else{if("http://www.w3.org/2000/svg"==r)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!=l&&"height"!=l&&"href"!=l&&"list"!=l&&"form"!=l&&"tabIndex"!=l&&"download"!=l&&"rowSpan"!=l&&"colSpan"!=l&&"role"!=l&&"popover"!=l&&l in n)try{n[l]=null==t?"":t;break n}catch(n){}"function"==typeof t||(null==t||!1===t&&"-"!=l[4]?n.removeAttribute(l):n.setAttribute(l,"popover"==l&&1==t?"":t))}}function z(n){return function(t){if(this.l){var u=this.l[t.type+n];if(null==t[c])t[c]=h++;else if(t[c]<u[s])return;return u(l.event?l.event(t):t)}}}function N(n,t,u,r,i,o,e,f,c,s){var a,h,p,v,y,d,_,b,k,C,I,P,A,L,T,j,F=t.type;if(void 0!==t.constructor)return null;128&u.__u&&(c=!!(32&u.__u),o=[f=t.__e=u.__e]),(a=l.__b)&&a(t);n:if("function"==typeof F){h=e.length;try{if(k=t.props,C=F.prototype&&F.prototype.render,I=(a=F.contextType)&&r[a.__c],P=a?I?I.props.value:a.__:r,u.__c?b=(p=t.__c=u.__c).__=p.__E:(C?t.__c=p=new F(k,P):(t.__c=p=new S(k,P),p.constructor=F,p.render=J),I&&I.sub(p),p.state||(p.state={}),p.__n=r,v=p.__d=!0,p.__h=[],p._sb=[]),C&&null==p.__s&&(p.__s=p.state),C&&null!=F.getDerivedStateFromProps&&(p.__s==p.state&&(p.__s=x({},p.__s)),x(p.__s,F.getDerivedStateFromProps(k,p.__s))),y=p.props,d=p.state,p.__v=t,v)C&&null==F.getDerivedStateFromProps&&null!=p.componentWillMount&&p.componentWillMount(),C&&null!=p.componentDidMount&&p.__h.push(p.componentDidMount);else{if(C&&null==F.getDerivedStateFromProps&&k!==y&&null!=p.componentWillReceiveProps&&p.componentWillReceiveProps(k,P),t.__v==u.__v||!p.__e&&null!=p.shouldComponentUpdate&&!1===p.shouldComponentUpdate(k,p.__s,P)){t.__v!=u.__v&&(p.props=k,p.state=p.__s,p.__d=!1),t.__e=u.__e,t.__k=u.__k,t.__k.some(function(n){n&&(n.__=t)}),w.push.apply(p.__h,p._sb),p._sb=[],p.__h.length&&e.push(p),f=$(u);break n}null!=p.componentWillUpdate&&p.componentWillUpdate(k,p.__s,P),C&&null!=p.componentDidUpdate&&p.__h.push(function(){p.componentDidUpdate(y,d,_)})}if(p.context=P,p.props=k,p.__P=n,p.__e=!1,A=l.__r,L=0,C)p.state=p.__s,p.__d=!1,A&&A(t),a=p.render(p.props,p.state,p.context),w.push.apply(p.__h,p._sb),p._sb=[];else do{p.__d=!1,A&&A(t),a=p.render(p.props,p.state,p.context),p.state=p.__s}while(p.__d&&++L<25);p.state=p.__s,null!=p.getChildContext&&(r=x(x({},r),p.getChildContext())),C&&!v&&null!=p.getSnapshotBeforeUpdate&&(_=p.getSnapshotBeforeUpdate(y,d)),T=null!=a&&a.type===M&&null==a.key?B(a.props.children):a,f=H(n,g(T)?T:[T],t,u,r,i,o,e,f,c,s),p.base=t.__e,t.__u&=-161,p.__h.length&&e.push(p),b&&(p.__E=p.__=null)}catch(n){if(e.length=h,t.__v=null,c||null!=o){if(n.then){for(t.__u|=c?160:128;f&&8==f.nodeType&&f.nextSibling;)f=f.nextSibling;null!=o&&(o[o.indexOf(f)]=null),t.__e=f}else if(null!=o)for(j=o.length;j--;)m(o[j])}else t.__e=u.__e;null==t.__k&&(t.__k=u.__k||[]),n.then||V(t),l.__e(n,t,u)}}else null==o&&t.__v==u.__v?(t.__k=u.__k,t.__e=u.__e):f=t.__e=D(u.__e,t,u,r,i,o,e,c,s);return(a=l.diffed)&&a(t),128&t.__u?void 0:f}function V(n){n&&(n.__c&&(n.__c.__e=!0),n.__k&&n.__k.some(V))}function q(n,t,u){for(var r=0;r<u.length;r++)E(u[r],u[++r],u[++r]);l.__c&&l.__c(t,n),n.some(function(t){try{n=t.__h,t.__h=[],n.some(function(n){n.call(t)})}catch(n){l.__e(n,t.__v)}})}function B(n){return"object"!=typeof n||null==n||n.__b>0?n:g(n)?n.map(B):void 0!==n.constructor?null:x({},n)}function D(t,u,r,i,o,e,f,c,s){var a,h,p,v,y,w,_,x=r.props||d,b=u.props,k=u.type;if("svg"==k?o="http://www.w3.org/2000/svg":"math"==k?o="http://www.w3.org/1998/Math/MathML":o||(o="http://www.w3.org/1999/xhtml"),null!=e)for(a=0;a<e.length;a++)if((y=e[a])&&"setAttribute"in y==!!k&&(k?y.localName==k:3==y.nodeType)){t=y,e[a]=null;break}if(null==t){if(null==k)return document.createTextNode(b);t=document.createElementNS(o,k,b.is&&b),c&&(l.__m&&l.__m(u,e),c=!1),e=null}if(null==k)x===b||c&&t.data==b||(t.data=b);else{if(e="textarea"==k&&null!=b.defaultValue?null:e&&n.call(t.childNodes),!c&&null!=e)for(x={},a=0;a<t.attributes.length;a++)x[(y=t.attributes[a]).name]=y.value;for(a in x)y=x[a],"dangerouslySetInnerHTML"==a?p=y:"children"==a||a in b||"value"==a&&"defaultValue"in b||"checked"==a&&"defaultChecked"in b||O(t,a,null,y,o);for(a in b)y=b[a],"children"==a?v=y:"dangerouslySetInnerHTML"==a?h=y:"value"==a?w=y:"checked"==a?_=y:c&&"function"!=typeof y||x[a]===y||O(t,a,y,x[a],o);if(h)c||p&&(h.__html==p.__html||h.__html==t.innerHTML)||(t.innerHTML=h.__html),u.__k=[];else if(p&&(t.innerHTML=""),H("template"==u.type?t.content:t,g(v)?v:[v],u,r,i,"foreignObject"==k?"http://www.w3.org/1999/xhtml":o,e,f,e?e[0]:r.__k&&$(r,0),c,s),null!=e)for(a=e.length;a--;)m(e[a]);c&&"textarea"!=k||(a="value","progress"==k&&null==w?t.removeAttribute("value"):null!=w&&(w!==t[a]||"progress"==k&&!w||"option"==k&&w!=x[a])&&O(t,a,w,x[a],o),a="checked",null!=_&&_!=t[a]&&O(t,a,_,x[a],o))}return t}function E(n,t,u){try{if("function"==typeof n){var r="function"==typeof n.__u;r&&n.__u(),r&&null==t||(n.__u=n(t))}else n.current=t}catch(n){l.__e(n,u)}}function G(n,t,u){var r,i;if(l.unmount&&l.unmount(n),(r=n.ref)&&(r.current&&r.current!=n.__e||E(r,null,t)),null!=(r=n.__c)){if(r.componentWillUnmount)try{r.componentWillUnmount()}catch(n){l.__e(n,t)}r.base=r.__P=r.__n=null}if(r=n.__k)for(i=0;i<r.length;i++)r[i]&&G(r[i],t,u||"function"!=typeof n.type);u||m(n.__e),n.__c=n.__=n.__e=void 0}function J(n,l,t){return this.constructor(n,t)}function K(t,u,r){var i,o,e,f;u==document&&(u=document.documentElement),l.__&&l.__(t,u),o=(i="function"==typeof r)?null:r&&r.__k||u.__k,e=[],f=[],N(u,t=(!i&&r||u).__k=b(M,null,[t]),o||d,d,u.namespaceURI,!i&&r?[r]:o?null:u.firstChild?n.call(u.childNodes):null,e,!i&&r?r:o?o.__e:u.firstChild,i,f),q(e,t,f),t.props.children=null}n=w.slice,l={__e:function(n,l,t,u){for(var r,i,o;l=l.__;)if((r=l.__c)&&!r.__)try{if((i=r.constructor)&&null!=i.getDerivedStateFromError&&(r.setState(i.getDerivedStateFromError(n)),o=r.__d),null!=r.componentDidCatch&&(r.componentDidCatch(n,u||{}),o=r.__d),o)return r.__E=r}catch(l){n=l}throw n}},t=0,u=function(n){return null!=n&&void 0===n.constructor},S.prototype.setState=function(n,l){var t;t=null!=this.__s&&this.__s!=this.state?this.__s:this.__s=x({},this.state),"function"==typeof n&&(n=n(x({},t),this.props)),n&&x(t,n),null!=n&&this.__v&&(l&&this._sb.push(l),P(this))},S.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),P(this))},S.prototype.render=M,r=[],o="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,e=function(n,l){return n.__v.__b-l.__v.__b},A.__r=0,f=Math.random().toString(8),c="__d"+f,s="__a"+f,a=/(PointerCapture)$|Capture$/i,h=0,p=z(!1),v=z(!0),y=0,exports.Component=S,exports.Fragment=M,exports.cloneElement=function(l,t,u){var r,i,o,e,f=x({},l.props);for(o in l.type&&l.type.defaultProps&&(e=l.type.defaultProps),t)"key"==o?r=t[o]:"ref"==o?i=t[o]:f[o]=void 0===t[o]&&null!=e?e[o]:t[o];return arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):u),k(l.type,f,r||l.key,i||l.ref,null)},exports.createContext=function(n){function l(n){var t,u;return this.getChildContext||(t=new Set,(u={})[l.__c]=this,this.getChildContext=function(){return u},this.componentWillUnmount=function(){t=null},this.shouldComponentUpdate=function(n){this.props.value!=n.value&&t.forEach(function(n){n.__e=!0,P(n)})},this.sub=function(n){t.add(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){t&&t.delete(n),l&&l.call(n)}}),n.children}return l.__c="__cC"+y++,l.__=n,l.Provider=l.__l=(l.Consumer=function(n,l){return n.children(l)}).contextType=l,l},exports.createElement=b,exports.createRef=function(){return{current:null}},exports.h=b,exports.hydrate=function n(l,t){K(l,t,n)},exports.isValidElement=u,exports.options=l,exports.render=K,exports.toChildArray=function n(l,t){return t=t||[],null==l||"boolean"==typeof l||(g(l)?l.some(function(l){n(l,t)}):t.push(l)),t};
	//# sourceMappingURL=preact.js.map


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	module.exports = function (it) {
	  if (!isObject(it)) return;(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(20)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var core = __webpack_require__(3);
	var ctx = __webpack_require__(19);
	var hide = __webpack_require__(11);
	var has = __webpack_require__(10);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var n=__webpack_require__(4),t=__webpack_require__(13);function e(n,t){for(var e in t)n[e]=t[e];return n}function r(n,t){for(var e in n)if("__source"!==e&&!(e in t))return!0;for(var r in t)if("__source"!==r&&n[r]!==t[r])return!0;return!1}function u(n,e){var r=e(),u=t.useState({t:{__:r,u:e}}),i=u[0].t,c=u[1];return t.useLayoutEffect(function(){i.__=r,i.u=e,o(i)&&c({t:i})},[n,r,e]),t.useEffect(function(){return o(i)&&c({t:i}),n(function(){o(i)&&c({t:i})})},[n]),r}function o(n){try{return!((t=n.__)===(e=n.u())&&(0!==t||1/t==1/e)||t!=t&&e!=e)}catch(n){return!0}var t,e}function i(n){n()}function c(n){return n}function l(){return[!1,i]}var f=t.useLayoutEffect;function a(n,t){this.props=n,this.context=t}function s(t,e){function u(n){var t=this.props.ref;return t!=n.ref&&t&&("function"==typeof t?t(null):t.current=null),e?!e(this.props,n)||t!=n.ref:r(this.props,n)}function o(e){return this.shouldComponentUpdate=u,n.createElement(t,e)}return o.displayName="Memo("+(t.displayName||t.name)+")",o.__f=o.prototype.isReactComponent=!0,o.type=t,o}(a.prototype=new n.Component).isPureReactComponent=!0,a.prototype.shouldComponentUpdate=function(n,t){return r(this.props,n)||r(this.state,t)};var p=n.options.__b;n.options.__b=function(n){n.type&&n.type.__f&&n.ref&&(n.props.ref=n.ref,n.ref=null),p&&p(n)};var v="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.forward_ref")||3911;function h(n){function t(t){var r=e({},t);return delete r.ref,n(r,t.ref||null)}return t.$$typeof=v,t.render=n,t.prototype.isReactComponent=t.__f=!0,t.displayName="ForwardRef("+(n.displayName||n.name)+")",t}var d=function(t,e){return null==t?null:n.toChildArray(n.toChildArray(t).map(e))},m={map:d,forEach:d,count:function(t){return t?n.toChildArray(t).length:0},only:function(t){var e=n.toChildArray(t);if(1!==e.length)throw"Children.only";return e[0]},toArray:n.toChildArray},x=n.options.__e;n.options.__e=function(n,t,e,r){if(n.then)for(var u,o=t;o=o.__;)if((u=o.__c)&&u.__c)return null==t.__e&&(t.__e=e.__e,t.__k=e.__k||[]),u.__c(n,t);x(n,t,e,r)};var b=n.options.unmount;function y(n,t,r){return n&&(n.__c&&n.__c.__H&&(n.__c.__H.__.forEach(function(n){"function"==typeof n.__c&&n.__c()}),n.__c.__H=null),null!=(n=e({},n)).__c&&(n.__c.__P===r&&(n.__c.__P=t),n.__c.__e=!0,n.__c=null),n.__k=n.__k&&n.__k.map(function(n){return y(n,t,r)})),n}function _(n,t,e){return n&&e&&(n.__v=null,n.__k=n.__k&&n.__k.map(function(n){return _(n,t,e)}),n.__c&&n.__c.__P===t&&(n.__e&&e.appendChild(n.__e),n.__c.__e=!0,n.__c.__P=e)),n}function g(){this.__u=0,this.o=null,this.__b=null}function S(n){var t=n.__&&n.__.__c;return t&&t.__a&&t.__a(n)}function E(t){var e,r,u,o=null;function i(i){if(e||(e=t()).then(function(n){n&&(o=n.default||n),u=!0},function(n){r=n,u=!0}),r)throw r;if(!u)throw e;return o?n.createElement(o,i):null}return i.displayName="Lazy",i.__f=!0,i}function C(){this.i=null,this.l=null}n.options.unmount=function(n){var t=n.__c;t&&(t.__z=!0),t&&t.__R&&t.__R(),t&&32&n.__u&&(n.type=null),b&&b(n)},(g.prototype=new n.Component).__c=function(n,t){var e=t.__c,r=this;null==r.o&&(r.o=[]),r.o.push(e);var u=S(r.__v),o=!1,i=function(){o||r.__z||(o=!0,e.__R=null,u?u(l):l())};e.__R=i;var c=e.__P;e.__P=null;var l=function(){if(!--r.__u){if(r.state.__a){var n=r.state.__a;r.__v.__k[0]=_(n,n.__c.__P,n.__c.__O)}var t;for(r.setState({__a:r.__b=null});t=r.o.pop();)t.__P=c,t.forceUpdate()}};r.__u++||32&t.__u||r.setState({__a:r.__b=r.__v.__k[0]}),n.then(i,i)},g.prototype.componentWillUnmount=function(){this.o=[]},g.prototype.render=function(t,e){if(this.__b){if(this.__v.__k){var r=document.createElement("div"),u=this.__v.__k[0].__c;this.__v.__k[0]=y(this.__b,r,u.__O=u.__P)}this.__b=null}var o=e.__a&&n.createElement(n.Fragment,null,t.fallback);return o&&(o.__u&=-33),[n.createElement(n.Fragment,null,e.__a?null:t.children),o]};var O=function(n,t,e){if(++e[1]===e[0]&&n.l.delete(t),n.props.revealOrder&&("t"!==n.props.revealOrder[0]||!n.l.size))for(e=n.i;e;){for(;e.length>3;)e.pop()();if(e[1]<e[0])break;n.i=e=e[2]}};function R(n){return this.getChildContext=function(){return n.context},n.children}function w(t){var e=this,r=t.p;if(e.componentWillUnmount=function(){n.render(null,e.v),e.v=null,e.p=null},e.p&&e.p!==r&&e.componentWillUnmount(),!e.v){for(var u=e.__v;null!==u&&!u.__m&&null!==u.__;)u=u.__;e.p=r,e.v={nodeType:1,parentNode:r,childNodes:[],__k:{__m:u.__m},contains:function(){return!0},namespaceURI:r.namespaceURI,insertBefore:function(n,t){this.childNodes.push(n),e.p.insertBefore(n,t)},removeChild:function(n){this.childNodes.splice(this.childNodes.indexOf(n)>>>1,1),e.p.removeChild(n)}}}n.render(n.createElement(R,{context:e.context},t.__v),e.v)}function j(t,e){var r=n.createElement(w,{__v:t,p:e});return r.containerInfo=e,r}(C.prototype=new n.Component).__a=function(n){var t=this,e=S(t.__v),r=t.l.get(n);return r[0]++,function(u){var o=function(){t.props.revealOrder?(r.push(u),O(t,n,r)):u()};e?e(o):o()}},C.prototype.render=function(t){this.i=null,this.l=new Map;var e=n.toChildArray(t.children);t.revealOrder&&"b"===t.revealOrder[0]&&e.reverse();for(var r=e.length;r--;)this.l.set(e[r],this.i=[1,0,this.i]);return t.children},C.prototype.componentDidUpdate=C.prototype.componentDidMount=function(){var n=this;this.l.forEach(function(t,e){O(n,e,t)})};var I="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,k=/^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,M=/^on(Ani|Tra|Tou|BeforeInp|Compo)/,N=/[A-Z0-9]/g,T="undefined"!=typeof document,A=function(n){return("undefined"!=typeof Symbol&&"symbol"==typeof Symbol()?/fil|che|rad/:/fil|che|ra/).test(n)};function D(t,e,r){return null==e.__k&&(e.textContent=""),n.render(t,e),"function"==typeof r&&r(),t?t.__c:null}function L(t,e,r){return n.hydrate(t,e),"function"==typeof r&&r(),t?t.__c:null}n.Component.prototype.isReactComponent=!0,["componentWillMount","componentWillReceiveProps","componentWillUpdate"].forEach(function(t){Object.defineProperty(n.Component.prototype,t,{configurable:!0,get:function(){return this["UNSAFE_"+t]},set:function(n){Object.defineProperty(this,t,{configurable:!0,writable:!0,value:n})}})});var U=n.options.event;n.options.event=function(n){return U&&(n=U(n)),n.persist=function(){},n.isPropagationStopped=function(){return this.cancelBubble},n.isDefaultPrevented=function(){return this.defaultPrevented},n.nativeEvent=n};var F,V={configurable:!0,get:function(){return this.class}},W=n.options.vnode;n.options.vnode=function(t){"string"==typeof t.type&&function(t){var e=t.props,r=t.type,u={},o=-1==r.indexOf("-");for(var i in e){var c=e[i];if(!("value"===i&&"defaultValue"in e&&null==c||T&&"children"===i&&"noscript"===r||"class"===i||"className"===i)){var l=i.toLowerCase();"defaultValue"===i&&"value"in e&&null==e.value?i="value":"download"===i&&!0===c?c="":"translate"===l&&"no"===c?c=!1:"o"===l[0]&&"n"===l[1]?"ondoubleclick"===l?i="ondblclick":"onchange"!==l||"input"!==r&&"textarea"!==r||A(e.type)?"onfocus"===l?i="onfocusin":"onblur"===l?i="onfocusout":M.test(i)&&(i=l):l=i="oninput":o&&k.test(i)?i=i.replace(N,"-$&").toLowerCase():null===c&&(c=void 0),"oninput"===l&&u[i=l]&&(i="oninputCapture"),u[i]=c}}"select"==r&&(u.multiple&&Array.isArray(u.value)&&(u.value=n.toChildArray(e.children).forEach(function(n){n.props.selected=-1!=u.value.indexOf(n.props.value)})),null!=u.defaultValue&&(u.value=n.toChildArray(e.children).forEach(function(n){n.props.selected=u.multiple?-1!=u.defaultValue.indexOf(n.props.value):u.defaultValue==n.props.value}))),e.class&&!e.className?(u.class=e.class,Object.defineProperty(u,"className",V)):e.className&&(u.class=u.className=e.className),t.props=u}(t),t.$$typeof=I,W&&W(t)};var P=n.options.__r;n.options.__r=function(n){P&&P(n),F=n.__c};var z=n.options.diffed;n.options.diffed=function(n){z&&z(n);var t=n.props,e=n.__e;null!=e&&"textarea"===n.type&&"value"in t&&t.value!==e.value&&(e.value=null==t.value?"":t.value),F=null};var B={ReactCurrentDispatcher:{current:{readContext:function(n){return F.__n[n.__c].props.value},useCallback:t.useCallback,useContext:t.useContext,useDebugValue:t.useDebugValue,useDeferredValue:c,useEffect:t.useEffect,useId:t.useId,useImperativeHandle:t.useImperativeHandle,useInsertionEffect:f,useLayoutEffect:t.useLayoutEffect,useMemo:t.useMemo,useReducer:t.useReducer,useRef:t.useRef,useState:t.useState,useSyncExternalStore:u,useTransition:l}}};function H(t){return n.createElement.bind(null,t)}function q(n){return!!n&&n.$$typeof===I}function Z(t){return q(t)&&t.type===n.Fragment}function Y(n){return!!n&&"string"==typeof n.displayName&&0==n.displayName.indexOf("Memo(")}function $(t){return q(t)?n.cloneElement.apply(null,arguments):t}function G(t){return!!t.__k&&(n.render(null,t),!0)}function J(n){return n&&(n.base||1===n.nodeType&&n)||null}var K=function(n,t){return n(t)},Q=function(t,e){var r,u=n.options.debounceRendering;n.options.debounceRendering=function(n){r=n};try{var o=t(e);return r&&r(),o}finally{n.options.debounceRendering=u}},X=q,nn={useState:t.useState,useId:t.useId,useReducer:t.useReducer,useEffect:t.useEffect,useLayoutEffect:t.useLayoutEffect,useInsertionEffect:f,useTransition:l,useDeferredValue:c,useSyncExternalStore:u,startTransition:i,useRef:t.useRef,useImperativeHandle:t.useImperativeHandle,useMemo:t.useMemo,useCallback:t.useCallback,useContext:t.useContext,useDebugValue:t.useDebugValue,version:"18.3.1",Children:m,render:D,hydrate:L,unmountComponentAtNode:G,createPortal:j,createElement:n.createElement,createContext:n.createContext,createFactory:H,cloneElement:$,createRef:n.createRef,Fragment:n.Fragment,isValidElement:q,isElement:X,isFragment:Z,isMemo:Y,findDOMNode:J,Component:n.Component,PureComponent:a,memo:s,forwardRef:h,flushSync:Q,unstable_batchedUpdates:K,StrictMode:n.Fragment,Suspense:g,SuspenseList:C,lazy:E,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:B};Object.defineProperty(exports,"Component",{enumerable:!0,get:function(){return n.Component}}),Object.defineProperty(exports,"Fragment",{enumerable:!0,get:function(){return n.Fragment}}),Object.defineProperty(exports,"StrictMode",{enumerable:!0,get:function(){return n.Fragment}}),Object.defineProperty(exports,"createContext",{enumerable:!0,get:function(){return n.createContext}}),Object.defineProperty(exports,"createElement",{enumerable:!0,get:function(){return n.createElement}}),Object.defineProperty(exports,"createRef",{enumerable:!0,get:function(){return n.createRef}}),exports.Children=m,exports.PureComponent=a,exports.Suspense=g,exports.SuspenseList=C,exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=B,exports.cloneElement=$,exports.createFactory=H,exports.createPortal=j,exports.default=nn,exports.findDOMNode=J,exports.flushSync=Q,exports.forwardRef=h,exports.hydrate=L,exports.isElement=X,exports.isFragment=Z,exports.isMemo=Y,exports.isValidElement=q,exports.lazy=E,exports.memo=s,exports.render=D,exports.startTransition=i,exports.unmountComponentAtNode=G,exports.unstable_batchedUpdates=K,exports.useDeferredValue=c,exports.useInsertionEffect=f,exports.useSyncExternalStore=u,exports.useTransition=l,exports.version="18.3.1",Object.keys(t).forEach(function(n){"default"===n||exports.hasOwnProperty(n)||Object.defineProperty(exports,n,{enumerable:!0,get:function(){return t[n]}})});
	//# sourceMappingURL=compat.js.map


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(12);
	var createDesc = __webpack_require__(29);
	module.exports = __webpack_require__(6) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(5);
	var IE8_DOM_DEFINE = __webpack_require__(52);
	var toPrimitive = __webpack_require__(46);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) return;('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var n,t,r,u,o=__webpack_require__(4),i=0,f=[],c=o.options,e=c.__b,a=c.__r,v=c.diffed,s=c.__c,l=c.unmount,p=c.__;function x(n,r){c.__h&&c.__h(t,n,i||r),i=0;var u=t.__H||(t.__H={__:[],__h:[]});return n>=u.__.length&&u.__.push({}),u.__[n]}function m(n){return i=1,d(b,n)}function d(r,u,o){var i=x(n++,2);if(i.t=r,!i.__c&&(i.__=[o?o(u):b(void 0,u),function(n){var t=i.__N?i.__N[0]:i.__[0],r=i.t(t,n);t!==r&&(i.__N=[r,i.__[1]],i.__c.setState({}))}],i.__c=t,!t.__f)){var f=function(n,t,r){if(!i.__c.__H)return!0;var u=!1,o=i.__c.props!==n;if(i.__c.__H.__.some(function(n){if(n.__N){u=!0;var t=n.__[0];n.__=n.__N,n.__N=void 0,t!==n.__[0]&&(o=!0)}}),c){var f=c.call(this,n,t,r);return u?f||o:f}return!u||o};t.__f=!0;var c=t.shouldComponentUpdate,e=t.componentWillUpdate;t.componentWillUpdate=function(n,t,r){if(this.__e){var u=c;c=void 0,f(n,t,r),c=u}e&&e.call(this,n,t,r)},t.shouldComponentUpdate=f}return i.__N||i.__}function y(r,u){var o=x(n++,4);!c.__s&&P(o.__H,u)&&(o.__=r,o.u=u,t.__h.push(o))}function h(t,r){var u=x(n++,7);return P(u.__H,r)&&(u.__=t(),u.__H=r,u.__h=t),u.__}function _(){for(var n;n=f.shift();){var t=n.__H;if(n.__P&&t)try{t.__h.some(F),t.__h.some(T),t.__h=[]}catch(r){t.__h=[],c.__e(r,n.__v)}}}c.__b=function(n){t=null,e&&e(n)},c.__=function(n,t){n&&t.__k&&t.__k.__m&&(n.__m=t.__k.__m),p&&p(n,t)},c.__r=function(u){a&&a(u),n=0;var o=(t=u.__c).__H;o&&(r===t?(o.__h=[],t.__h=[],o.__.some(function(n){n.__N&&(n.__=n.__N),n.u=n.__N=void 0})):(o.__h.some(F),o.__h.some(T),o.__h=[],n=0)),r=t},c.diffed=function(n){v&&v(n);var o=n.__c;o&&o.__H&&(o.__H.__h.length&&(1!==f.push(o)&&u===c.requestAnimationFrame||((u=c.requestAnimationFrame)||A)(_)),o.__H.__.some(function(n){n.u&&(n.__H=n.u,n.u=void 0)})),r=t=null},c.__c=function(n,t){t.some(function(n){try{n.__h.some(F),n.__h=n.__h.filter(function(n){return!n.__||T(n)})}catch(r){t.some(function(n){n.__h&&(n.__h=[])}),t=[],c.__e(r,n.__v)}}),s&&s(n,t)},c.unmount=function(n){l&&l(n);var t,r=n.__c;r&&r.__H&&(r.__H.__.some(function(n){try{F(n)}catch(n){t=n}}),r.__H=void 0,t&&c.__e(t,r.__v))};var q="function"==typeof requestAnimationFrame;function A(n){var t,r=function(){clearTimeout(u),q&&cancelAnimationFrame(t),setTimeout(n)},u=setTimeout(r,35);q&&(t=requestAnimationFrame(r))}function F(n){var r=t,u=n.__c;"function"==typeof u&&(n.__c=void 0,u()),t=r}function T(n){var r=t;n.__c=n.__(),t=r}function P(n,t){return!n||n.length!==t.length||t.some(function(t,r){return t!==n[r]})}function b(n,t){return"function"==typeof t?t(n):t}exports.useCallback=function(n,t){return i=8,h(function(){return n},t)},exports.useContext=function(r){var u=t.context[r.__c],o=x(n++,9);return o.c=r,u?(null==o.__&&(o.__=!0,u.sub(t)),u.props.value):r.__},exports.useDebugValue=function(n,t){c.useDebugValue&&c.useDebugValue(t?t(n):n)},exports.useEffect=function(r,u){var o=x(n++,3);!c.__s&&P(o.__H,u)&&(o.__=r,o.u=u,t.__H.__h.push(o))},exports.useErrorBoundary=function(r){var u=x(n++,10),o=m();return u.__=r,t.componentDidCatch||(t.componentDidCatch=function(n,t){u.__&&u.__(n,t),o[1](n)}),[o[0],function(){o[1](void 0)}]},exports.useId=function(){var r=x(n++,11);if(!r.__){for(var u=t.__v;null!==u&&!u.__m&&null!==u.__;)u=u.__;var o=u.__m||(u.__m=[0,0]);r.__="P"+o[0]+"-"+o[1]++}return r.__},exports.useImperativeHandle=function(n,t,r){i=6,y(function(){if("function"==typeof n){var r=n(t());return function(){n(null),r&&"function"==typeof r&&r()}}if(n)return n.current=t(),function(){return n.current=null}},null==r?r:r.concat(n))},exports.useLayoutEffect=y,exports.useMemo=h,exports.useReducer=d,exports.useRef=function(n){return i=5,h(function(){return{current:n}},[])},exports.useState=m;
	//# sourceMappingURL=hooks.js.map


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	if (false) {
	  var ReactIs = require('react-is');

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(147)();
	}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(53);
	var defined = __webpack_require__(36);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _promise = __webpack_require__(96);

	var _promise2 = _interopRequireDefault(_promise);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }

	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }

	      return step("next");
	    });
	  };
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(152);


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(26);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _api = __webpack_require__(90);

	Object.keys(_api).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api[key];
	    }
	  });
	});

	var _helpers = __webpack_require__(91);

	Object.keys(_helpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _helpers[key];
	    }
	  });
	});

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _assign = __webpack_require__(93);

	var _assign2 = _interopRequireDefault(_assign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _iterator = __webpack_require__(98);

	var _iterator2 = _interopRequireDefault(_iterator);

	var _symbol = __webpack_require__(97);

	var _symbol2 = _interopRequireDefault(_symbol);

	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') return;(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(57);
	var enumBugKeys = __webpack_require__(38);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(12).f;
	var has = __webpack_require__(10);
	var TAG = __webpack_require__(2)('toStringTag');

	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = compareObjects;
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function compareObjects(objA, objB) {
	  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  if (objA === objB) {
	    return false;
	  }
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	  if (aKeys.length !== bKeys.length) {
	    return true;
	  }
	  var keysMap = {};
	  var i, len;
	  for (i = 0, len = keys.length; i < len; i++) {
	    keysMap[keys[i]] = true;
	  }
	  for (i = 0, len = aKeys.length; i < len; i++) {
	    var key = aKeys[i];
	    var aValue = objA[key];
	    var bValue = objB[key];
	    if (aValue === bValue) {
	      continue;
	    }
	    if (!keysMap[key] || aValue === null || bValue === null || _typeof(aValue) !== 'object' || _typeof(bValue) !== 'object') {
	      return true;
	    }
	    var aValueKeys = Object.keys(aValue);
	    var bValueKeys = Object.keys(bValue);
	    if (aValueKeys.length !== bValueKeys.length) {
	      return true;
	    }
	    for (var n = 0, length = aValueKeys.length; n < length; n++) {
	      var aValueKey = aValueKeys[n];
	      if (aValue[aValueKey] !== bValue[aValueKey]) {
	        return true;
	      }
	    }
	  }
	  return false;
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    return;("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _setPrototypeOf = __webpack_require__(95);

	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

	var _create = __webpack_require__(94);

	var _create2 = _interopRequireDefault(_create);

	var _typeof2 = __webpack_require__(25);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    return;("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }

	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _typeof2 = __webpack_require__(25);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (self, call) {
	  if (!self) {
	    return;("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) return;("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	var document = __webpack_require__(1).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(26);

	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) return;('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}

	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(5);
	var dPs = __webpack_require__(121);
	var enumBugKeys = __webpack_require__(38);
	var IE_PROTO = __webpack_require__(42)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(37)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(51).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(43)('keys');
	var uid = __webpack_require__(31);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(3);
	var global = __webpack_require__(1);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(22) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(36);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(8);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  return;("Can't convert object to primitive value");
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var core = __webpack_require__(3);
	var LIBRARY = __webpack_require__(22);
	var wksExt = __webpack_require__(48);
	var defineProperty = __webpack_require__(12).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(2);


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';

	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};

	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}

	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return Object.propertyIsEnumerable.call(target, symbol)
			})
			: []
	}

	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}

	function propertyIsOnObject(object, property) {
		try {
			return property in object
		} catch(_) {
			return false
		}
	}

	// Protects from prototype poisoning and unexpected merging up the prototype chain.
	function propertyIsUnsafe(target, key) {
		return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
			&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
				&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (propertyIsUnsafe(target, key)) {
				return
			}

			if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			} else {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			}
		});
		return destination
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
		// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
		// implementations can use it. The caller may not replace it.
		options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}

		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};

	var deepmerge_1 = deepmerge;

	module.exports = deepmerge_1;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(18);
	var TAG = __webpack_require__(2)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(1).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(20)(function () {
	  return Object.defineProperty(__webpack_require__(37)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(18);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(22);
	var $export = __webpack_require__(7);
	var redefine = __webpack_require__(60);
	var hide = __webpack_require__(11);
	var Iterators = __webpack_require__(21);
	var $iterCreate = __webpack_require__(115);
	var setToStringTag = __webpack_require__(30);
	var getPrototypeOf = __webpack_require__(123);
	var ITERATOR = __webpack_require__(2)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(28);
	var createDesc = __webpack_require__(29);
	var toIObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(46);
	var has = __webpack_require__(10);
	var IE8_DOM_DEFINE = __webpack_require__(52);
	var gOPD = Object.getOwnPropertyDescriptor;

	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(57);
	var hiddenKeys = __webpack_require__(38).concat('length', 'prototype');

	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(10);
	var toIObject = __webpack_require__(15);
	var arrayIndexOf = __webpack_require__(108)(false);
	var IE_PROTO = __webpack_require__(42)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(39);

	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(11);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(5);
	var aFunction = __webpack_require__(26);
	var SPECIES = __webpack_require__(2)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(19);
	var invoke = __webpack_require__(111);
	var html = __webpack_require__(51);
	var cel = __webpack_require__(37);
	var global = __webpack_require__(1);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(18)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(44);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(127)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(54)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(131);
	var global = __webpack_require__(1);
	var hide = __webpack_require__(11);
	var Iterators = __webpack_require__(21);
	var TO_STRING_TAG = __webpack_require__(2)('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),Y=_.prototype;return O.prototype=Y,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){Y[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	exports.__esModule = true;
	var appleIphone = /iPhone/i;
	var appleIpod = /iPod/i;
	var appleTablet = /iPad/i;
	var appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
	var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
	var androidTablet = /Android/i;
	var amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
	var amazonTablet = /Silk/i;
	var windowsPhone = /Windows Phone/i;
	var windowsTablet = /\bWindows(?:.+)ARM\b/i;
	var otherBlackBerry = /BlackBerry/i;
	var otherBlackBerry10 = /BB10/i;
	var otherOpera = /Opera Mini/i;
	var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
	var otherFirefox = /Mobile(?:.+)Firefox\b/i;
	var isAppleTabletOnIos13 = function (navigator) {
	    return (typeof navigator !== 'undefined' &&
	        navigator.platform === 'MacIntel' &&
	        typeof navigator.maxTouchPoints === 'number' &&
	        navigator.maxTouchPoints > 1 &&
	        typeof MSStream === 'undefined');
	};
	function createMatch(userAgent) {
	    return function (regex) { return regex.test(userAgent); };
	}
	function isMobile(param) {
	    var nav = {
	        userAgent: '',
	        platform: '',
	        maxTouchPoints: 0
	    };
	    if (!param && typeof navigator !== 'undefined') {
	        nav = {
	            userAgent: navigator.userAgent,
	            platform: navigator.platform,
	            maxTouchPoints: navigator.maxTouchPoints || 0
	        };
	    }
	    else if (typeof param === 'string') {
	        nav.userAgent = param;
	    }
	    else if (param && param.userAgent) {
	        nav = {
	            userAgent: param.userAgent,
	            platform: param.platform,
	            maxTouchPoints: param.maxTouchPoints || 0
	        };
	    }
	    var userAgent = nav.userAgent;
	    var tmp = userAgent.split('[FBAN');
	    if (typeof tmp[1] !== 'undefined') {
	        userAgent = tmp[0];
	    }
	    tmp = userAgent.split('Twitter');
	    if (typeof tmp[1] !== 'undefined') {
	        userAgent = tmp[0];
	    }
	    var match = createMatch(userAgent);
	    var result = {
	        apple: {
	            phone: match(appleIphone) && !match(windowsPhone),
	            ipod: match(appleIpod),
	            tablet: !match(appleIphone) &&
	                (match(appleTablet) || isAppleTabletOnIos13(nav)) &&
	                !match(windowsPhone),
	            universal: match(appleUniversal),
	            device: (match(appleIphone) ||
	                match(appleIpod) ||
	                match(appleTablet) ||
	                match(appleUniversal) ||
	                isAppleTabletOnIos13(nav)) &&
	                !match(windowsPhone)
	        },
	        amazon: {
	            phone: match(amazonPhone),
	            tablet: !match(amazonPhone) && match(amazonTablet),
	            device: match(amazonPhone) || match(amazonTablet)
	        },
	        android: {
	            phone: (!match(windowsPhone) && match(amazonPhone)) ||
	                (!match(windowsPhone) && match(androidPhone)),
	            tablet: !match(windowsPhone) &&
	                !match(amazonPhone) &&
	                !match(androidPhone) &&
	                (match(amazonTablet) || match(androidTablet)),
	            device: (!match(windowsPhone) &&
	                (match(amazonPhone) ||
	                    match(amazonTablet) ||
	                    match(androidPhone) ||
	                    match(androidTablet))) ||
	                match(/\bokhttp\b/i)
	        },
	        windows: {
	            phone: match(windowsPhone),
	            tablet: match(windowsTablet),
	            device: match(windowsPhone) || match(windowsTablet)
	        },
	        other: {
	            blackberry: match(otherBlackBerry),
	            blackberry10: match(otherBlackBerry10),
	            opera: match(otherOpera),
	            firefox: match(otherFirefox),
	            chrome: match(otherChrome),
	            device: match(otherBlackBerry) ||
	                match(otherBlackBerry10) ||
	                match(otherOpera) ||
	                match(otherFirefox) ||
	                match(otherChrome)
	        },
	        any: false,
	        phone: false,
	        tablet: false
	    };
	    result.any =
	        result.apple.device ||
	            result.android.device ||
	            result.windows.device ||
	            result.other.device;
	    result.phone =
	        result.apple.phone || result.android.phone || result.windows.phone;
	    result.tablet =
	        result.apple.tablet || result.android.tablet || result.windows.tablet;
	    return result;
	}
	exports["default"] = isMobile;
	//# sourceMappingURL=isMobile.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = {"en":{"departureAirportLabel":"Select Departure Airport","departureAirportError":"Please choose a departure airport.","departureAirportPlaceholder":"Search by name or IATA code","arrivalAirportLabel":"Select Arrival Airport","arrivalAirportError":"Please choose an arrival airport.","arrivalAirportPlaceholder":"Search by name or IATA code","dateSelectionLabel":"When are you travelling?","outboundDateError":"Please pick a departure date.","inboundDateError":"Please pick a return date.","calendarLabels":{"months":{"January":"January","February":"February","March":"March","April":"April","May":"May","June":"June","July":"July","August":"August","September":"September","October":"October","November":"November","December":"December"},"days":{"Sun":"Sun","Mon":"Mon","Tue":"Tue","Wed":"Wed","Thu":"Thu","Fri":"Fri","Sat":"Sat"},"outBoundPlaceholder":"Outbound","inBoundPlaceholder":"Inbound","selectionIndicator":"Selecting","close":"Done","soldOut":"Sold Out"},"tripTypeLabel":"Travelling","onewayName":"One way","roundtripName":"Round trip","multicityName":"Multi-City","passengersLabel":"Who's travelling?","passengersPlaceholder":"Select passengers","passengersCountSingular":"Passenger","passengersCountPlural":"Passengers","passengersTypeLabels":{"ADT":"Adults","CHD":"Children","INF":"Infants"},"passengersTypeDescriptions":{"ADT":"16 — 65 Years","CHD":"2 — 16 Years","INF":"0 — 2 Years"},"passengersTypeCloseButton":"Done","cabinClassLabel":"Service Class","cabinClassAllClassesOption":"","currenciesLabel":"Select your currency","promocodeLabel":"Have a promocode?","promocodePlaceholder":"","travelQuestionLabel":"Traveling for Business?","searchButtonName":"Search →","tabs":{"flight-search-tab":{"tabLabel":"Flights"}}}}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(9));
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	var _arrays = _interopRequireDefault(__webpack_require__(156));
	var _Autowhatever = _interopRequireDefault(__webpack_require__(73));
	var _theme = __webpack_require__(78);
	function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
	function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _classCallCheck(a, n) { if (!(a instanceof n)) return;("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) return;("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) return;("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) return;("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; return;("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
	  return value.trim().length > 0;
	};
	var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	    children = _ref.children;
	  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
	};
	var Autosuggest = exports["default"] = /*#__PURE__*/function (_Component) {
	  function Autosuggest(_ref2) {
	    var _this;
	    var _alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;
	    _classCallCheck(this, Autosuggest);
	    _this = _callSuper(this, Autosuggest);
	    _defineProperty(_this, "onDocumentMouseDown", function (event) {
	      _this.justClickedOnSuggestionsContainer = false;
	      var node = event.detail && event.detail.target ||
	      // This is for testing only. Please show me a better way to emulate this.
	      event.target;
	      while (node !== null && node !== document) {
	        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
	          // Suggestion was clicked
	          return;
	        }
	        if (node === _this.suggestionsContainer) {
	          // Something else inside suggestions container was clicked
	          _this.justClickedOnSuggestionsContainer = true;
	          return;
	        }
	        node = node.parentNode;
	      }
	    });
	    _defineProperty(_this, "storeAutowhateverRef", function (autowhatever) {
	      if (autowhatever !== null) {
	        _this.autowhatever = autowhatever;
	      }
	    });
	    _defineProperty(_this, "onSuggestionMouseEnter", function (event, _ref3) {
	      var sectionIndex = _ref3.sectionIndex,
	        itemIndex = _ref3.itemIndex;
	      _this.updateHighlightedSuggestion(sectionIndex, itemIndex);
	      if (event.target === _this.pressedSuggestion) {
	        _this.justSelectedSuggestion = true;
	      }
	      _this.justMouseEntered = true;
	      setTimeout(function () {
	        _this.justMouseEntered = false;
	      });
	    });
	    _defineProperty(_this, "highlightFirstSuggestion", function () {
	      _this.updateHighlightedSuggestion(_this.props.multiSection ? 0 : null, 0);
	    });
	    _defineProperty(_this, "onDocumentMouseUp", function () {
	      if (_this.pressedSuggestion && !_this.justSelectedSuggestion) {
	        _this.input.focus();
	      }
	      _this.pressedSuggestion = null;
	    });
	    _defineProperty(_this, "onSuggestionMouseDown", function (event) {
	      // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
	      // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
	      if (!_this.justSelectedSuggestion) {
	        _this.justSelectedSuggestion = true;
	        _this.pressedSuggestion = event.target;
	      }
	    });
	    _defineProperty(_this, "onSuggestionsClearRequested", function () {
	      var onSuggestionsClearRequested = _this.props.onSuggestionsClearRequested;
	      onSuggestionsClearRequested && onSuggestionsClearRequested();
	    });
	    _defineProperty(_this, "onSuggestionSelected", function (event, data) {
	      var _this$props = _this.props,
	        alwaysRenderSuggestions = _this$props.alwaysRenderSuggestions,
	        onSuggestionSelected = _this$props.onSuggestionSelected,
	        onSuggestionsFetchRequested = _this$props.onSuggestionsFetchRequested;
	      onSuggestionSelected && onSuggestionSelected(event, data);
	      if (alwaysRenderSuggestions) {
	        onSuggestionsFetchRequested({
	          value: data.suggestionValue,
	          reason: 'suggestion-selected'
	        });
	      } else {
	        _this.onSuggestionsClearRequested();
	      }
	      _this.resetHighlightedSuggestion();
	    });
	    _defineProperty(_this, "onSuggestionClick", function (event) {
	      var _this$props2 = _this.props,
	        alwaysRenderSuggestions = _this$props2.alwaysRenderSuggestions,
	        focusInputOnSuggestionClick = _this$props2.focusInputOnSuggestionClick;
	      var _this$getSuggestionIn = _this.getSuggestionIndices(_this.findSuggestionElement(event.target)),
	        sectionIndex = _this$getSuggestionIn.sectionIndex,
	        suggestionIndex = _this$getSuggestionIn.suggestionIndex;
	      var clickedSuggestion = _this.getSuggestion(sectionIndex, suggestionIndex);
	      var clickedSuggestionValue = _this.props.getSuggestionValue(clickedSuggestion);
	      _this.maybeCallOnChange(event, clickedSuggestionValue, 'click');
	      _this.onSuggestionSelected(event, {
	        suggestion: clickedSuggestion,
	        suggestionValue: clickedSuggestionValue,
	        suggestionIndex: suggestionIndex,
	        sectionIndex: sectionIndex,
	        method: 'click'
	      });
	      if (!alwaysRenderSuggestions) {
	        _this.closeSuggestions();
	      }
	      if (focusInputOnSuggestionClick === true) {
	        _this.input.focus();
	      } else {
	        _this.onBlur();
	      }
	      setTimeout(function () {
	        _this.justSelectedSuggestion = false;
	      });
	    });
	    _defineProperty(_this, "onBlur", function () {
	      var _this$props3 = _this.props,
	        inputProps = _this$props3.inputProps,
	        shouldRenderSuggestions = _this$props3.shouldRenderSuggestions;
	      var value = inputProps.value,
	        onBlur = inputProps.onBlur;
	      var highlightedSuggestion = _this.getHighlightedSuggestion();
	      var shouldRender = shouldRenderSuggestions(value);
	      _this.setState({
	        isFocused: false,
	        highlightedSectionIndex: null,
	        highlightedSuggestionIndex: null,
	        highlightedSuggestion: null,
	        valueBeforeUpDown: null,
	        isCollapsed: !shouldRender
	      });
	      onBlur && onBlur(_this.blurEvent, {
	        highlightedSuggestion: highlightedSuggestion
	      });
	    });
	    _defineProperty(_this, "onSuggestionMouseLeave", function (event) {
	      _this.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown

	      if (_this.justSelectedSuggestion && event.target === _this.pressedSuggestion) {
	        _this.justSelectedSuggestion = false;
	      }
	    });
	    _defineProperty(_this, "onSuggestionTouchStart", function () {
	      _this.justSelectedSuggestion = true;
	      // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
	      // todo: gets released so onSuggestionMouseDown won't fire in chrome
	    });
	    _defineProperty(_this, "onSuggestionTouchMove", function () {
	      _this.justSelectedSuggestion = false;
	      _this.pressedSuggestion = null;
	      _this.input.focus();
	    });
	    _defineProperty(_this, "itemProps", function (_ref4) {
	      var sectionIndex = _ref4.sectionIndex,
	        itemIndex = _ref4.itemIndex;
	      return {
	        'data-section-index': sectionIndex,
	        'data-suggestion-index': itemIndex,
	        onMouseEnter: _this.onSuggestionMouseEnter,
	        onMouseLeave: _this.onSuggestionMouseLeave,
	        onMouseDown: _this.onSuggestionMouseDown,
	        onTouchStart: _this.onSuggestionTouchStart,
	        onTouchMove: _this.onSuggestionTouchMove,
	        onClick: _this.onSuggestionClick
	      };
	    });
	    _defineProperty(_this, "renderSuggestionsContainer", function (_ref5) {
	      var containerProps = _ref5.containerProps,
	        children = _ref5.children;
	      var renderSuggestionsContainer = _this.props.renderSuggestionsContainer;
	      return renderSuggestionsContainer({
	        containerProps: containerProps,
	        children: children,
	        query: _this.getQuery()
	      });
	    });
	    _this.state = {
	      isFocused: false,
	      isCollapsed: !_alwaysRenderSuggestions,
	      highlightedSectionIndex: null,
	      highlightedSuggestionIndex: null,
	      highlightedSuggestion: null,
	      valueBeforeUpDown: null
	    };
	    _this.justPressedUpDown = false;
	    _this.justMouseEntered = false;
	    _this.pressedSuggestion = null;
	    return _this;
	  }
	  _inherits(Autosuggest, _Component);
	  return _createClass(Autosuggest, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.onDocumentMouseDown);
	      document.addEventListener('mouseup', this.onDocumentMouseUp);
	      this.input = this.autowhatever.input;
	      this.suggestionsContainer = this.autowhatever.itemsContainer;
	    }

	    // eslint-disable-next-line camelcase, react/sort-comp
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if ((0, _arrays["default"])(nextProps.suggestions, this.props.suggestions)) {
	        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
	          this.highlightFirstSuggestion();
	        }
	      } else {
	        if (this.willRenderSuggestions(nextProps)) {
	          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
	            this.revealSuggestions();
	          }
	        } else {
	          this.resetHighlightedSuggestion();
	        }
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this$props4 = this.props,
	        suggestions = _this$props4.suggestions,
	        onSuggestionHighlighted = _this$props4.onSuggestionHighlighted,
	        highlightFirstSuggestion = _this$props4.highlightFirstSuggestion;
	      if (!(0, _arrays["default"])(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
	        this.highlightFirstSuggestion();
	        return;
	      }
	      if (onSuggestionHighlighted) {
	        var highlightedSuggestion = this.getHighlightedSuggestion();
	        var prevHighlightedSuggestion = prevState.highlightedSuggestion;
	        if (highlightedSuggestion != prevHighlightedSuggestion) {
	          onSuggestionHighlighted({
	            suggestion: highlightedSuggestion
	          });
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.onDocumentMouseDown);
	      document.removeEventListener('mouseup', this.onDocumentMouseUp);
	    }
	  }, {
	    key: "updateHighlightedSuggestion",
	    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
	      var _this2 = this;
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	        if (suggestionIndex === null) {
	          valueBeforeUpDown = null;
	        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
	          valueBeforeUpDown = prevValue;
	        }
	        return {
	          highlightedSectionIndex: sectionIndex,
	          highlightedSuggestionIndex: suggestionIndex,
	          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
	          valueBeforeUpDown: valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: "resetHighlightedSuggestion",
	    value: function resetHighlightedSuggestion() {
	      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	        return {
	          highlightedSectionIndex: null,
	          highlightedSuggestionIndex: null,
	          highlightedSuggestion: null,
	          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: "revealSuggestions",
	    value: function revealSuggestions() {
	      this.setState({
	        isCollapsed: false
	      });
	    }
	  }, {
	    key: "closeSuggestions",
	    value: function closeSuggestions() {
	      this.setState({
	        highlightedSectionIndex: null,
	        highlightedSuggestionIndex: null,
	        highlightedSuggestion: null,
	        valueBeforeUpDown: null,
	        isCollapsed: true
	      });
	    }
	  }, {
	    key: "getSuggestion",
	    value: function getSuggestion(sectionIndex, suggestionIndex) {
	      var _this$props5 = this.props,
	        suggestions = _this$props5.suggestions,
	        multiSection = _this$props5.multiSection,
	        getSectionSuggestions = _this$props5.getSectionSuggestions;
	      if (multiSection) {
	        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
	      }
	      return suggestions[suggestionIndex];
	    }
	  }, {
	    key: "getHighlightedSuggestion",
	    value: function getHighlightedSuggestion() {
	      var _this$state = this.state,
	        highlightedSectionIndex = _this$state.highlightedSectionIndex,
	        highlightedSuggestionIndex = _this$state.highlightedSuggestionIndex;
	      if (highlightedSuggestionIndex === null) {
	        return null;
	      }
	      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
	    }
	  }, {
	    key: "getSuggestionValueByIndex",
	    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
	      var getSuggestionValue = this.props.getSuggestionValue;
	      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
	    }
	  }, {
	    key: "getSuggestionIndices",
	    value: function getSuggestionIndices(suggestionElement) {
	      var sectionIndex = suggestionElement.getAttribute('data-section-index');
	      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
	      return {
	        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
	        suggestionIndex: parseInt(suggestionIndex, 10)
	      };
	    }
	  }, {
	    key: "findSuggestionElement",
	    value: function findSuggestionElement(startNode) {
	      var node = startNode;
	      do {
	        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
	          return node;
	        }
	        node = node.parentNode;
	      } while (node !== null);
	      console.error('Clicked element:', startNode); // eslint-disable-line no-console
	      throw new Error("Couldn't find suggestion element");
	    }
	  }, {
	    key: "maybeCallOnChange",
	    value: function maybeCallOnChange(event, newValue, method) {
	      var _this$props$inputProp = this.props.inputProps,
	        value = _this$props$inputProp.value,
	        onChange = _this$props$inputProp.onChange;
	      if (newValue !== value) {
	        onChange(event, {
	          newValue: newValue,
	          method: method
	        });
	      }
	    }
	  }, {
	    key: "willRenderSuggestions",
	    value: function willRenderSuggestions(props) {
	      var suggestions = props.suggestions,
	        inputProps = props.inputProps,
	        shouldRenderSuggestions = props.shouldRenderSuggestions;
	      var value = inputProps.value;
	      return suggestions.length > 0 && shouldRenderSuggestions(value);
	    }
	  }, {
	    key: "getQuery",
	    value: function getQuery() {
	      var inputProps = this.props.inputProps;
	      var value = inputProps.value;
	      var valueBeforeUpDown = this.state.valueBeforeUpDown;
	      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	      var _this$props6 = this.props,
	        suggestions = _this$props6.suggestions,
	        renderInputComponent = _this$props6.renderInputComponent,
	        onSuggestionsFetchRequested = _this$props6.onSuggestionsFetchRequested,
	        renderSuggestion = _this$props6.renderSuggestion,
	        inputProps = _this$props6.inputProps,
	        multiSection = _this$props6.multiSection,
	        renderSectionTitle = _this$props6.renderSectionTitle,
	        id = _this$props6.id,
	        getSectionSuggestions = _this$props6.getSectionSuggestions,
	        theme = _this$props6.theme,
	        getSuggestionValue = _this$props6.getSuggestionValue,
	        alwaysRenderSuggestions = _this$props6.alwaysRenderSuggestions,
	        highlightFirstSuggestion = _this$props6.highlightFirstSuggestion;
	      var _this$state2 = this.state,
	        isFocused = _this$state2.isFocused,
	        isCollapsed = _this$state2.isCollapsed,
	        highlightedSectionIndex = _this$state2.highlightedSectionIndex,
	        highlightedSuggestionIndex = _this$state2.highlightedSuggestionIndex,
	        valueBeforeUpDown = _this$state2.valueBeforeUpDown;
	      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
	      var value = inputProps.value,
	        _onFocus = inputProps.onFocus,
	        _onKeyDown = inputProps.onKeyDown;
	      var willRenderSuggestions = this.willRenderSuggestions(this.props);
	      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
	      var items = isOpen ? suggestions : [];
	      var autowhateverInputProps = _objectSpread(_objectSpread({}, inputProps), {}, {
	        onFocus: function onFocus(event) {
	          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
	            var shouldRender = shouldRenderSuggestions(value);
	            _this3.setState({
	              isFocused: true,
	              isCollapsed: !shouldRender
	            });
	            _onFocus && _onFocus(event);
	            if (shouldRender) {
	              onSuggestionsFetchRequested({
	                value: value,
	                reason: 'input-focused'
	              });
	            }
	          }
	        },
	        onBlur: function onBlur(event) {
	          if (_this3.justClickedOnSuggestionsContainer) {
	            _this3.input.focus();
	            return;
	          }
	          _this3.blurEvent = event;
	          if (!_this3.justSelectedSuggestion) {
	            _this3.onBlur();
	            _this3.onSuggestionsClearRequested();
	          }
	        },
	        onChange: function onChange(event) {
	          var value = event.target.value;
	          var shouldRender = shouldRenderSuggestions(value);
	          _this3.maybeCallOnChange(event, value, 'type');
	          if (_this3.suggestionsContainer) {
	            _this3.suggestionsContainer.scrollTop = 0;
	          }
	          _this3.setState(_objectSpread(_objectSpread({}, highlightFirstSuggestion ? {} : {
	            highlightedSectionIndex: null,
	            highlightedSuggestionIndex: null,
	            highlightedSuggestion: null
	          }), {}, {
	            valueBeforeUpDown: null,
	            isCollapsed: !shouldRender
	          }));
	          if (shouldRender) {
	            onSuggestionsFetchRequested({
	              value: value,
	              reason: 'input-changed'
	            });
	          } else {
	            _this3.onSuggestionsClearRequested();
	          }
	        },
	        onKeyDown: function onKeyDown(event, data) {
	          var keyCode = event.keyCode;
	          switch (keyCode) {
	            case 40: // ArrowDown
	            case 38:
	              // ArrowUp
	              if (isCollapsed) {
	                if (shouldRenderSuggestions(value)) {
	                  onSuggestionsFetchRequested({
	                    value: value,
	                    reason: 'suggestions-revealed'
	                  });
	                  _this3.revealSuggestions();
	                }
	              } else if (suggestions.length > 0) {
	                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
	                  newHighlightedItemIndex = data.newHighlightedItemIndex;
	                var newValue;
	                if (newHighlightedItemIndex === null) {
	                  // valueBeforeUpDown can be null if, for example, user
	                  // hovers on the first suggestion and then pressed Up.
	                  // If that happens, use the original input value.
	                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
	                } else {
	                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
	                }
	                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
	                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
	              }
	              event.preventDefault(); // Prevents the cursor from moving

	              _this3.justPressedUpDown = true;
	              setTimeout(function () {
	                _this3.justPressedUpDown = false;
	              });
	              break;

	            // Enter
	            case 13:
	              {
	                // See #388
	                if (event.keyCode === 229) {
	                  break;
	                }
	                var highlightedSuggestion = _this3.getHighlightedSuggestion();
	                if (isOpen && !alwaysRenderSuggestions) {
	                  _this3.closeSuggestions();
	                }
	                if (highlightedSuggestion != null) {
	                  var _newValue = getSuggestionValue(highlightedSuggestion);
	                  _this3.maybeCallOnChange(event, _newValue, 'enter');
	                  _this3.onSuggestionSelected(event, {
	                    suggestion: highlightedSuggestion,
	                    suggestionValue: _newValue,
	                    suggestionIndex: highlightedSuggestionIndex,
	                    sectionIndex: highlightedSectionIndex,
	                    method: 'enter'
	                  });
	                  _this3.justSelectedSuggestion = true;
	                  setTimeout(function () {
	                    _this3.justSelectedSuggestion = false;
	                  });
	                }
	                break;
	              }

	            // Escape
	            case 27:
	              {
	                if (isOpen) {
	                  // If input.type === 'search', the browser clears the input
	                  // when Escape is pressed. We want to disable this default
	                  // behaviour so that, when suggestions are shown, we just hide
	                  // them, without clearing the input.
	                  event.preventDefault();
	                }
	                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
	                if (valueBeforeUpDown === null) {
	                  // Didn't interact with Up/Down
	                  if (!willCloseSuggestions) {
	                    var _newValue2 = '';
	                    _this3.maybeCallOnChange(event, _newValue2, 'escape');
	                    if (shouldRenderSuggestions(_newValue2)) {
	                      onSuggestionsFetchRequested({
	                        value: _newValue2,
	                        reason: 'escape-pressed'
	                      });
	                    } else {
	                      _this3.onSuggestionsClearRequested();
	                    }
	                  }
	                } else {
	                  // Interacted with Up/Down
	                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
	                }
	                if (willCloseSuggestions) {
	                  _this3.onSuggestionsClearRequested();
	                  _this3.closeSuggestions();
	                } else {
	                  _this3.resetHighlightedSuggestion();
	                }
	                break;
	              }
	          }
	          _onKeyDown && _onKeyDown(event);
	        }
	      });
	      var renderSuggestionData = {
	        query: this.getQuery()
	      };
	      return /*#__PURE__*/_react["default"].createElement(_Autowhatever["default"], {
	        multiSection: multiSection,
	        items: items,
	        renderInputComponent: renderInputComponent,
	        renderItemsContainer: this.renderSuggestionsContainer,
	        renderItem: renderSuggestion,
	        renderItemData: renderSuggestionData,
	        renderSectionTitle: renderSectionTitle,
	        getSectionItems: getSectionSuggestions,
	        highlightedSectionIndex: highlightedSectionIndex,
	        highlightedItemIndex: highlightedSuggestionIndex,
	        inputProps: autowhateverInputProps,
	        itemProps: this.itemProps,
	        theme: (0, _theme.mapToAutowhateverTheme)(theme),
	        id: id,
	        ref: this.storeAutowhateverRef
	      });
	    }
	  }]);
	}(_react.Component);
	_defineProperty(Autosuggest, "propTypes", {
	  suggestions: _propTypes["default"].array.isRequired,
	  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
	    var onSuggestionsFetchRequested = props[propName];
	    if (typeof onSuggestionsFetchRequested !== 'function') {
	      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
	    }
	  },
	  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
	    var onSuggestionsClearRequested = props[propName];
	    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
	      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
	    }
	  },
	  onSuggestionSelected: _propTypes["default"].func,
	  onSuggestionHighlighted: _propTypes["default"].func,
	  renderInputComponent: _propTypes["default"].func,
	  renderSuggestionsContainer: _propTypes["default"].func,
	  getSuggestionValue: _propTypes["default"].func.isRequired,
	  renderSuggestion: _propTypes["default"].func.isRequired,
	  inputProps: function inputProps(props, propName) {
	    var inputProps = props[propName];
	    if (!Object.prototype.hasOwnProperty.call(inputProps, 'value')) {
	      throw new Error("'inputProps' must have 'value'.");
	    }
	    if (!Object.prototype.hasOwnProperty.call(inputProps, 'onChange')) {
	      throw new Error("'inputProps' must have 'onChange'.");
	    }
	  },
	  shouldRenderSuggestions: _propTypes["default"].func,
	  alwaysRenderSuggestions: _propTypes["default"].bool,
	  multiSection: _propTypes["default"].bool,
	  renderSectionTitle: function renderSectionTitle(props, propName) {
	    var renderSectionTitle = props[propName];
	    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
	      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
	    }
	  },
	  getSectionSuggestions: function getSectionSuggestions(props, propName) {
	    var getSectionSuggestions = props[propName];
	    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
	      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
	    }
	  },
	  focusInputOnSuggestionClick: _propTypes["default"].bool,
	  highlightFirstSuggestion: _propTypes["default"].bool,
	  theme: _propTypes["default"].object,
	  id: _propTypes["default"].string
	});
	_defineProperty(Autosuggest, "defaultProps", {
	  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
	  shouldRenderSuggestions: defaultShouldRenderSuggestions,
	  alwaysRenderSuggestions: false,
	  multiSection: false,
	  focusInputOnSuggestionClick: true,
	  highlightFirstSuggestion: false,
	  theme: _theme.defaultTheme,
	  id: '1'
	});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(9));
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	var _sectionIterator = _interopRequireDefault(__webpack_require__(155));
	var _reactThemeable = _interopRequireDefault(__webpack_require__(151));
	var _SectionTitle = _interopRequireDefault(__webpack_require__(76));
	var _ItemList = _interopRequireDefault(__webpack_require__(75));
	function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
	function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
	function _nonIterableRest() { return;("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
	function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _classCallCheck(a, n) { if (!(a instanceof n)) return;("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) return;("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) return;("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) return;("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; return;("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	var emptyObject = {};
	var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
	  return /*#__PURE__*/_react["default"].createElement("input", props);
	};
	var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	    children = _ref.children;
	  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
	};
	var defaultTheme = {
	  container: 'react-autowhatever__container',
	  containerOpen: 'react-autowhatever__container--open',
	  input: 'react-autowhatever__input',
	  inputOpen: 'react-autowhatever__input--open',
	  inputFocused: 'react-autowhatever__input--focused',
	  itemsContainer: 'react-autowhatever__items-container',
	  itemsContainerOpen: 'react-autowhatever__items-container--open',
	  itemsList: 'react-autowhatever__items-list',
	  item: 'react-autowhatever__item',
	  itemFirst: 'react-autowhatever__item--first',
	  itemHighlighted: 'react-autowhatever__item--highlighted',
	  sectionContainer: 'react-autowhatever__section-container',
	  sectionContainerFirst: 'react-autowhatever__section-container--first',
	  sectionTitle: 'react-autowhatever__section-title'
	};
	var Autowhatever = exports["default"] = /*#__PURE__*/function (_Component) {
	  function Autowhatever(props) {
	    var _this;
	    _classCallCheck(this, Autowhatever);
	    _this = _callSuper(this, Autowhatever, [props]);
	    _defineProperty(_this, "storeInputReference", function (input) {
	      if (input !== null) {
	        _this.input = input;
	      }
	      var userRef = _this.props.inputProps.ref;
	      if (userRef) {
	        if (typeof userRef === 'function') {
	          userRef(input);
	        } else if (_typeof(userRef) === 'object' && Object.prototype.hasOwnProperty.call(userRef, 'current')) {
	          userRef.current = input;
	        }
	      }
	    });
	    _defineProperty(_this, "storeItemsContainerReference", function (itemsContainer) {
	      if (itemsContainer !== null) {
	        _this.itemsContainer = itemsContainer;
	      }
	    });
	    _defineProperty(_this, "onHighlightedItemChange", function (highlightedItem) {
	      _this.highlightedItem = highlightedItem;
	    });
	    _defineProperty(_this, "getItemId", function (sectionIndex, itemIndex) {
	      if (itemIndex === null) {
	        return null;
	      }
	      var id = _this.props.id;
	      var section = sectionIndex === null ? '' : "section-".concat(sectionIndex);
	      return "react-autowhatever-".concat(id, "-").concat(section, "-item-").concat(itemIndex);
	    });
	    _defineProperty(_this, "onFocus", function (event) {
	      var inputProps = _this.props.inputProps;
	      _this.setState({
	        isInputFocused: true
	      });
	      inputProps.onFocus && inputProps.onFocus(event);
	    });
	    _defineProperty(_this, "onBlur", function (event) {
	      var inputProps = _this.props.inputProps;
	      _this.setState({
	        isInputFocused: false
	      });
	      inputProps.onBlur && inputProps.onBlur(event);
	    });
	    _defineProperty(_this, "onKeyDown", function (event) {
	      var _this$props = _this.props,
	        inputProps = _this$props.inputProps,
	        highlightedSectionIndex = _this$props.highlightedSectionIndex,
	        highlightedItemIndex = _this$props.highlightedItemIndex;
	      switch (event.key) {
	        case 'ArrowDown':
	        case 'ArrowUp':
	          {
	            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';
	            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
	              _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
	              newHighlightedSectionIndex = _this$sectionIterator2[0],
	              newHighlightedItemIndex = _this$sectionIterator2[1];
	            inputProps.onKeyDown(event, {
	              newHighlightedSectionIndex: newHighlightedSectionIndex,
	              newHighlightedItemIndex: newHighlightedItemIndex
	            });
	            break;
	          }
	        default:
	          inputProps.onKeyDown(event, {
	            highlightedSectionIndex: highlightedSectionIndex,
	            highlightedItemIndex: highlightedItemIndex
	          });
	      }
	    });
	    _this.highlightedItem = null;
	    _this.state = {
	      isInputFocused: false
	    };
	    _this.setSectionsItems(props);
	    _this.setSectionIterator(props);
	    _this.setTheme(props);
	    return _this;
	  }
	  _inherits(Autowhatever, _Component);
	  return _createClass(Autowhatever, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ensureHighlightedItemIsVisible();
	    }

	    // eslint-disable-next-line camelcase, react/sort-comp
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (nextProps.items !== this.props.items) {
	        this.setSectionsItems(nextProps);
	      }
	      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
	        this.setSectionIterator(nextProps);
	      }
	      if (nextProps.theme !== this.props.theme) {
	        this.setTheme(nextProps);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.ensureHighlightedItemIsVisible();
	    }
	  }, {
	    key: "setSectionsItems",
	    value: function setSectionsItems(props) {
	      if (props.multiSection) {
	        this.sectionsItems = props.items.map(function (section) {
	          return props.getSectionItems(section);
	        });
	        this.sectionsLengths = this.sectionsItems.map(function (items) {
	          return items.length;
	        });
	        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
	          return itemsCount === 0;
	        });
	      }
	    }
	  }, {
	    key: "setSectionIterator",
	    value: function setSectionIterator(props) {
	      this.sectionIterator = (0, _sectionIterator["default"])({
	        multiSection: props.multiSection,
	        data: props.multiSection ? this.sectionsLengths : props.items.length
	      });
	    }
	  }, {
	    key: "setTheme",
	    value: function setTheme(props) {
	      this.theme = (0, _reactThemeable["default"])(props.theme);
	    }
	  }, {
	    key: "renderSections",
	    value: function renderSections() {
	      var _this2 = this;
	      if (this.allSectionsAreEmpty) {
	        return null;
	      }
	      var theme = this.theme;
	      var _this$props2 = this.props,
	        id = _this$props2.id,
	        items = _this$props2.items,
	        renderItem = _this$props2.renderItem,
	        renderItemData = _this$props2.renderItemData,
	        renderSectionTitle = _this$props2.renderSectionTitle,
	        highlightedSectionIndex = _this$props2.highlightedSectionIndex,
	        highlightedItemIndex = _this$props2.highlightedItemIndex,
	        itemProps = _this$props2.itemProps;
	      return items.map(function (section, sectionIndex) {
	        var keyPrefix = "react-autowhatever-".concat(id, "-");
	        var sectionKeyPrefix = "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
	        var isFirstSection = sectionIndex === 0;

	        // `key` is provided by theme()
	        /* eslint-disable react/jsx-key */
	        return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "container"), 'sectionContainer', isFirstSection && 'sectionContainerFirst'), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
	          section: section,
	          renderSectionTitle: renderSectionTitle,
	          theme: theme,
	          sectionKeyPrefix: sectionKeyPrefix
	        }), /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
	          items: _this2.sectionsItems[sectionIndex],
	          itemProps: itemProps,
	          renderItem: renderItem,
	          renderItemData: renderItemData,
	          sectionIndex: sectionIndex,
	          highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
	          onHighlightedItemChange: _this2.onHighlightedItemChange,
	          getItemId: _this2.getItemId,
	          theme: theme,
	          keyPrefix: keyPrefix,
	          ref: _this2.storeItemsListReference
	        }));
	        /* eslint-enable react/jsx-key */
	      });
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var items = this.props.items;
	      if (items.length === 0) {
	        return null;
	      }
	      var theme = this.theme;
	      var _this$props3 = this.props,
	        id = _this$props3.id,
	        renderItem = _this$props3.renderItem,
	        renderItemData = _this$props3.renderItemData,
	        highlightedSectionIndex = _this$props3.highlightedSectionIndex,
	        highlightedItemIndex = _this$props3.highlightedItemIndex,
	        itemProps = _this$props3.itemProps;
	      return /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
	        items: items,
	        itemProps: itemProps,
	        renderItem: renderItem,
	        renderItemData: renderItemData,
	        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
	        onHighlightedItemChange: this.onHighlightedItemChange,
	        getItemId: this.getItemId,
	        theme: theme,
	        keyPrefix: "react-autowhatever-".concat(id, "-")
	      });
	    }
	  }, {
	    key: "ensureHighlightedItemIsVisible",
	    value: function ensureHighlightedItemIsVisible() {
	      var highlightedItem = this.highlightedItem;
	      if (!highlightedItem) {
	        return;
	      }
	      var itemsContainer = this.itemsContainer;
	      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
	      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

	      if (itemOffsetRelativeToContainer < scrollTop) {
	        // Item is off the top of the visible area
	        scrollTop = itemOffsetRelativeToContainer;
	      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
	        // Item is off the bottom of the visible area
	        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
	      }
	      if (scrollTop !== itemsContainer.scrollTop) {
	        itemsContainer.scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var theme = this.theme;
	      var _this$props4 = this.props,
	        id = _this$props4.id,
	        multiSection = _this$props4.multiSection,
	        renderInputComponent = _this$props4.renderInputComponent,
	        renderItemsContainer = _this$props4.renderItemsContainer,
	        highlightedSectionIndex = _this$props4.highlightedSectionIndex,
	        highlightedItemIndex = _this$props4.highlightedItemIndex;
	      var isInputFocused = this.state.isInputFocused;
	      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
	      var isOpen = renderedItems !== null;
	      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
	      var itemsContainerId = "react-autowhatever-".concat(id);
	      var containerProps = _objectSpread(_objectSpread({
	        role: 'combobox',
	        'aria-haspopup': 'listbox',
	        'aria-owns': itemsContainerId,
	        'aria-expanded': isOpen
	      }, theme("react-autowhatever-".concat(id, "-container"), 'container', isOpen && 'containerOpen')), this.props.containerProps);
	      var inputComponent = renderInputComponent(_objectSpread(_objectSpread(_objectSpread({
	        type: 'text',
	        value: '',
	        autoComplete: 'off',
	        'aria-autocomplete': 'list',
	        'aria-controls': itemsContainerId,
	        'aria-activedescendant': ariaActivedescendant
	      }, theme("react-autowhatever-".concat(id, "-input"), 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused')), this.props.inputProps), {}, {
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
	        ref: this.storeInputReference
	      }));
	      var itemsContainer = renderItemsContainer({
	        containerProps: _objectSpread(_objectSpread({
	          id: itemsContainerId
	        }, theme("react-autowhatever-".concat(id, "-items-container"), 'itemsContainer', isOpen && 'itemsContainerOpen')), {}, {
	          ref: this.storeItemsContainerReference
	        }),
	        children: renderedItems
	      });
	      return /*#__PURE__*/_react["default"].createElement("div", containerProps, inputComponent, itemsContainer);
	    }
	  }]);
	}(_react.Component);
	_defineProperty(Autowhatever, "propTypes", {
	  id: _propTypes["default"].string,
	  // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
	  multiSection: _propTypes["default"].bool,
	  // Indicates whether a multi section layout should be rendered.
	  renderInputComponent: _propTypes["default"].func,
	  // When specified, it is used to render the input element.
	  renderItemsContainer: _propTypes["default"].func,
	  // Renders the items container.
	  items: _propTypes["default"].array.isRequired,
	  // Array of items or sections to render.
	  renderItem: _propTypes["default"].func,
	  // This function renders a single item.
	  renderItemData: _propTypes["default"].object,
	  // Arbitrary data that will be passed to renderItem()
	  renderSectionTitle: _propTypes["default"].func,
	  // This function gets a section and renders its title.
	  getSectionItems: _propTypes["default"].func,
	  // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
	  containerProps: _propTypes["default"].object,
	  // Arbitrary container props
	  inputProps: _propTypes["default"].object,
	  // Arbitrary input props
	  itemProps: _propTypes["default"].oneOfType([
	  // Arbitrary item props
	  _propTypes["default"].object, _propTypes["default"].func]),
	  highlightedSectionIndex: _propTypes["default"].number,
	  // Section index of the highlighted item
	  highlightedItemIndex: _propTypes["default"].number,
	  // Highlighted item index (within a section)
	  theme: _propTypes["default"].oneOfType([
	  // Styles. See: https://github.com/markdalgleish/react-themeable
	  _propTypes["default"].object, _propTypes["default"].array])
	});
	_defineProperty(Autowhatever, "defaultProps", {
	  id: '1',
	  multiSection: false,
	  renderInputComponent: defaultRenderInputComponent,
	  renderItemsContainer: defaultRenderItemsContainer,
	  renderItem: function renderItem() {
	    throw new Error('`renderItem` must be provided');
	  },
	  renderItemData: emptyObject,
	  renderSectionTitle: function renderSectionTitle() {
	    throw new Error('`renderSectionTitle` must be provided');
	  },
	  getSectionItems: function getSectionItems() {
	    throw new Error('`getSectionItems` must be provided');
	  },
	  containerProps: emptyObject,
	  inputProps: emptyObject,
	  itemProps: emptyObject,
	  highlightedSectionIndex: null,
	  highlightedItemIndex: null,
	  theme: defaultTheme
	});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(9));
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	var _compareObjects = _interopRequireDefault(__webpack_require__(32));
	var _excluded = ["isHighlighted", "item", "renderItem", "renderItemData"];
	function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
	function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
	function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
	function _classCallCheck(a, n) { if (!(a instanceof n)) return;("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) return;("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) return;("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) return;("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; return;("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	var Item = exports["default"] = /*#__PURE__*/function (_Component) {
	  function Item() {
	    var _this;
	    _classCallCheck(this, Item);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _callSuper(this, Item, [].concat(args));
	    _defineProperty(_this, "storeItemReference", function (item) {
	      if (item !== null) {
	        _this.item = item;
	      }
	    });
	    _defineProperty(_this, "onMouseEnter", function (event) {
	      var _this$props = _this.props,
	        sectionIndex = _this$props.sectionIndex,
	        itemIndex = _this$props.itemIndex;
	      _this.props.onMouseEnter(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	    _defineProperty(_this, "onMouseLeave", function (event) {
	      var _this$props2 = _this.props,
	        sectionIndex = _this$props2.sectionIndex,
	        itemIndex = _this$props2.itemIndex;
	      _this.props.onMouseLeave(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	    _defineProperty(_this, "onMouseDown", function (event) {
	      var _this$props3 = _this.props,
	        sectionIndex = _this$props3.sectionIndex,
	        itemIndex = _this$props3.itemIndex;
	      _this.props.onMouseDown(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	    _defineProperty(_this, "onClick", function (event) {
	      var _this$props4 = _this.props,
	        sectionIndex = _this$props4.sectionIndex,
	        itemIndex = _this$props4.itemIndex;
	      _this.props.onClick(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	    return _this;
	  }
	  _inherits(Item, _Component);
	  return _createClass(Item, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props, ['renderItemData']);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	        isHighlighted = _this$props5.isHighlighted,
	        item = _this$props5.item,
	        renderItem = _this$props5.renderItem,
	        renderItemData = _this$props5.renderItemData,
	        restProps = _objectWithoutProperties(_this$props5, _excluded);
	      delete restProps.sectionIndex;
	      delete restProps.itemIndex;
	      if (typeof restProps.onMouseEnter === 'function') {
	        restProps.onMouseEnter = this.onMouseEnter;
	      }
	      if (typeof restProps.onMouseLeave === 'function') {
	        restProps.onMouseLeave = this.onMouseLeave;
	      }
	      if (typeof restProps.onMouseDown === 'function') {
	        restProps.onMouseDown = this.onMouseDown;
	      }
	      if (typeof restProps.onClick === 'function') {
	        restProps.onClick = this.onClick;
	      }
	      return /*#__PURE__*/_react["default"].createElement("li", _extends({
	        role: "option"
	      }, restProps, {
	        ref: this.storeItemReference
	      }), renderItem(item, _objectSpread({
	        isHighlighted: isHighlighted
	      }, renderItemData)));
	    }
	  }]);
	}(_react.Component);
	_defineProperty(Item, "propTypes", {
	  sectionIndex: _propTypes["default"].number,
	  isHighlighted: _propTypes["default"].bool.isRequired,
	  itemIndex: _propTypes["default"].number.isRequired,
	  item: _propTypes["default"].any.isRequired,
	  renderItem: _propTypes["default"].func.isRequired,
	  renderItemData: _propTypes["default"].object.isRequired,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onMouseDown: _propTypes["default"].func,
	  onClick: _propTypes["default"].func
	});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(9));
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	var _Item = _interopRequireDefault(__webpack_require__(74));
	var _compareObjects = _interopRequireDefault(__webpack_require__(32));
	function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
	function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _classCallCheck(a, n) { if (!(a instanceof n)) return;("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) return;("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) return;("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) return;("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; return;("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	var ItemsList = exports["default"] = /*#__PURE__*/function (_Component) {
	  function ItemsList() {
	    var _this;
	    _classCallCheck(this, ItemsList);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _callSuper(this, ItemsList, [].concat(args));
	    _defineProperty(_this, "storeHighlightedItemReference", function (highlightedItem) {
	      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
	    });
	    return _this;
	  }
	  _inherits(ItemsList, _Component);
	  return _createClass(ItemsList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props, ['itemProps']);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	      var _this$props = this.props,
	        items = _this$props.items,
	        itemProps = _this$props.itemProps,
	        renderItem = _this$props.renderItem,
	        renderItemData = _this$props.renderItemData,
	        sectionIndex = _this$props.sectionIndex,
	        highlightedItemIndex = _this$props.highlightedItemIndex,
	        getItemId = _this$props.getItemId,
	        theme = _this$props.theme,
	        keyPrefix = _this$props.keyPrefix;
	      var sectionPrefix = sectionIndex === null ? keyPrefix : "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
	      var isItemPropsFunction = typeof itemProps === 'function';
	      return /*#__PURE__*/_react["default"].createElement("ul", _extends({
	        role: "listbox",
	        "aria-label": "Select Option"
	      }, theme("".concat(sectionPrefix, "items-list"), 'itemsList')), items.map(function (item, itemIndex) {
	        var isFirst = itemIndex === 0;
	        var isHighlighted = itemIndex === highlightedItemIndex;
	        var itemKey = "".concat(sectionPrefix, "item-").concat(itemIndex);
	        var itemPropsObj = isItemPropsFunction ? itemProps({
	          sectionIndex: sectionIndex,
	          itemIndex: itemIndex
	        }) : itemProps;
	        var allItemProps = _objectSpread(_objectSpread({
	          id: getItemId(sectionIndex, itemIndex),
	          'aria-selected': isHighlighted
	        }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted')), itemPropsObj);
	        if (isHighlighted) {
	          allItemProps.ref = _this2.storeHighlightedItemReference;
	        }

	        // `key` is provided by theme()
	        /* eslint-disable react/jsx-key */
	        return /*#__PURE__*/_react["default"].createElement(_Item["default"], _extends({}, allItemProps, {
	          sectionIndex: sectionIndex,
	          isHighlighted: isHighlighted,
	          itemIndex: itemIndex,
	          item: item,
	          renderItem: renderItem,
	          renderItemData: renderItemData
	        }));
	        /* eslint-enable react/jsx-key */
	      }));
	    }
	  }]);
	}(_react.Component);
	_defineProperty(ItemsList, "propTypes", {
	  items: _propTypes["default"].array.isRequired,
	  itemProps: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
	  renderItem: _propTypes["default"].func.isRequired,
	  renderItemData: _propTypes["default"].object.isRequired,
	  sectionIndex: _propTypes["default"].number,
	  highlightedItemIndex: _propTypes["default"].number,
	  onHighlightedItemChange: _propTypes["default"].func.isRequired,
	  getItemId: _propTypes["default"].func.isRequired,
	  theme: _propTypes["default"].func.isRequired,
	  keyPrefix: _propTypes["default"].string.isRequired
	});
	_defineProperty(ItemsList, "defaultProps", {
	  sectionIndex: null
	});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(9));
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	var _compareObjects = _interopRequireDefault(__webpack_require__(32));
	function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
	function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _classCallCheck(a, n) { if (!(a instanceof n)) return;("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) return;("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) return;("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) return;("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; return;("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	var SectionTitle = exports["default"] = /*#__PURE__*/function (_Component) {
	  function SectionTitle() {
	    _classCallCheck(this, SectionTitle);
	    return _callSuper(this, SectionTitle, arguments);
	  }
	  _inherits(SectionTitle, _Component);
	  return _createClass(SectionTitle, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        section = _this$props.section,
	        renderSectionTitle = _this$props.renderSectionTitle,
	        theme = _this$props.theme,
	        sectionKeyPrefix = _this$props.sectionKeyPrefix;
	      var sectionTitle = renderSectionTitle(section);
	      if (!sectionTitle) {
	        return null;
	      }
	      return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "title"), 'sectionTitle'), sectionTitle);
	    }
	  }]);
	}(_react.Component);
	_defineProperty(SectionTitle, "propTypes", {
	  section: _propTypes["default"].any.isRequired,
	  renderSectionTitle: _propTypes["default"].func.isRequired,
	  theme: _propTypes["default"].func.isRequired,
	  sectionKeyPrefix: _propTypes["default"].string.isRequired
	});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	module.exports = __webpack_require__(72)["default"];

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapToAutowhateverTheme = exports.defaultTheme = void 0;
	var defaultTheme = exports.defaultTheme = {
	  container: 'react-autosuggest__container',
	  containerOpen: 'react-autosuggest__container--open',
	  input: 'react-autosuggest__input',
	  inputOpen: 'react-autosuggest__input--open',
	  inputFocused: 'react-autosuggest__input--focused',
	  suggestionsContainer: 'react-autosuggest__suggestions-container',
	  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
	  suggestionsList: 'react-autosuggest__suggestions-list',
	  suggestion: 'react-autosuggest__suggestion',
	  suggestionFirst: 'react-autosuggest__suggestion--first',
	  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
	  sectionContainer: 'react-autosuggest__section-container',
	  sectionContainerFirst: 'react-autosuggest__section-container--first',
	  sectionTitle: 'react-autosuggest__section-title'
	};
	var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
	  var result = {};
	  for (var key in theme) {
	    switch (key) {
	      case 'suggestionsContainer':
	        result['itemsContainer'] = theme[key];
	        break;
	      case 'suggestionsContainerOpen':
	        result['itemsContainerOpen'] = theme[key];
	        break;
	      case 'suggestion':
	        result['item'] = theme[key];
	        break;
	      case 'suggestionFirst':
	        result['itemFirst'] = theme[key];
	        break;
	      case 'suggestionHighlighted':
	        result['itemHighlighted'] = theme[key];
	        break;
	      case 'suggestionsList':
	        result['itemsList'] = theme[key];
	        break;
	      default:
	        result[key] = theme[key];
	    }
	  }
	  return result;
	};

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };

	  return _extends.apply(this, arguments);
	}

	module.exports = _extends;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}

	module.exports = _inheritsLoose;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;

	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }

	  return target;
	}

	module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = undefined;

	var _classCallCheck2 = __webpack_require__(33);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _possibleConstructorReturn2 = __webpack_require__(35);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(34);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _preact = __webpack_require__(4);

	var _hooks = __webpack_require__(13);

	var _dayjs = __webpack_require__(68);

	var _dayjs2 = _interopRequireDefault(_dayjs);

	var _isBetween = __webpack_require__(143);

	var _isBetween2 = _interopRequireDefault(_isBetween);

	var _utility = __webpack_require__(23);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_dayjs2.default.extend(_isBetween2.default);

	var Calendar = function (_Component) {
		(0, _inherits3.default)(Calendar, _Component);

		function Calendar() {
			var _temp, _this, _ret;

			(0, _classCallCheck3.default)(this, Calendar);

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				currentMonth: (0, _dayjs2.default)(_this.props.initialMonth),
				startingMonth: (0, _dayjs2.default)(_this.props.initialMonth),
				outboundDateSelected: (0, _dayjs2.default)(_this.props.outboundDate),
				inboundDateSelected: (0, _dayjs2.default)(_this.props.inboundDate),
				availableDatesOutbound: _this.props.outboundDates,
				availableDatesOutboundMeta: [],
				availableDatesInboundMeta: [],
				availableDatesOutboundCache: [],
				availableDatesInboundCache: [],
				availableDatesInbound: _this.props.inboundDates,
				showLowFares: _this.props.showLowestFare,
				showSoldoutDates: _this.props.showSoldoutDates,
				showAvailableDates: _this.props.showAvailableDates,
				viewableMonths: _this.props.isMobile ? _this.props.mobileViewableMonths : _this.props.desktopViewableMonths,
				tripType: _this.props.tripType,
				showCalendar: false,
				selectingOutbound: true,
				cachedApiCalls: {},
				datePickerTop: '',
				datePickerWidth: '',
				dateFormat: _this.props.dateFormat,
				widgetIsCentered: false,
				widgetIsLeftAligned: false,
				widgetIsRightAligned: false,
				dataLoaded: false,
				dimensions: {
					width: -1,
					height: -1,
					offsetParentDimensions: {
						top: -1,
						left: -1
					}
				}
			}, _this.dateInArray = function (date, array) {
				if (_this.props.showAvailableDates == "off") {
					return true;
				}
				return array.some(function (d) {
					return (0, _dayjs2.default)(d).isSame(date, 'day');
				});
			}, _this.dateRangeRef = (0, _preact.createRef)(), _this.calendarRef = (0, _preact.createRef)(), _this.outboundDateRef = (0, _preact.createRef)(), _this.inboundDateRef = (0, _preact.createRef)(), _this.startDateSelection = function () {
				_this.setState({
					showCalendar: true,
					selectingOutbound: true,
					inboundDateSelected: _this.state.tripType == 'ow' ? (0, _dayjs2.default)('') : _this.state.inboundDateSelected
				}, function () {
					document.addEventListener('mouseup', _this.blurCloseDateSelection);
					document.body.classList.add('ias-calendar-open');

					if (_this.props.clearDateError) _this.props.clearDateError('outboundDate');
					_this.updateParentCalendarMonth();
				});
			}, _this.endDateSelection = function () {
				_this.setState({
					showCalendar: true,
					selectingOutbound: false
				}, function () {
					document.addEventListener('mouseup', _this.blurCloseDateSelection);
					document.body.classList.add('ias-calendar-open');

					if (_this.props.clearDateError) _this.props.clearDateError('inboundDate');
				});
			}, _this.closureEvents = function (e) {
				_this.props.callOnCalendarClose();
			}, _this.closeDateSelection = function (e) {
				e.preventDefault();
				_this.setState({
					showCalendar: false
				}, function () {
					document.body.classList.remove('ias-calendar-open');
					_this.closureEvents();
				});
			}, _this.resetDateSelection = function () {
				_this.setState({
					outboundDateSelected: (0, _dayjs2.default)(''),
					inboundDateSelected: (0, _dayjs2.default)(''),
					selectingOutbound: true,
					showCalendar: false
				});
				document.removeEventListener('mouseup', _this.blurCloseDateSelection);
				document.body.classList.remove('ias-calendar-open');
			}, _this.blurCloseDateSelection = function (e) {
				var target = e.target;

				if (_this.state.showCalendar) {
					if (_this.calendarRef && !_this.calendarRef.current.contains(target) && _this.dateRangeRef && !_this.dateRangeRef.current.contains(target)) {
						_this.setState({ showCalendar: false });
						document.removeEventListener('mouseup', _this.blurCloseDateSelection);
						document.body.classList.remove('ias-calendar-open');
					}
				}
			}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
		}

		/* getSnapshotBeforeUpdate(prevProps, prevState){
	 	console.log("getSnapshotBeforeUpdate prevProps",prevProps)
	 	console.log("getSnapshotBeforeUpdate this.props",this.props)
	 } */

		Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
			var avod = nextProps.outboundDates[nextProps.cityPairOutbound] && nextProps.outboundDates[nextProps.cityPairOutbound].dates || [];
			var avid = nextProps.inboundDates[nextProps.cityPairInbound] && nextProps.inboundDates[nextProps.cityPairInbound].dates || [];

			this.setState({
				tripType: nextProps.tripType,
				startingMonth: nextProps.initialMonth,
				currentMonth: nextProps.initialMonth,
				outboundDateSelected: !this.dateInArray(this.state.outboundDateSelected, avod) ? (0, _dayjs2.default)('') : this.state.outboundDateSelected,
				inboundDateSelected: !this.dateInArray(this.state.inboundDateSelected, avid) ? (0, _dayjs2.default)('') : this.state.inboundDateSelected,
				dataLoaded: !nextProps.waitingForCalendar,
				cachedApiCalls: nextProps.cachedApiCalls
			});
		};

		Calendar.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
			/* console.log(this.props.outboundDates) */
			/* console.log("OBP",nextProps.outboundDates) */
			/* console.log("shouldComponentUpdate this.props",this.props)
	  console.log("shouldComponentUpdate nextProps",nextProps) */

			var avod = nextProps.outboundDates[nextProps.cityPairOutbound] && nextProps.outboundDates[nextProps.cityPairOutbound].dates || [];
			var avid = nextProps.inboundDates[nextProps.cityPairInbound] && nextProps.inboundDates[nextProps.cityPairInbound].dates || [];
			var avodfd = nextProps.outboundDates[nextProps.cityPairOutbound] && nextProps.outboundDates[nextProps.cityPairOutbound].flightMetaData || [];
			var avidfd = nextProps.inboundDates[nextProps.cityPairInbound] && nextProps.inboundDates[nextProps.cityPairInbound].flightMetaData || [];
			var avodfc = nextProps.outboundDates[nextProps.cityPairOutbound] && nextProps.outboundDates[nextProps.cityPairOutbound].cache || [];
			var avidfc = nextProps.inboundDates[nextProps.cityPairInbound] && nextProps.inboundDates[nextProps.cityPairInbound].cache || [];

			this.setState({
				//startingMonth: (this.state.outboundDateSelected.isValid()) ? this.state.outboundDateSelected : (!dayjs(nextProps.outboundDates[0]).isBefore(dayjs())) ? dayjs(nextProps.outboundDates[0]) : dayjs(),
				availableDatesOutbound: avod,
				availableDatesOutboundMeta: avodfd,
				availableDatesOutboundCache: avodfc,
				availableDatesInbound: avid,
				availableDatesInboundMeta: avidfd,
				availableDatesInboundCache: avidfc,
				showAvailableDates: nextProps.showAvailableDates
			});

			// BEWARE OF THIS STATE BLOCKING CONDITIONAL AS IT COULD AFFECT CALENDAR VISIBILITY.
			//if(!this.props.cityPairOutbound && this.props.showAvailableDates.toLowerCase() !== 'off') return false;
		};

		Calendar.prototype.renderHeader = function renderHeader(month, index, total) {
			var dateFormat = 'MMMM YYYY';
			var monthLabels = Object.values(this.props.calendarLabels.months);

			return (0, _preact.h)(
				'div',
				{ className: 'header flex-middle' },
				(0, _preact.h)(
					'div',
					{ className: 'col col-start', onClick: this.prevMonth.bind(this) },
					(0, _preact.h)(
						'div',
						{ className: 'icon' },
						'\u27E8'
					)
				),
				(0, _preact.h)(
					'div',
					{ className: 'col col-center' },
					(0, _preact.h)(
						'span',
						{ 'class': 'ias-month' },
						monthLabels[(0, _dayjs2.default)(month).format('M') - 1]
					),
					this.props.calendarYearFormat && (0, _preact.h)(
						'span',
						{ 'class': 'ias-year' },
						(0, _dayjs2.default)(month).format(this.props.calendarYearFormat)
					)
				),
				(0, _preact.h)(
					'div',
					{ className: 'col col-end', onClick: this.nextMonth.bind(this) },
					(0, _preact.h)(
						'div',
						{ className: 'icon' },
						'\u27E9'
					)
				)
			);
		};

		Calendar.prototype.renderFooter = function renderFooter(month, index, total) {
			return (0, _preact.h)(
				'div',
				{ className: 'footer flex-middle' },
				(index == 1 || index == total - 1) && (0, _preact.h)(
					'div',
					{ className: 'col col-center' },
					(0, _preact.h)(
						'button',
						{ className: 'calendar--close-button', onClick: this.closeDateSelection },
						this.props.calendarLabels.close
					)
				)
			);
		};

		Calendar.prototype.renderDays = function renderDays(month) {
			var dateFormat = 'ddd';
			var days = [];
			var dayLabels = Object.values(this.props.calendarLabels.days);
			if (this.props.startOnMonday) dayLabels.push(dayLabels.shift());

			var startDate = (0, _dayjs2.default)(month).startOf('week');

			for (var i = 0; i < 7; i++) {
				days.push((0, _preact.h)(
					'div',
					{ className: 'col col-center', key: i },
					dayLabels[i]
				));
			}

			return (0, _preact.h)(
				'div',
				{ className: 'days row' },
				days
			);
		};

		Calendar.prototype.insertMarkup = function insertMarkup(string) {
			var cleanString = string === 'not-fetched' || this.state.showAvailableDates === 'off' ? '&nbsp;' : string;
			return { __html: cleanString };
		};

		Calendar.prototype.renderCells = function renderCells(month, loading) {
			var _this2 = this;

			var _state = this.state,
			    outboundDateSelected = _state.outboundDateSelected,
			    inboundDateSelected = _state.inboundDateSelected,
			    availableDatesOutbound = _state.availableDatesOutbound,
			    availableDatesOutboundMeta = _state.availableDatesOutboundMeta,
			    availableDatesInbound = _state.availableDatesInbound,
			    availableDatesInboundMeta = _state.availableDatesInboundMeta,
			    selectingOutbound = _state.selectingOutbound;

			var currentMonth = month;
			var monthStart = (0, _dayjs2.default)(currentMonth).startOf('month');
			var monthEnd = (0, _dayjs2.default)(monthStart).endOf('month');
			var startDate = (0, _dayjs2.default)(monthStart).startOf('week');
			var endDate = (0, _dayjs2.default)(monthEnd).endOf('week');

			var dateFormat = 'D';
			var rows = [];

			var days = [];
			var day = startDate;
			var formattedDate = '';

			while (day <= endDate) {
				var _loop = function _loop(i) {
					formattedDate = (0, _dayjs2.default)(day).format(dateFormat);
					var cloneDay = day;
					var lowestPriceOutbound = availableDatesOutboundMeta && availableDatesOutboundMeta['' + cloneDay.format('YYYY-MM-DD')] && availableDatesOutboundMeta['' + cloneDay.format('YYYY-MM-DD')].lowestPrice[_this2.props.currency + '-' + _this2.state.tripType] || null;
					var lowestPriceInbound = availableDatesInboundMeta && availableDatesInboundMeta['' + cloneDay.format('YYYY-MM-DD')] && availableDatesInboundMeta['' + cloneDay.format('YYYY-MM-DD')].lowestPrice[_this2.props.currency + '-' + _this2.state.tripType] || null;
					var cellClasses = [];
					var isAvailable = (0, _dayjs2.default)(day).isBefore((0, _dayjs2.default)().subtract(1, 'day')) || !_this2.dateInArray(day, selectingOutbound ? availableDatesOutbound : availableDatesInbound);
					var isSoldOut = false;

					if (!isAvailable && _this2.state.showAvailableDates == "on") {
						if (selectingOutbound && !lowestPriceOutbound && lowestPriceOutbound !== 'not-fetched') {
							cellClasses.push('soldout');
							isSoldOut = true;
						}
						if (!selectingOutbound && !lowestPriceInbound && lowestPriceInbound !== 'not-fetched') {
							cellClasses.push('soldout');
							isSoldOut = true;
						}
					}
					if (isAvailable) {
						cellClasses.push('notavailable');
						isSoldOut = null;
					}
					if ((0, _dayjs2.default)(day).isBefore((0, _dayjs2.default)().subtract(1, 'day'))) cellClasses.push('befortoday');
					if (!(0, _dayjs2.default)(day).isSame(monthStart, 'month')) cellClasses.push('disabled');
					if ((0, _dayjs2.default)(day).isSame(outboundDateSelected, 'day') || (0, _dayjs2.default)(day).isSame(inboundDateSelected, 'day')) cellClasses.push('selected');
					if ((0, _dayjs2.default)(day).isBetween(outboundDateSelected, inboundDateSelected)) cellClasses.push('between');
					if ((0, _dayjs2.default)(day).isSame(outboundDateSelected, 'day')) cellClasses.push('outbound');
					if ((0, _dayjs2.default)(day).isSame(inboundDateSelected, 'day')) cellClasses.push('inbound');

					days.push((0, _preact.h)(
						'div',
						{
							className: 'col cell ' + cellClasses.join(' '),
							key: day + '-cell',
							onClick: function onClick() {
								return _this2.onDateClick(cloneDay);
							}
						},
						(0, _preact.h)(
							'div',
							{ className: 'number' },
							(0, _preact.h)(
								'span',
								null,
								formattedDate
							)
						),
						loading && (0, _preact.h)(
							'div',
							{ className: 'load' },
							(0, _preact.h)(_utility.LoadingSvg, null)
						),
						_this2.state.showLowFares.toLowerCase() === 'on' && (0, _preact.h)(
							'div',
							{ className: 'lowestPrice' },
							selectingOutbound && (0, _preact.h)('span', { dangerouslySetInnerHTML: _this2.insertMarkup(lowestPriceOutbound ? lowestPriceOutbound : _this2.state.showSoldoutDates.toLowerCase() === 'on' ? '' + _this2.props.calendarLabels.soldOut : '&nbsp;') }),
							!selectingOutbound && (0, _preact.h)('span', { dangerouslySetInnerHTML: _this2.insertMarkup(lowestPriceInbound ? lowestPriceInbound : _this2.state.showSoldoutDates.toLowerCase() === 'on' ? '' + _this2.props.calendarLabels.soldOut : '&nbsp;') })
						)
					));
					day = (0, _dayjs2.default)(day).add(1, 'day');
				};

				for (var i = 0; i < 7; i++) {
					_loop(i);
				}
				rows.push((0, _preact.h)(
					'div',
					{ className: 'row', key: day },
					days
				));
				days = [];
			}
			return (0, _preact.h)(
				'div',
				{ className: 'body' },
				rows
			);
		};

		Calendar.prototype.onDateClick = function onDateClick(day) {
			var _this3 = this;

			if (!this.state.dataLoaded) return false; // dont let people click while loading
			if (this.state.selectingOutbound) {
				this.setState({
					outboundDateSelected: day,
					inboundDateSelected: day.isAfter(this.state.inboundDateSelected) ? day : this.state.inboundDateSelected,
					selectingOutbound: false,
					showCalendar: this.state.tripType === 'ow' ? false : true
				}, function () {
					if (_this3.props.clearDateError) _this3.props.clearDateError('outboundDate');
					if (_this3.state.tripType === 'ow') document.body.classList.remove('ias-calendar-open');
					_this3.props.updateTravelDates(_this3.state.outboundDateSelected, _this3.state.inboundDateSelected);
					if (!_this3.state.showCalendar) _this3.closureEvents();
				});

				if (this.inboundDateRef.current) this.inboundDateRef.current.focus();
			}
			if (!this.state.selectingOutbound) {
				this.setState({
					inboundDateSelected: day,
					outboundDateSelected: day.isBefore(this.state.outboundDateSelected) ? day : this.state.outboundDateSelected,
					selectingOutbound: true,
					showCalendar: false
				}, function () {
					if (_this3.props.clearDateError) _this3.props.clearDateError('inboundDate');
					document.body.classList.remove('ias-calendar-open');
					_this3.props.updateTravelDates(_this3.state.outboundDateSelected, _this3.state.inboundDateSelected);
					if (!_this3.state.showCalendar) _this3.closureEvents();
				});
			}
		};

		Calendar.prototype.updateParentCalendarMonth = function updateParentCalendarMonth() {
			this.props.updateCalendarMonth(this.state.currentMonth, this.state.selectingOutbound);
		};

		Calendar.prototype.nextMonth = function nextMonth() {
			var _this4 = this;

			this.setState({
				currentMonth: (0, _dayjs2.default)(this.state.currentMonth).add(this.state.viewableMonths, 'month'),
				startingMonth: (0, _dayjs2.default)(this.state.startingMonth).add(this.state.viewableMonths, 'month')
			}, function () {
				_this4.updateParentCalendarMonth();
			});
		};

		Calendar.prototype.prevMonth = function prevMonth() {
			var _this5 = this;

			this.setState({
				currentMonth: (0, _dayjs2.default)(this.state.currentMonth).subtract(this.state.viewableMonths, 'month'),
				startingMonth: (0, _dayjs2.default)(this.state.startingMonth).subtract(this.state.viewableMonths, 'month')
			}, function () {
				_this5.updateParentCalendarMonth();
			});
		};

		Calendar.prototype.componentWillUnmount = function componentWillUnmount() {
			document.removeEventListener('mouseup', this.blurCloseDateSelection);
		};

		Calendar.prototype.componentDidMount = function componentDidMount() {
			var _this6 = this;

			//document.addEventListener('mouseup', this.blurCloseDateSelection)

			// For safety: Check if a ref was supplied
			_dayjs2.default.Ls.en.weekStart = this.props.startOnMonday;

			if (this.dateRangeRef.current) {
				setTimeout(function () {

					var dimensions = _this6.dateRangeRef.current.getBoundingClientRect();
					dimensions.offsetParentDimensions = {
						top: _this6.dateRangeRef.current.offsetTop,
						left: _this6.dateRangeRef.current.offsetLeft
					};

					var widgetIsCentered = _this6.props.componentDimensions.left === Math.abs(_this6.props.componentDimensions.right - window.innerWidth);
					var widgetIsLeftAligned = _this6.props.componentDimensions.left < window.innerWidth - (_this6.props.componentDimensions.left + _this6.props.componentDimensions.width);
					var widgetIsRightAligned = window.innerWidth - (_this6.props.componentDimensions.left + _this6.props.componentDimensions.width) < _this6.props.componentDimensions.left;
					var availableSpace = void 0;
					if (widgetIsLeftAligned) {
						widgetIsCentered = false;
						widgetIsRightAligned = false;
						availableSpace = window.innerWidth - _this6.props.componentDimensions.left;
					}
					if (widgetIsRightAligned) {
						widgetIsLeftAligned = false;
						widgetIsCentered = false;
						availableSpace = _this6.props.componentDimensions.left + _this6.props.componentDimensions.width;
					}
					if (widgetIsCentered) {
						widgetIsLeftAligned = false;
						widgetIsRightAligned = false;
						availableSpace = window.innerWidth;
					}

					var a = availableSpace;
					//let b = (widgetIsCentered) ? window.innerWidth : this.props.componentDimensions.width;
					//let b = this.props.componentDimensions.width;
					var b = 320; // this is not good, but it's currently the fixed min/width for the calendar
					var i = a % b;
					var i2 = a - i;
					var hyptheticalMaxMonths = i2 / b;

					var setViewableMonths = hyptheticalMaxMonths > _this6.state.viewableMonths ? _this6.state.viewableMonths : hyptheticalMaxMonths;

					_this6.setState({
						datePickerWidth: dimensions.width,
						datePickerTop: dimensions.y + dimensions.height,
						dimensions: dimensions,
						viewableMonths: setViewableMonths,
						widgetIsCentered: widgetIsCentered,
						widgetIsLeftAligned: widgetIsLeftAligned,
						widgetIsRightAligned: widgetIsRightAligned
						// this could be used to automatically hide months if there isn't enough room
						//viewableMonths: (this.props.componentDimensions.width * 2 > window.innerWidth && !this.props.isMobile && window.innerWidth < this.props.horizontalBreakpoint) ? 1 : this.state.viewableMonths
					});
				}, 100);
			}
		};

		Calendar.prototype.render = function render(_, _ref) {
			var _this7 = this;

			var tripType = _ref.tripType,
			    datePickerWidth = _ref.datePickerWidth,
			    datePickerTop = _ref.datePickerTop,
			    currentMonth = _ref.currentMonth,
			    startingMonth = _ref.startingMonth,
			    outboundDateSelected = _ref.outboundDateSelected,
			    inboundDateSelected = _ref.inboundDateSelected,
			    showCalendar = _ref.showCalendar,
			    dateFormat = _ref.dateFormat,
			    dimensions = _ref.dimensions,
			    viewableMonths = _ref.viewableMonths;

			var months = [startingMonth];
			for (var m = 0; m < viewableMonths - 1; m++) {
				// minus two because the currentMonth is already present
				months.push((0, _dayjs2.default)(startingMonth).add(1 + m, 'month'));
			}

			var styleObj = {};

			if (!this.props.isMobile && this.props.listPosition.toLowerCase() == "right" && this.props.componentDimensions.width < this.props.horizontalBreakpoint && !this.props.autoDrop) {
				styleObj.top = dimensions.offsetParentDimensions.top + 'px';
				styleObj.left = dimensions.width + 'px';
			} else {
				styleObj.top = dimensions.offsetParentDimensions.top + dimensions.height + 'px';
			}

			if (this.state.widgetIsRightAligned) {
				styleObj.right = '0px';
			}
			if (this.state.widgetIsLeftAligned) {
				styleObj.left = '0px';
			}
			if (this.state.widgetIsCentered) {
				styleObj.left = '50%';
				styleObj.transform = 'translateX(-50%)';
			}

			return (0, _preact.h)(
				_preact.Fragment,
				null,
				(0, _preact.h)(
					'div',
					{ 'class': 'dateRangeControls', ref: this.dateRangeRef },
					(0, _preact.h)(
						'span',
						{ 'class': 'dateInputControl' },
						(0, _preact.h)(
							'label',
							{ 'class': 'secondary--label', 'for': this.props.uniqueValue + '-dateRange' },
							this.props.translations.dateOutboundSelectionLabel
						),
						this.props.showLoadingIndicator && (0, _preact.h)(
							'div',
							{
								'class': 'control-loading-indicator is-visible',
								role: 'status',
								'aria-label': 'Loading live prices'
							},
							(0, _preact.h)(
								'span',
								{ 'class': 'control-loading-indicator__spinner', 'aria-hidden': 'true' },
								(0, _preact.h)(_utility.LoadingSvg, null)
							)
						),
						(0, _preact.h)('input', {
							readonly: true,
							type: 'text',
							ref: this.outboundDateRef,
							id: this.props.uniqueValue + '-dateRange',
							name: 'dateRange',
							className: 'form-control',
							value: outboundDateSelected.isValid() ? outboundDateSelected.format(dateFormat) : '',
							onFocus: this.startDateSelection,
							placeholder: this.props.calendarLabels.outBoundPlaceholder
						}),
						this.props.dateErrors && this.props.dateErrors.outbound && (0, _preact.h)(
							'div',
							{ id: this.props.uniqueValue + '-outbound-error', 'class': 'field-error', role: 'alert' },
							this.props.dateErrors.outbound
						)
					),
					tripType == 'rt' && (0, _preact.h)(
						_preact.Fragment,
						null,
						(0, _preact.h)(
							'span',
							{ 'class': 'dateIcon' },
							(0, _preact.h)(_utility.ArrowSvg, null)
						),
						(0, _preact.h)(
							'span',
							{ 'class': 'dateInputControl' },
							(0, _preact.h)(
								'label',
								{ 'class': 'secondary--label', 'for': this.props.uniqueValue + '-dateRangeEnd' },
								this.props.translations.dateInboundSelectionLabel
							),
							this.props.showLoadingIndicator && (0, _preact.h)(
								'div',
								{
									'class': 'control-loading-indicator is-visible',
									role: 'status',
									'aria-label': 'Loading live prices'
								},
								(0, _preact.h)(
									'span',
									{ 'class': 'control-loading-indicator__spinner', 'aria-hidden': 'true' },
									(0, _preact.h)(_utility.LoadingSvg, null)
								)
							),
							(0, _preact.h)('input', {
								readonly: true,
								ref: this.inboundDateRef,
								type: 'text',
								name: 'dateRangeEnd',
								className: 'form-control',
								value: inboundDateSelected.isValid() ? inboundDateSelected.format(dateFormat) : '',
								onFocus: this.endDateSelection,
								placeholder: this.props.calendarLabels.inBoundPlaceholder
							}),
							this.props.dateErrors && this.props.dateErrors.inbound && (0, _preact.h)(
								'div',
								{ id: this.props.uniqueValue + '-inbound-error', 'class': 'field-error', role: 'alert' },
								this.props.dateErrors.inbound
							)
						)
					)
				),
				showCalendar && (0, _preact.h)(
					'div',
					{ ref: this.calendarRef, className: 'calendar-window', style: styleObj },
					(0, _preact.h)(
						'h2',
						null,
						this.props.calendarLabels.selectionIndicator,
						' ',
						(0, _preact.h)(
							'span',
							null,
							(0, _preact.h)(_utility.ArrowSvg, null)
						),
						' ',
						this.state.selectingOutbound ? this.props.calendarLabels.outBoundPlaceholder : this.props.calendarLabels.inBoundPlaceholder
					),
					months.map(function (m, i) {

						var monthLoading = true;
						var successfulLoad = true;
						try {
							var currMY = (0, _dayjs2.default)(m).format('MMMYY');
							var cityPair = _this7.props.cityPairSearch['outbound'];
							var composedLookup = cityPair.dep + '-' + cityPair.arr + '-' + _this7.state.tripType + '-' + currMY + '-' + _this7.props.currency;
							if (!_this7.state.selectingOutbound && _this7.state.outboundDateSelected && _this7.state.outboundDateSelected.isValid()) {
								var depDateStr = _this7.state.outboundDateSelected.format('YYYYMMDD');
								composedLookup += '-dep:' + depDateStr;
							}
							var currentJourneyCache = _this7.state.selectingOutbound ? _this7.state.availableDatesOutboundCache : _this7.state.availableDatesInboundCache;

							if (Object.keys(currentJourneyCache).includes(composedLookup)) {
								var cacheStatus = currentJourneyCache['' + composedLookup];
								monthLoading = cacheStatus === 'loading';
								if (cacheStatus === 'error') successfulLoad = false;
							}
							if (_this7.state.showAvailableDates == "off") {
								monthLoading = false;
							}
						} catch (e) {
							monthLoading = false;
						}

						return (0, _preact.h)(
							'div',
							{ key: m, className: 'calendar ' + (monthLoading ? 'loading' : 'loaded') + ' ' + (_this7.state.showLowFares.toLowerCase() === 'on' ? 'lowFares' : '') + ' ' + (_this7.state.showSoldoutDates.toLowerCase() !== 'on' ? 'hideSoldout' : '') },
							_this7.renderHeader(m, i, months.length),
							_this7.renderDays(m),
							_this7.renderCells(m, monthLoading, successfulLoad),
							_this7.renderFooter(m, i, months.length)
						);
					})
				)
			);
		};

		return Calendar;
	}(_preact.Component);

	exports.default = Calendar;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = undefined;

	var _extends2 = __webpack_require__(24);

	var _extends3 = _interopRequireDefault(_extends2);

	var _classCallCheck2 = __webpack_require__(33);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _possibleConstructorReturn2 = __webpack_require__(35);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(34);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _preact = __webpack_require__(4);

	var _hooks = __webpack_require__(13);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var InputStepper = function (_Component) {
	  (0, _inherits3.default)(InputStepper, _Component);

	  function InputStepper() {
	    var _temp, _this, _ret;

	    (0, _classCallCheck3.default)(this, InputStepper);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      count: _this.props.startingCount || 0
	    }, _this.updateParent = function () {
	      _this.props.onChange({ value: _this.state.count, name: _this.props.name });
	    }, _this.increase = function () {
	      if (_this.state.count + 1 <= _this.fieldRef.current.getAttribute("max") && _this.props.totalCount < _this.props.totalCountMax) _this.setState({ count: parseInt(_this.state.count) + 1 }, _this.updateParent);
	    }, _this.decrease = function (e) {
	      if (_this.state.count - 1 >= _this.fieldRef.current.getAttribute("min")) _this.setState({ count: parseInt(_this.state.count) - 1 }, _this.updateParent);
	    }, _this.update = function (e) {
	      _this.setState({ count: parseInt(e.target.value) }, _this.updateParent);
	    }, _this.fieldRef = (0, _preact.createRef)(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }

	  InputStepper.prototype.render = function render() {
	    return (0, _preact.h)(
	      'div',
	      { 'class': 'stepper' },
	      (0, _preact.h)(
	        'button',
	        { type: 'button', 'class': 'minus', disabled: this.state.count == this.props.minCount, tabIndex: '-1', 'data-type': 'pax', onBlur: this.props.onBlur, onClick: this.decrease },
	        (0, _preact.h)(
	          'span',
	          null,
	          '\u2212'
	        )
	      ),
	      (0, _preact.h)('input', (0, _extends3.default)({}, this.props, {
	        type: 'number',
	        ref: this.fieldRef,
	        min: this.props.minCount,
	        max: this.props.maxCount,
	        value: this.state.count,
	        pattern: '[0-9]*',
	        'data-type': 'pax',
	        className: 'form-control',
	        onChange: this.update,
	        onKeyDown: function onKeyDown(e) {
	          if (e.key === 'Enter') {
	            e.preventDefault();
	            // optional: do something here or bubble to parent
	          }
	        }
	      })),
	      (0, _preact.h)(
	        'button',
	        { type: 'button', 'class': 'plus', disabled: this.props.totalCount >= this.props.totalCountMax || this.props.maxCount == this.state.count, tabIndex: '-1', 'data-type': 'pax', onBlur: this.props.onBlur, onClick: this.increase },
	        (0, _preact.h)(
	          'span',
	          null,
	          '+'
	        )
	      )
	    );
	  };

	  return InputStepper;
	}(_preact.Component);

	exports.default = InputStepper;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _extends2 = __webpack_require__(24);

	var _extends3 = _interopRequireDefault(_extends2);

	var _preact = __webpack_require__(4);

	var _compat = __webpack_require__(9);

	var _hooks = __webpack_require__(13);

	var _InputStepper = __webpack_require__(83);

	var _InputStepper2 = _interopRequireDefault(_InputStepper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var PassengersInput = (0, _compat.forwardRef)(function (props, ref) {
	  var _useState = (0, _hooks.useState)(0),
	      paxCount = _useState[0],
	      setPaxCount = _useState[1];

	  var _useState2 = (0, _hooks.useState)(props.paxTypes),
	      paxTypesRet = _useState2[0],
	      setPaxTypesRet = _useState2[1];

	  var _useState3 = (0, _hooks.useState)(false),
	      showPaxModal = _useState3[0],
	      setShowPaxModal = _useState3[1];

	  var wrapperRef = (0, _hooks.useRef)(null);
	  var translations = props.translations;

	  var contentWrapper = (0, _preact.createRef)();

	  (0, _hooks.useEffect)(function () {
	    var basePaxCount = props.paxTypes instanceof Object && Object.keys(props.paxTypes).reduce(function (acc, ptc) {
	      acc = acc + props.ptcDefault[ptc].min;
	      return acc;
	    }, 0);
	    setPaxCount(basePaxCount);
	  }, []);

	  (0, _hooks.useEffect)(function () {
	    if (props.paxModalOpenRef) {
	      props.paxModalOpenRef.current = showPaxModal;
	    }
	  }, [showPaxModal]);

	  var showPax = function showPax() {
	    setShowPaxModal(!showPaxModal);
	    if (contentWrapper.current.fieldRef.current) contentWrapper.current.fieldRef.current.focus();
	  };

	  (0, _hooks.useImperativeHandle)(ref, function () {
	    return {
	      showPax: showPax
	    };
	  });

	  var handleUserClick = (0, _hooks.useCallback)(function (event) {
	    var target = event.target;

	    if (wrapperRef.current && !wrapperRef.current.contains(target)) {
	      setShowPaxModal(false);
	    }
	  }, []);

	  (0, _hooks.useEffect)(function () {
	    window.addEventListener('mousedown', handleUserClick);
	    return function () {
	      window.removeEventListener('mousedown', handleUserClick);
	    };
	  }, [handleUserClick]);

	  var handlePaxChange = function handlePaxChange(e) {
	    var paxTypesL = (0, _extends3.default)({}, paxTypesRet);
	    paxTypesL[e.name] = e.value;
	    setPaxTypesRet(paxTypesL);
	    setPaxCount(Object.values(paxTypesL).reduce(function (a, b) {
	      return parseInt(a) + parseInt(b);
	    }, 0));
	  };

	  (0, _hooks.useEffect)(function () {
	    props.handlePaxChange({ paxTypes: paxTypesRet, paxCount: paxCount });
	  }, [paxTypesRet, paxCount]);

	  var paxTypes = props.paxTypes,
	      ptcDefault = props.ptcDefault,
	      ptcMinMax = props.ptcMinMax,
	      ptcTotalMax = props.ptcTotalMax,
	      lang = props.lang,
	      uniqueValue = props.uniqueValue,
	      dataIsLoaded = props.dataIsLoaded,
	      ptcDependencies = props.ptcDependencies;


	  return (0, _preact.h)(
	    'div',
	    { ref: wrapperRef, 'class': 'fieldset passengerSelection' },
	    (0, _preact.h)(
	      'label',
	      { 'class': 'primary--label', 'for': uniqueValue + '-passengerSelection', onClick: showPax },
	      translations[lang].passengersLabel
	    ),
	    dataIsLoaded && (0, _preact.h)(
	      'div',
	      { role: 'button', tabIndex: '0', 'aria-haspopup': 'dialog', 'aria-expanded': showPaxModal ? "true" : "false", id: uniqueValue + '-passengerSelection', 'class': showPaxModal ? 'passengerCount form-control show' : 'passengerCount form-control', 'data-type': 'pax', onClick: showPax,
	        onKeyDown: function onKeyDown(e) {
	          if (e.key === 'Enter' || e.key === ' ') {
	            e.preventDefault(); // Prevent scroll on Space
	            showPax();
	          }
	          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
	            e.preventDefault();
	            showPax();
	          }
	        }
	      },
	      !paxCount ? translations[lang].passengersPlaceholder : (0, _preact.h)(
	        _preact.Fragment,
	        null,
	        (0, _preact.h)(
	          'span',
	          null,
	          paxCount
	        ),
	        paxCount > 1 ? translations[lang].passengersCountPlural : translations[lang].passengersCountSingular
	      )
	    ),
	    !dataIsLoaded && (0, _preact.h)(
	      'div',
	      { 'class': 'form-control' },
	      (0, _preact.h)(
	        'div',
	        { 'class': 'load-parent--wrapper' },
	        (0, _preact.h)(LoadingSvg, null)
	      )
	    ),
	    (0, _preact.h)(
	      'div',
	      { 'class': showPaxModal ? 'optionContainer show' : 'optionContainer' },
	      paxTypes instanceof Object && Object.keys(paxTypes).map(function (ptc, index) {
	        var dynamicMax = ptcMinMax[ptc].max;
	        var dynamicMin = ptcMinMax[ptc].min;

	        if (ptcDependencies && ptcDependencies[ptc]) {
	          var deps = ptcDependencies[ptc];
	          var depSum = deps.reduce(function (sum, dep) {
	            return sum + (parseInt(paxTypesRet[dep]) || 0);
	          }, 0);
	          if (depSum === 0) {
	            dynamicMax = 0;
	          }
	        }

	        if (ptcDependencies) {
	          var isCrucialDependency = false;
	          Object.keys(ptcDependencies).forEach(function (dependent) {
	            if (parseInt(paxTypesRet[dependent]) > 0) {
	              var depsForThisDependent = ptcDependencies[dependent];
	              if (depsForThisDependent.includes(ptc)) {
	                var _depSum = depsForThisDependent.reduce(function (sum, dep) {
	                  return sum + (parseInt(paxTypesRet[dep]) || 0);
	                }, 0);
	                if (_depSum === 1 && parseInt(paxTypesRet[ptc]) === 1) {
	                  isCrucialDependency = true;
	                }
	              }
	            }
	          });
	          if (isCrucialDependency) {
	            dynamicMin = Math.max(dynamicMin, 1);
	          }
	        }

	        return (0, _preact.h)(
	          'div',
	          { key: ptc, 'class': 'passengerTypes ' + ptc },
	          (0, _preact.h)(
	            'div',
	            { 'class': 'field' },
	            (0, _preact.h)(
	              'label',
	              { 'class': 'specialized--label ptc--label', 'for': uniqueValue + '-' + ptc },
	              translations[lang].passengersTypeLabels[ptc]
	            ),
	            (0, _preact.h)(_InputStepper2.default, {
	              ref: index === 0 ? contentWrapper : null,
	              name: '' + ptc,
	              id: uniqueValue + '-' + ptc,
	              startingCount: ptcDefault[ptc].min,
	              totalCount: paxCount,
	              totalCountMax: parseInt(ptcTotalMax),
	              minCount: dynamicMin,
	              maxCount: dynamicMax,
	              onChange: handlePaxChange
	            })
	          ),
	          (0, _preact.h)(
	            'div',
	            { 'class': 'desc' },
	            translations[lang].passengersTypeDescriptions[ptc]
	          )
	        );
	      }),
	      (0, _preact.h)(
	        'button',
	        { type: 'button', className: 'btn btn-primary ptc--close-button', onClick: showPax },
	        translations[lang].passengersTypeCloseButton
	      )
	    )
	  );
	});

	exports.default = PassengersInput;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = TabNavigation;

	var _preact = __webpack_require__(4);

	var _hooks = __webpack_require__(13);

	var _deepmerge = __webpack_require__(49);

	var _deepmerge2 = _interopRequireDefault(_deepmerge);

	var _utility = __webpack_require__(23);

	var _en = __webpack_require__(70);

	var _en2 = _interopRequireDefault(_en);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var translations = _en2.default;
	var globalExtraData = {};

	function TabNavigation(props) {
		var _useState = (0, _hooks.useState)({}),
		    tabs = _useState[0],
		    setTabs = _useState[1];

		var _useState2 = (0, _hooks.useState)(),
		    active = _useState2[0],
		    setActive = _useState2[1];

		(0, _hooks.useEffect)(function () {
			if (props.hasOwnProperty('endpoint') || props.hasOwnProperty('airline')) return false;
			try {
				var sc = document.getElementById('flight-search-widget-translations');
				var clientTranslations = JSON.parse(sc.innerHTML.replace(/^[\<][\S ]+|^[\/]\S+/gm, ""));
				if (sc) {
					Object.keys(clientTranslations).forEach(function (key) {
						// This extends the languages to be sure that if a client does not include a key the language will still load properly. Helpful for widget upgrades too!
						clientTranslations[key] = (0, _deepmerge2.default)(translations.en, clientTranslations[key]);
					});
					translations = (0, _deepmerge2.default)(translations, clientTranslations);
				}
				if (!clientTranslations.hasOwnProperty(props.lang)) props.lang = 'en';
			} catch (e) {
				props.lang = 'en';
				console.log("ERROR", e, props);
			}

			try {
				var extraDataSet = document.getElementById('flight-search-widget-data-extension');
				var extraDataParsed = JSON.parse(extraDataSet.innerHTML.replace(/^[\<][\S ]+|^[\/]\S+/gm, ""));
				if (extraDataParsed) {
					globalExtraData = extraDataParsed;
					var tabDefault = props.defaultTab || Object.keys(globalExtraData.tabs)[0];
					if (!globalExtraData.tabs[props.defaultTab]) tabDefault = Object.keys(globalExtraData.tabs)[0]; // if the specifed tab doesn't exist use the first one available

					var realTabbedData = Object.keys(extraDataParsed.tabs).forEach(function (tab, i) {
						try {
							globalExtraData.tabs[tab]["label"] = translations[props.lang].tabs[tab].tabLabel;
							var el = document.querySelector(globalExtraData.tabs[tab].contentSelector);
							globalExtraData.tabs[tab]["contentId"] = el.id;
							el.setAttribute("role", "tabpanel");
							el.classList.add("ias-tab-panel");
							el.setAttribute("tabindex", 0);
							el.setAttribute("aria-labelledby", 'tab-' + tab);
							el.classList.remove("ias-tab-preload");

							if (globalExtraData.tabs[tab] && tab !== tabDefault) el.classList.add("ias-hidden-tab");
							if (tabDefault && tab === tabDefault) {
								setActive(tab);
								el.classList.add("ias-visible-tab");
							}
						} catch (e) {
							console.log("Missing translation for", tab);
							globalExtraData.tabs[tab]["label"] = "Label Missing";
						}
					});

					setTabs(globalExtraData.tabs);
				}
			} catch (e) {
				//logToConsole(e,props)
				console.log("ERROR", e, props);
			}
		}, []);

		var actOnTabs = function actOnTabs(last, next) {
			last.classList.add("ias-hidden-tab");
			last.classList.remove("ias-visible-tab");
			next.classList.remove("ias-hidden-tab");
			next.classList.add("ias-visible-tab");
		};

		var manageTab = function manageTab(tab, event) {
			actOnTabs(document.querySelector(tabs[active].contentSelector), document.querySelector(tabs[tab].contentSelector));
			setActive(tab);
		};

		return (0, _preact.h)(
			'ul',
			{ role: 'tablist', className: 'ias-tab-list' },
			Object.keys(tabs).map(function (tab) {
				return (0, _preact.h)(
					'li',
					{
						id: 'tab-' + tab,
						key: tab,
						role: 'tab',
						tabindex: '0',
						'aria-selected': active === tab ? true : false,
						'aria-pressed': 'false',
						'aria-controls': tabs[tab].contentId,
						className: 'ias-tab-item' + (active === tab ? ' ias-tab-active' : ''),
						onClick: function onClick(ev) {
							manageTab(tab, ev);
						} },
					(0, _preact.h)(
						'span',
						{ className: 'tab-utility-wrapper' },
						tabs[tab].label
					)
				);
			})
		);
	}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = TripTypeInput;

	var _preact = __webpack_require__(4);

	var _hooks = __webpack_require__(13);

	var _utility = __webpack_require__(23);

	var DISPLAY_MODES = ['group', 'radio', 'switch', 'select'];
	var TRIP_TYPES = ['ow', 'rt', 'mc'];

	function filterValues(options, input) {
	  input = Array.isArray(input) ? input : [];
	  return input.filter(function (v) {
	    return options.indexOf(v) >= 0;
	  });
	}

	function TripTypeInput(props) {
	  var isDisabled = !!props.disabled;
	  var showLoadingIndicator = !!props.showLoadingIndicator;
	  // i18n helper with safe fallback
	  var lang = (props.lang || 'en').toLowerCase();
	  function t(key) {
	    var bundles = props.translations || {};
	    var bundle = bundles[lang] || bundles.en || {};
	    return bundle[key] || '';
	  }

	  // allowed types based on props, memoized
	  var allowedTypes = (0, _hooks.useMemo)(function () {
	    return filterValues(TRIP_TYPES, props.tripTypeOptions || TRIP_TYPES);
	  }, [props.tripTypeOptions]);

	  // sanitize incoming props
	  function safeDisplayMode(v) {
	    return DISPLAY_MODES.indexOf(v) >= 0 ? v : 'group';
	  }
	  function safeTripType(v) {
	    return allowedTypes.indexOf(v) >= 0 ? v : allowedTypes[0] || 'ow';
	  }

	  // initial state from sanitized props

	  var _useState = (0, _hooks.useState)(safeDisplayMode(props.tripTypeDisplay)),
	      displayMode = _useState[0],
	      setDisplayMode = _useState[1];

	  var _useState2 = (0, _hooks.useState)(safeTripType(props.tripType)),
	      tripType = _useState2[0],
	      setTripType = _useState2[1];

	  // keep display mode in sync with parent updates


	  (0, _hooks.useEffect)(function () {
	    var next = safeDisplayMode(props.tripTypeDisplay);
	    if (next !== displayMode) setDisplayMode(next);
	  }, [props.tripTypeDisplay]);

	  // keep trip type in sync when parent or allowedTypes change
	  (0, _hooks.useEffect)(function () {
	    var next = safeTripType(props.tripType);
	    if (next !== tripType) setTripType(next);
	  }, [props.tripType, allowedTypes]);

	  // notify parent when tripType changes
	  (0, _hooks.useEffect)(function () {
	    if (typeof props.handleTripChange === 'function') {
	      props.handleTripChange({ target: { value: tripType } });
	    }
	  }, [tripType]);

	  // label helper
	  function labelFor(type) {
	    if (type === 'ow') return t('onewayName');
	    if (type === 'rt') return t('roundtripName');
	    return t('multicityName');
	  }

	  var uniqueValue = props.uniqueValue || 'trip';

	  return (0, _preact.h)(
	    'div',
	    { 'class': 'fieldset tripTypeSelection ' + displayMode },
	    (0, _preact.h)(
	      'label',
	      { 'class': 'primary--label', 'for': uniqueValue + '-ow' },
	      t('tripTypeLabel')
	    ),
	    showLoadingIndicator && (0, _preact.h)(
	      'div',
	      {
	        'class': 'control-loading-indicator is-visible',
	        role: 'status',
	        'aria-label': 'Loading live prices'
	      },
	      (0, _preact.h)(
	        'span',
	        { 'class': 'control-loading-indicator__spinner', 'aria-hidden': 'true' },
	        (0, _preact.h)(_utility.LoadingSvg, null)
	      )
	    ),
	    displayMode === 'group' && (0, _preact.h)(
	      _preact.Fragment,
	      null,
	      (0, _preact.h)(
	        'div',
	        { 'class': 'stv-radio-buttons-wrapper' },
	        allowedTypes.map(function (type) {
	          return (0, _preact.h)(
	            _preact.Fragment,
	            { key: type },
	            (0, _preact.h)('input', {
	              type: 'radio',
	              'class': 'stv-radio-button',
	              name: 'tripType',
	              value: type,
	              id: uniqueValue + '-' + type,
	              checked: tripType === type,
	              disabled: isDisabled,
	              onChange: function onChange() {
	                setTripType(type);
	              }
	            }),
	            (0, _preact.h)(
	              'label',
	              { 'for': uniqueValue + '-' + type, 'class': 'btn specialized--label trip--label' },
	              labelFor(type)
	            )
	          );
	        })
	      )
	    ),
	    displayMode === 'radio' && (0, _preact.h)(
	      _preact.Fragment,
	      null,
	      (0, _preact.h)(
	        'div',
	        { 'class': 'radio-buttons-wrapper' },
	        allowedTypes.map(function (type) {
	          return (0, _preact.h)(
	            _preact.Fragment,
	            { key: type },
	            (0, _preact.h)(
	              'div',
	              { 'class': 'radio-option' },
	              (0, _preact.h)('input', {
	                type: 'radio',
	                'class': 'radio-button form-check-input',
	                name: 'tripType',
	                value: type,
	                id: uniqueValue + '-' + type,
	                checked: tripType === type,
	                disabled: isDisabled,
	                onChange: function onChange() {
	                  setTripType(type);
	                }
	              }),
	              (0, _preact.h)(
	                'label',
	                { 'for': uniqueValue + '-' + type, 'class': 'form-check-label trip--label' },
	                labelFor(type)
	              )
	            )
	          );
	        })
	      )
	    ),
	    displayMode === 'select' && (0, _preact.h)(
	      _preact.Fragment,
	      null,
	      (0, _preact.h)(
	        'div',
	        { 'class': 'select-trip-wrapper' },
	        (0, _preact.h)(
	          'select',
	          {
	            'class': 'select-css form-control',
	            id: uniqueValue + '-tripTypeSelect',
	            value: tripType,
	            disabled: isDisabled,
	            onChange: function onChange(e) {
	              setTripType(e.target.value);
	            } },
	          allowedTypes.map(function (type) {
	            return (0, _preact.h)(
	              'option',
	              { key: type, value: type },
	              labelFor(type)
	            );
	          })
	        )
	      )
	    ),
	    displayMode === 'switch' && (0, _preact.h)(
	      _preact.Fragment,
	      null,
	      (0, _preact.h)(
	        'div',
	        { 'class': 'toggle-checkbox-wrapper' },
	        (0, _preact.h)('input', {
	          'class': 'toggle-checkbox',
	          type: 'checkbox',
	          id: uniqueValue + '-toggle',
	          checked: tripType === 'ow',
	          disabled: isDisabled,
	          onChange: function onChange() {
	            setTripType(tripType === 'ow' ? 'rt' : 'ow');
	          }
	        }),
	        (0, _preact.h)(
	          'label',
	          { 'class': 'iasslidertg', 'for': uniqueValue + '-toggle' },
	          (0, _preact.h)(
	            'span',
	            { 'class': 'toggle-switch opt1' },
	            t('roundtripName')
	          ),
	          (0, _preact.h)(
	            'span',
	            { 'class': 'toggle-switch opt2' },
	            t('onewayName')
	          )
	        )
	      )
	    )
	  );
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = undefined;

	var _objectWithoutProperties2 = __webpack_require__(99);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _regenerator = __webpack_require__(17);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(16);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	var _extends11 = __webpack_require__(24);

	var _extends12 = _interopRequireDefault(_extends11);

	var _classCallCheck2 = __webpack_require__(33);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _possibleConstructorReturn2 = __webpack_require__(35);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(34);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _class, _temp2;

	var _preact = __webpack_require__(4);

	var _hooks = __webpack_require__(13);

	var _reactAutosuggest = __webpack_require__(77);

	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

	var _reactIsolatedScroll = __webpack_require__(149);

	var _reactIsolatedScroll2 = _interopRequireDefault(_reactIsolatedScroll);

	var _ismobilejs = __webpack_require__(144);

	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

	var _Calendar = __webpack_require__(82);

	var _Calendar2 = _interopRequireDefault(_Calendar);

	var _PassengersInput = __webpack_require__(84);

	var _PassengersInput2 = _interopRequireDefault(_PassengersInput);

	var _TripTypeInput = __webpack_require__(86);

	var _TripTypeInput2 = _interopRequireDefault(_TripTypeInput);

	var _reactMeasure = __webpack_require__(150);

	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

	var _dayjs = __webpack_require__(68);

	var _dayjs2 = _interopRequireDefault(_dayjs);

	var _deepmerge = __webpack_require__(49);

	var _deepmerge2 = _interopRequireDefault(_deepmerge);

	var _utility = __webpack_require__(23);

	var _en = __webpack_require__(70);

	var _en2 = _interopRequireDefault(_en);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var flightsByDate = (0, _utility.groupBy)('departureDate');

	var translations = _en2.default;
	var cityPairs = [];
	var airports = [];
	var gatewayCityPairsControl = [];
	var paxTypeMap = {
		'ADT': { ngi: 'adult', ibe: 'Adults' },
		'CHD': { ngi: 'child', ibe: 'Children' },
		'INF': { ngi: 'infant', ibe: 'Infants' }
	};
	var paxTypeAltMap = {
		'ADT': { gateway: 'ADT', abbPackager: 'Adult' },
		'SRC': { gateway: 'SRC', abbPackager: 'Adult' },
		'CHD': { gateway: 'CNN', abbPackager: 'Child' },
		'YTH': { gateway: 'CNN', abbPackager: 'Child' },
		'INF': { gateway: 'INF', abbPackager: 'Infant' }
	};

	var globalExtraData = {};

	function delayMethodCall(callback) {
		var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 225;

		return new Promise(function (resolve) {
			setTimeout(function () {
				callback();
				resolve();
			}, delay);
		});
	}

	var groupByCityPairIdentifier = function groupByCityPairIdentifier(data) {
		return data.reduce(function (acc, item) {
			var identifier = item.originalCityPair && item.originalCityPair.identifier || item.cityPair && item.cityPair.identifier;
			if (identifier) {
				if (!acc[identifier]) {
					acc[identifier] = [];
				}
				acc[identifier].push(item);
			}
			return acc;
		}, {});
	};

	var getSuggestions = function getSuggestions(value) {
		var displayInputAirportCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'on';
		var displayInputAirportCodeFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '({{code}})';

		var inputValue = value.trim().toLowerCase();
		var inputLength = inputValue && inputValue.length || 0;

		var nameSearch = airports.filter(function (a) {
			var formattedCode = displayInputAirportCodeFormat.replace('{{code}}', a.code).toLowerCase();
			var combined = a.code.length > 1 && displayInputAirportCode.toLowerCase() === 'on' ? a.name.toLowerCase() + ' ' + formattedCode : a.name.toLowerCase();
			return a.name.toLowerCase().includes(inputValue) || combined.includes(inputValue);
		});
		var codeSearch = airports.filter(function (a) {
			return a.code.toLowerCase().slice(0, inputLength) === inputValue;
		});

		return inputLength === 0 ? [].concat(airports).sort(function (a, b) {
			return a.name.localeCompare(b.name);
		}) : [].concat(nameSearch.concat(codeSearch.filter(function (item) {
			return nameSearch.indexOf(item) < 0;
		}))).sort(function (a, b) {
			return a.name.localeCompare(b.name);
		});
	};
	var getSuggestionsMatch = function getSuggestionsMatch(value, departure) {
		var displayInputAirportCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'on';
		var displayInputAirportCodeFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '({{code}})';

		var inputValue = value.trim().toLowerCase();
		var inputLength = inputValue && inputValue.length || 0;

		var filteredCityPairs = cityPairs.reduce(function (acc, a) {
			if (a.departure.airport.code === departure.code) acc.push(a.arrival.airport);
			return acc;
		}, []);

		filteredCityPairs.sort(function (a, b) {
			return a.name > b.name ? 1 : -1;
		}); // sort from a-z

		var nameSearch = filteredCityPairs.filter(function (a) {
			var formattedCode = displayInputAirportCodeFormat.replace('{{code}}', a.code).toLowerCase();
			var combined = a.code.length > 1 && displayInputAirportCode.toLowerCase() === 'on' ? a.name.toLowerCase() + ' ' + formattedCode : a.name.toLowerCase();
			return a.name.toLowerCase().includes(inputValue) || combined.includes(inputValue);
		});
		var codeSearch = filteredCityPairs.filter(function (a) {
			return a.code.toLowerCase().slice(0, inputLength) === inputValue;
		});

		return inputLength === 0 ? filteredCityPairs : nameSearch.concat(codeSearch.filter(function (item) {
			return nameSearch.indexOf(item) < 0;
		}));
	};

	var getSuggestionValue = function getSuggestionValue(suggestion) {
		var displayInputAirportCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'on';
		var displayInputAirportCodeFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '({{code}})';

		var formattedCode = displayInputAirportCodeFormat.replace('{{code}}', suggestion.code);
		return suggestion.code.length > 1 && displayInputAirportCode.toLowerCase() === 'on' ? suggestion.name + ' ' + formattedCode : suggestion.name;
	};

	var shouldRenderSuggestions = function shouldRenderSuggestions(value) {
		//return value.trim().length > 0;
		return true;
	};
	var renderSuggestion = function renderSuggestion(suggestion) {

		var isInterline = !!(suggestion && suggestion.code && airports.some(function (_ref) {
			var code = _ref.code,
			    interline = _ref.interline;
			return code === suggestion.code && interline;
		}));

		return (0, _preact.h)(
			'div',
			{ className: 'sg-item' + (isInterline ? ' interline' : ''), 'data-code': suggestion && suggestion.code },
			(0, _preact.h)(
				'span',
				{ className: 'name' },
				suggestion.name
			),
			suggestion.code.length > 1 && (0, _preact.h)(
				'span',
				{ className: 'code' },
				suggestion.code
			)
		);
	};

	var renderInputComponent = function renderInputComponent(inputProps) {
		var close = function close(e) {
			e.preventDefault();
			inputProps.closeMethod(inputProps);
		};
		return (0, _preact.h)(
			'div',
			{ 'class': 'autosuggest-wrapper' },
			(0, _preact.h)('input', inputProps),
			!inputProps.dataIsLoaded && (0, _preact.h)(
				'div',
				{ 'class': 'load-parent--wrapper' },
				(0, _preact.h)(_utility.LoadingSvg, null)
			),
			inputProps.value && (0, _preact.h)(
				'button',
				{ type: 'button', 'class': 'clear-selected', tabindex: '-1', onClick: close },
				(0, _preact.h)(
					'span',
					null,
					'\xD7'
				)
			)
		);
	};

	var Widget = (_temp2 = _class = function (_Component) {
		(0, _inherits3.default)(Widget, _Component);

		function Widget() {
			var _this2 = this;

			var _temp, _this, _ret;

			(0, _classCallCheck3.default)(this, Widget);

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				airline: _this.props.airline || _this.props.endpoint || null,
				value: '',
				lang: 'en',
				widgetId: _this.props.widgetId,
				uniqueValue: (0, _utility.uniqueValueGenerator)(),
				currencies: [],
				currency: '',
				cityPairSearch: [],
				passengerTypeCodes: [],
				cabinClasses: [{
					code: 'Y',
					description: 'Economy'
				}, {
					code: 'B',
					description: 'Business'
				}],
				departureAirportSelection: { code: '', name: '', href: '' },
				arrivalAirportSelection: { code: '', name: '', href: '' },
				outboundDate: '',
				inboundDate: '',
				suggestions: [],
				autoAdvanceOptions: null,
				departureSuggestions: [],
				arrivalSuggestions: [],
				availableOutboundDates: {},
				availableInboundDates: {},
				mobileViewableMonths: _this.props.mobileViewableMonths,
				desktopViewableMonths: _this.props.desktopViewableMonths,
				viewableMonths: (0, _ismobilejs2.default)(window.navigator).any ? _this.props.mobileViewableMonths : _this.props.desktopViewableMonths,
				showAvailableDates: _this.props.showAvailableDates,
				showLowestFare: _this.props.showLowestFare,
				showSoldoutDates: _this.props.showSoldoutDates,
				fareFormats: null,
				tripType: _this.props.tripType.toLowerCase() === "ow" || _this.props.tripType.toLowerCase() === "rt" ? _this.props.tripType.toLowerCase() : 'rt',
				tripTypeOptions: _this.props.tripTypeOptions.split('|').map(function (type) {
					return type.trim().toLowerCase();
				}),
				serviceType: '',
				calendarCurrentMonth: (0, _dayjs2.default)(),
				cachedApiCalls: {},
				outboundCachedApiCalls: [],
				inboundCachedApiCalls: [],
				promocode: _this.props.promocode || '',
				saleAffiliateId: null,
				showPaxModal: false,
				showPromocode: _this.props.showPromocode || 'on',
				showCurrencies: _this.props.showCurrencies || 'on',
				paxCount: 1,
				ptcTypes: {},
				ptcMinMax: {},
				ptcDefault: {},
				ptcDependencies: {},
				dimensions: {
					width: -1,
					height: -1,
					windowWidth: -1
				},
				suggestDepRect: {},
				suggestArrRect: {},
				formValidated: false,
				errors: {},
				gatewaySearch: false,
				gatewayDirect: false,
				dataLoaded: false,
				waitingForCalendar: false,
				calendarLoadingCount: 0,
				soarUrl: _this.props.soarUrl,
				travelQuestion: _this.props.travelQuestionDefault.toLowerCase() === "on" ? true : false,
				autoPromocodeValue: null,
				autoPromocodeAssociation: _this.props.autoPromocodeAssociation,
				useRTL: 'off'
			}, _this.getCurrentDatesByMonthIndex = function (index) {
				var monthLoop = (0, _dayjs2.default)(_this.state.calendarCurrentMonth).add(index, 'month');
				var daysInMonth = (0, _dayjs2.default)(monthLoop).daysInMonth() - 1; // days in current month
				var todayDay = !(0, _dayjs2.default)(_this.state.calendarCurrentMonth.isSame((0, _dayjs2.default)(monthLoop), 'day')) ? (0, _dayjs2.default)(_this.state.calendarCurrentMonth) : (0, _dayjs2.default)(monthLoop).startOf('month'); // needed to garb same day flights
				var todayDayIndex = parseInt(!(0, _dayjs2.default)(_this.state.calendarCurrentMonth.isSame((0, _dayjs2.default)(monthLoop), 'day')) ? (0, _dayjs2.default)(_this.state.calendarCurrentMonth).date() : (0, _dayjs2.default)(monthLoop).startOf('month').date()) - 1; // needed to garb same day flights
				var totalDays = daysInMonth - todayDayIndex;

				return {
					monthLoop: monthLoop,
					daysInMonth: daysInMonth,
					todayDay: todayDay,
					todayDayIndex: todayDayIndex,
					totalDays: totalDays
				};
			}, _this.startCalendarLoading = function () {
				_this.setState(function (prevState) {
					return {
						calendarLoadingCount: (prevState.calendarLoadingCount || 0) + 1,
						waitingForCalendar: true
					};
				});
			}, _this.stopCalendarLoading = function () {
				_this.setState(function (prevState) {
					var nextCount = Math.max((prevState.calendarLoadingCount || 0) - 1, 0);
					return {
						calendarLoadingCount: nextCount,
						waitingForCalendar: nextCount > 0
					};
				});
			}, _this.buildDateObjectArray = function (dates) {
				// set default currency
				var priceStatus = {};
				priceStatus[_this.state.currency + '-' + _this.state.tripType] = 'not-fetched';
				return dates.reduce(function (a, v) {
					var _extends2;

					return (0, _extends12.default)({}, a, (_extends2 = {}, _extends2[v] = { flightNumbers: null, lowestPrice: priceStatus }, _extends2));
				}, {});
			}, _this.buildFlightMetaData = function (resultsByDate, empty) {
				try {
					return Object.keys(resultsByDate).reduce(function (acc, curr) {
						if (empty) {
							acc['' + curr] = {
								flightNumbers: null,
								lowestPrice: null
							};
							return acc;
						}
						// make list of flight numbers for this day
						var flightNumbers = resultsByDate['' + curr].map(function (options) {
							return options.flights.map(function (flight) {
								var alCode = flight.airlineCode && flight.airlineCode.code || '';
								return '' + alCode + flight.flightNumber;
							});
						});

						var lowPrice = null;
						var currentCurrencyFormatMask = _this.state.fareFormats && _this.state.fareFormats[_this.state.currency] || _this.props.fareFormatOverride;
						var lowestFares = resultsByDate['' + curr].map(function (r) {
							return r.fareOptions;
						}).flat().filter(function (fo) {
							return fo.cheapestFareOption;
						});
						var calculatedLowestFares = lowestFares.map(function (lp) {
							return (0, _utility.calculateFare)(lp, _this.props.fareRounding.toLowerCase(), _this.props.fareDecimals.toLowerCase(), _this.props.fareBaseOnly.toLowerCase(), _this.state.currencies.find(function (c) {
								return c.code === _this.state.currency;
							}), currentCurrencyFormatMask);
						});
						calculatedLowestFares.sort(function (a, b) {
							return parseFloat(a.fareDirty) - parseFloat(b.fareDirty);
						});

						lowPrice = calculatedLowestFares[0];
						if (!lowPrice) lowPrice = { fareTotal: 0, availability: 0, class: '' };

						var lowestByCurrency = {};
						lowestByCurrency[_this.state.currency + '-' + _this.state.tripType] = lowPrice && lowPrice.fareTotal;

						acc['' + curr] = {
							flightNumbers: flightNumbers.flat(),
							lowestPrice: lowestByCurrency
						};
						return acc;
					}, {});
				} catch (error) {
					console.log("error in buildFlightMetaData", error);
				}
			}, _this.getWeeksForSearchRange = function (searchDates) {
				var todayDay = searchDates.todayDay,
				    totalDays = searchDates.totalDays,
				    monthLoop = searchDates.monthLoop,
				    daysInMonth = searchDates.daysInMonth;

				var maxDate = todayDay.add(totalDays, 'day');
				var weeks = [];

				for (var start = (0, _dayjs2.default)(todayDay); start.isBefore(maxDate) || start.isSame(maxDate, 'day'); start = start.add(7, 'day')) {
					var endOfInterval = start.add(6, 'day').isAfter(maxDate) ? maxDate : start.add(6, 'day');
					var intervalDays = endOfInterval.diff(start, 'day');
					weeks.push({
						monthLoop: monthLoop,
						daysInMonth: daysInMonth,
						todayDay: start,
						todayDayIndex: start.date() - 1,
						totalDays: intervalDays
					});
				}
				return weeks;
			}, _this.populateCalendarWithResultsByMonth = function () {
				var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(outbound, index, cityPair, lookUpdates) {
					var isReturnCall = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
					var cachedApiCalls, currMY, composedLookup, depDateStr, expectedCityPairs, inboundCityPair, targetStateKey, targetJourney, cachedDatesBlock, weeks, failedWeeksCount, weeklyPromises, finalStatus;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									cachedApiCalls = _this.state.cachedApiCalls;
									currMY = (0, _dayjs2.default)(lookUpdates.todayDay).format('MMMYY');
									composedLookup = cityPair + '-' + _this.state.tripType + '-' + currMY + '-' + _this.state.currency;

									if (isReturnCall && _this.state.outboundDate) {
										depDateStr = (0, _dayjs2.default)(_this.state.outboundDate).format('YYYYMMDD');

										composedLookup += '-dep:' + depDateStr;
									}

									// 1. Check if already loading/loaded in class instance to prevent concurrent double-triggers
									if (!_this.loadingMonths) {
										_this.loadingMonths = new Set();
									}

									if (!_this.loadingMonths.has(composedLookup)) {
										_context2.next = 7;
										break;
									}

									return _context2.abrupt('return', false);

								case 7:
									expectedCityPairs = [cityPair];

									if (_this.state.tripType === 'rt' && _this.state.cityPairSearch.inbound) expectedCityPairs.push(_this.state.cityPairSearch.inbound.dep + '-' + _this.state.cityPairSearch.inbound.arr);

									// 2. Check if already loaded/loading in state
									inboundCityPair = _this.state.cityPairSearch.inbound ? _this.state.cityPairSearch.inbound.dep + '-' + _this.state.cityPairSearch.inbound.arr : null;

									if (!(isReturnCall && !inboundCityPair)) {
										_context2.next = 12;
										break;
									}

									return _context2.abrupt('return', false);

								case 12:
									targetStateKey = isReturnCall ? 'availableInboundDates' : 'availableOutboundDates';
									targetJourney = isReturnCall ? inboundCityPair : cityPair;
									cachedDatesBlock = (0, _extends12.default)({}, _this.state[targetStateKey][targetJourney] || {});

									if (!(cachedDatesBlock && cachedDatesBlock.cache)) {
										_context2.next = 19;
										break;
									}

									if (!Object.keys(cachedDatesBlock.cache).includes(composedLookup)) {
										_context2.next = 19;
										break;
									}

									if (!(cachedDatesBlock.cache['' + composedLookup] === 'loaded' || cachedDatesBlock.cache['' + composedLookup] === 'loading')) {
										_context2.next = 19;
										break;
									}

									return _context2.abrupt('return', false);

								case 19:

									// 3. Mark month as loading (in-memory block + state)
									_this.loadingMonths.add(composedLookup);

									_this.setState(function (prevState) {
										var startStateUpdate = {};
										expectedCityPairs.forEach(function (journey) {
											var _extends3, _extends4;

											var isOutbound = journey === cityPair;
											if (isReturnCall && isOutbound) return;

											var key = isOutbound ? 'availableOutboundDates' : 'availableInboundDates';
											var currentData = prevState[key][journey] || { dates: [], flightMetaData: {}, cache: {} };
											startStateUpdate[key] = (0, _extends12.default)({}, startStateUpdate[key] || prevState[key] || {}, (_extends4 = {}, _extends4[journey] = (0, _extends12.default)({}, currentData, {
												cache: (0, _extends12.default)({}, currentData.cache, (_extends3 = {}, _extends3[composedLookup] = 'loading', _extends3))
											}), _extends4));
										});
										return startStateUpdate;
									});

									weeks = _this.getWeeksForSearchRange(lookUpdates);
									failedWeeksCount = 0;
									weeklyPromises = weeks.map(function () {
										var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(weekDates) {
											var responses, issue, flightsGroupedByJourney;
											return _regenerator2.default.wrap(function _callee$(_context) {
												while (1) {
													switch (_context.prev = _context.next) {
														case 0:
															_this.startCalendarLoading();
															responses = void 0;
															issue = null;
															_context.prev = 3;
															_context.next = 6;
															return _this.queryCalendar(outbound, index, weekDates, isReturnCall);

														case 6:
															responses = _context.sent;
															flightsGroupedByJourney = [];

															try {
																flightsGroupedByJourney = groupByCityPairIdentifier(responses);
															} catch (e) {
																issue = true;
																failedWeeksCount++;
															}

															expectedCityPairs.forEach(function (journey) {
																if (!Object.keys(flightsGroupedByJourney).includes(journey)) {
																	flightsGroupedByJourney[journey] = [];
																}
															});

															// Update state incrementally with this week's responses
															_this.setState(function (prevState) {
																var stateUpdateObject = {};
																Object.entries(flightsGroupedByJourney).forEach(function (_ref4) {
																	var _extends5;

																	var journey = _ref4[0],
																	    items = _ref4[1];

																	var isOutbound = journey === cityPair;
																	if (isReturnCall && isOutbound) {
																		// Skip updating outbound dates during return combinability queries
																		return;
																	}

																	var key = isOutbound ? 'availableOutboundDates' : 'availableInboundDates';
																	var cachedData = prevState[key][journey] || { dates: [], flightMetaData: {}, cache: {} };

																	var dates = void 0;
																	var flightMetaData = void 0;
																	var resultsByDate = flightsByDate(items.flat());
																	if (issue) {
																		dates = !items.length ? _this.populateBackupCalendarMonth(weekDates) : Object.keys(resultsByDate);
																		flightMetaData = !items.length ? _this.buildDateObjectArray(dates, true) : _this.buildFlightMetaData(resultsByDate, false);
																	} else {
																		dates = !items.length ? [] : Object.keys(resultsByDate);
																		flightMetaData = !items.length ? {} : _this.buildFlightMetaData(resultsByDate, false);
																	}

																	var overwriteMerge = function overwriteMerge(destinationArray, sourceArray, options) {
																		return sourceArray;
																	};
																	var mergedMetaData = (0, _deepmerge2.default)(cachedData.flightMetaData, flightMetaData, { arrayMerge: overwriteMerge });

																	stateUpdateObject[key] = (0, _extends12.default)({}, stateUpdateObject[key] || prevState[key] || {}, (_extends5 = {}, _extends5[journey] = {
																		dates: (0, _utility.joinAndKeepUnique)(cachedData.dates, dates),
																		flightMetaData: mergedMetaData,
																		cache: cachedData.cache
																	}, _extends5));
																});
																return stateUpdateObject;
															});

															_context.next = 18;
															break;

														case 13:
															_context.prev = 13;
															_context.t0 = _context['catch'](3);

															console.log("error loading week", _context.t0);
															(0, _utility.logToConsole)(_context.t0, _this.props);
															failedWeeksCount++;

														case 18:
															_context.prev = 18;

															_this.stopCalendarLoading();
															return _context.finish(18);

														case 21:
														case 'end':
															return _context.stop();
													}
												}
											}, _callee, _this2, [[3, 13, 18, 21]]);
										}));

										return function (_x13) {
											return _ref3.apply(this, arguments);
										};
									}());
									_context2.prev = 24;
									_context2.next = 27;
									return Promise.all(weeklyPromises);

								case 27:

									// Mark month cache status as loaded/error depending on whether weekly calls failed
									finalStatus = failedWeeksCount > 0 ? 'error' : 'loaded';

									_this.setState(function (prevState) {
										var stateUpdateObject = {};
										expectedCityPairs.forEach(function (journey) {
											var _extends6, _extends7;

											var isOutbound = journey === cityPair;
											if (isReturnCall && isOutbound) return;

											var key = isOutbound ? 'availableOutboundDates' : 'availableInboundDates';
											var cachedData = prevState[key][journey] || { dates: [], flightMetaData: {}, cache: {} };
											stateUpdateObject[key] = (0, _extends12.default)({}, stateUpdateObject[key] || prevState[key] || {}, (_extends7 = {}, _extends7[journey] = (0, _extends12.default)({}, cachedData, {
												cache: (0, _extends12.default)({}, cachedData.cache, (_extends6 = {}, _extends6[composedLookup] = finalStatus, _extends6))
											}), _extends7));
										});
										return stateUpdateObject;
									});
									_context2.next = 34;
									break;

								case 31:
									_context2.prev = 31;
									_context2.t0 = _context2['catch'](24);

									console.log("error resolving weekly promises", _context2.t0);

								case 34:
									_context2.prev = 34;

									_this.loadingMonths.delete(composedLookup);
									return _context2.finish(34);

								case 37:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2, [[24, 31, 34, 37]]);
				}));

				return function (_x8, _x9, _x10, _x11) {
					return _ref2.apply(this, arguments);
				};
			}(), _this.refreshReturnCalendar = function () {
				var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(selectedDeparture) {
					var _this$state$cityPairS, outbound, inbound, outboundCityPair, inboundCityPair, depDateStr, asyncTravelOptionsCalls;

					return _regenerator2.default.wrap(function _callee4$(_context4) {
						while (1) {
							switch (_context4.prev = _context4.next) {
								case 0:
									if (!(_this.props.showAvailableDates == 'off' || _this.state.gatewayDirect)) {
										_context4.next = 2;
										break;
									}

									return _context4.abrupt('return', false);

								case 2:
									_this$state$cityPairS = _this.state.cityPairSearch, outbound = _this$state$cityPairS.outbound, inbound = _this$state$cityPairS.inbound;

									if (inbound) {
										_context4.next = 5;
										break;
									}

									return _context4.abrupt('return', false);

								case 5:
									outboundCityPair = outbound.dep + '-' + outbound.arr;
									inboundCityPair = inbound.dep + '-' + inbound.arr;
									depDateStr = (0, _dayjs2.default)(selectedDeparture).format('YYYYMMDD');
									asyncTravelOptionsCalls = Array.from(Array(parseInt(_this.state.viewableMonths)).keys()).map(function () {
										var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(cp, index) {
											var dates, startReturnSearchDate, endOfMonth, currMY, composedLookup, adjustedTotalDays, adjustedDates;
											return _regenerator2.default.wrap(function _callee3$(_context3) {
												while (1) {
													switch (_context3.prev = _context3.next) {
														case 0:
															dates = _this.getCurrentDatesByMonthIndex(index);

															// Adjust starting date for return calendar to be on or after selectedDeparture

															startReturnSearchDate = (0, _dayjs2.default)(dates.todayDay).isAfter(selectedDeparture) ? (0, _dayjs2.default)(dates.todayDay) : (0, _dayjs2.default)(selectedDeparture);
															endOfMonth = (0, _dayjs2.default)(dates.monthLoop).endOf('month');

															if (!startReturnSearchDate.isAfter(endOfMonth)) {
																_context3.next = 8;
																break;
															}

															currMY = (0, _dayjs2.default)(dates.monthLoop).format('MMMYY');
															composedLookup = outboundCityPair + '-' + _this.state.tripType + '-' + currMY + '-' + _this.state.currency + '-dep:' + depDateStr;

															_this.setState(function (prevState) {
																var _extends8, _extends9;

																var cachedData = prevState.availableInboundDates[inboundCityPair] || { dates: [], flightMetaData: {}, cache: {} };
																return {
																	availableInboundDates: (0, _extends12.default)({}, prevState.availableInboundDates, (_extends9 = {}, _extends9[inboundCityPair] = (0, _extends12.default)({}, cachedData, {
																		cache: (0, _extends12.default)({}, cachedData.cache, (_extends8 = {}, _extends8[composedLookup] = 'loaded', _extends8))
																	}), _extends9))
																};
															});
															return _context3.abrupt('return', false);

														case 8:
															adjustedTotalDays = endOfMonth.diff(startReturnSearchDate, 'day');
															adjustedDates = (0, _extends12.default)({}, dates, {
																todayDay: startReturnSearchDate,
																todayDayIndex: startReturnSearchDate.date() - 1,
																totalDays: adjustedTotalDays
															});

															// Fetch return flights for this month (using outbound cityPair for the combinability roundtrip query)

															_context3.next = 12;
															return _this.populateCalendarWithResultsByMonth(true, index, outboundCityPair, adjustedDates, true);

														case 12:
														case 'end':
															return _context3.stop();
													}
												}
											}, _callee3, _this2);
										}));

										return function (_x15, _x16) {
											return _ref6.apply(this, arguments);
										};
									}());
									_context4.next = 11;
									return Promise.all(asyncTravelOptionsCalls);

								case 11:
								case 'end':
									return _context4.stop();
							}
						}
					}, _callee4, _this2);
				}));

				return function (_x14) {
					return _ref5.apply(this, arguments);
				};
			}(), _this.handleDepartureChange = function (newOutboundDate) {
				var isRT = _this.state.tripType === 'rt';
				if (!isRT || !newOutboundDate || !(0, _dayjs2.default)(newOutboundDate).isValid() || !_this.state.cityPairSearch.inbound) return;

				var inboundCityPair = _this.state.cityPairSearch.inbound.dep + '-' + _this.state.cityPairSearch.inbound.arr;

				// Clear existing return dates and cache for this city pair
				_this.setState(function (prevState) {
					var _extends10;

					return {
						availableInboundDates: (0, _extends12.default)({}, prevState.availableInboundDates, (_extends10 = {}, _extends10[inboundCityPair] = {
							dates: [],
							flightMetaData: {},
							cache: {}
						}, _extends10))
					};
				}, function () {
					_this.refreshReturnCalendar(newOutboundDate);
				});
			}, _this.populateBackupCalendarMonth = function (searchDates) {
				var monthLoop = searchDates.monthLoop,
				    daysInMonth = searchDates.daysInMonth,
				    todayDay = searchDates.todayDay,
				    todayDayIndex = searchDates.todayDayIndex,
				    totalDays = searchDates.totalDays;

				var startDate = todayDay;
				var endDate = (0, _dayjs2.default)(todayDay).add(totalDays, 'days');

				var dateFormat = 'D';
				var rows = [];

				var days = [];
				var day = startDate;
				var formattedDate = '';

				while (day <= endDate) {
					var cloneDay = day;
					days.push(cloneDay.format('YYYY-MM-DD'));
					day = (0, _dayjs2.default)(day).add(1, 'day');
				}
				return days;
			}, _this.lookupAvailability = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
				var _cityPairs, locatedCityPairInGateway, autoPromocodeValue, overrideAvailableDates;

				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.prev = 0;

								if (!(!_this.state.departureAirportSelection.code || !_this.state.arrivalAirportSelection.code)) {
									_context6.next = 4;
									break;
								}

								_this.setState(_this.getCalendarResetState(), _this.resetCalendarView);
								return _context6.abrupt('return', false);

							case 4:
								_cityPairs = (0, _extends12.default)({
									outbound: { dep: _this.state.departureAirportSelection.code, arr: _this.state.arrivalAirportSelection.code }
								}, _this.state.tripType == "rt" && { inbound: { dep: _this.state.arrivalAirportSelection.code, arr: _this.state.departureAirportSelection.code } });
								locatedCityPairInGateway = gatewayCityPairsControl.find(function (c) {
									return c.departure.airport.code === _this.state.departureAirportSelection.code && c.arrival.airport.code === _this.state.arrivalAirportSelection.code;
								});
								autoPromocodeValue = globalExtraData && globalExtraData.promocodeAssociation ? globalExtraData.promocodeAssociation[_this.state.departureAirportSelection.code + '-' + _this.state.arrivalAirportSelection.code] || null : null;

								// here we are going to check if additional JSON was provided with a list of cityPairs that should enable full calendar view
								// when the dates are selected, we check them against the data returned from amelia that has already been cached because it matches the SOAR parameters

								overrideAvailableDates = false;

								if (globalExtraData && globalExtraData.gatewayOverride) {
									if (Object.keys(globalExtraData.gatewayOverride).includes(_cityPairs.outbound.dep + '-' + _cityPairs.outbound.arr)) {
										overrideAvailableDates = true;
									}
								}

								if (locatedCityPairInGateway) {
									_context6.next = 15;
									break;
								}

								if (!(_this.props.showAvailableDates == 'off')) {
									_context6.next = 12;
									break;
								}

								return _context6.abrupt('return', false);

							case 12:

								_this.setState((0, _extends12.default)({
									showAvailableDates: overrideAvailableDates ? "off" : "on"
								}, overrideAvailableDates && { gatewaySearch: true }, {
									gatewayDirect: false,
									cityPairSearch: _cityPairs,
									autoPromocodeValue: autoPromocodeValue
								}), (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
									return _regenerator2.default.wrap(function _callee5$(_context5) {
										while (1) {
											switch (_context5.prev = _context5.next) {
												case 0:

													_this.refreshCalendar();

												case 1:
												case 'end':
													return _context5.stop();
											}
										}
									}, _callee5, _this2);
								})));
								_context6.next = 16;
								break;

							case 15:
								_this.setState({
									showAvailableDates: "off",
									gatewayDirect: true,
									gatewaySearch: true,
									autoPromocodeValue: autoPromocodeValue
								});

							case 16:
								_context6.next = 21;
								break;

							case 18:
								_context6.prev = 18;
								_context6.t0 = _context6['catch'](0);

								(0, _utility.logToConsole)(_context6.t0, _this.props);

							case 21:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this2, [[0, 18]]);
			})), _this.refreshCalendar = function () {
				var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
					var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

					var _this$state$cityPairS2, outbound, inbound, hasSelectedDeparture, includeOutbound, includeReturn, asyncTravelOptionsCalls;

					return _regenerator2.default.wrap(function _callee8$(_context8) {
						while (1) {
							switch (_context8.prev = _context8.next) {
								case 0:
									if (!(_this.props.showAvailableDates == 'off' || _this.state.gatewayDirect)) {
										_context8.next = 2;
										break;
									}

									return _context8.abrupt('return', false);

								case 2:
									_this$state$cityPairS2 = _this.state.cityPairSearch, outbound = _this$state$cityPairS2.outbound, inbound = _this$state$cityPairS2.inbound;

									if (outbound) {
										_context8.next = 5;
										break;
									}

									return _context8.abrupt('return', false);

								case 5:
									hasSelectedDeparture = (0, _dayjs2.default)(_this.state.outboundDate).isValid();
									includeOutbound = options.includeOutbound !== undefined ? options.includeOutbound : true;
									includeReturn = options.includeReturn !== undefined ? options.includeReturn : Boolean(inbound && hasSelectedDeparture);

									if (!includeOutbound) {
										_context8.next = 12;
										break;
									}

									asyncTravelOptionsCalls = Array.from(Array(parseInt(_this.state.viewableMonths)).keys()).map(function () {
										var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(cp, index) {
											var dates;
											return _regenerator2.default.wrap(function _callee7$(_context7) {
												while (1) {
													switch (_context7.prev = _context7.next) {
														case 0:
															dates = _this.getCurrentDatesByMonthIndex(index);
															_context7.next = 3;
															return _this.populateCalendarWithResultsByMonth(true, index, outbound.dep + '-' + outbound.arr, dates);

														case 3:
														case 'end':
															return _context7.stop();
													}
												}
											}, _callee7, _this2);
										}));

										return function (_x18, _x19) {
											return _ref10.apply(this, arguments);
										};
									}());
									_context8.next = 12;
									return Promise.all(asyncTravelOptionsCalls);

								case 12:
									if (!(inbound && includeReturn)) {
										_context8.next = 16;
										break;
									}

									if (!_this.state.outboundDate) {
										_context8.next = 16;
										break;
									}

									_context8.next = 16;
									return _this.refreshReturnCalendar(_this.state.outboundDate);

								case 16:
								case 'end':
									return _context8.stop();
							}
						}
					}, _callee8, _this2);
				}));

				return function () {
					return _ref9.apply(this, arguments);
				};
			}(), _this.renderSuggestionsContainerDep = function (_ref11) {
				var containerProps = _ref11.containerProps,
				    children = _ref11.children,
				    query = _ref11.query;
				var ref = containerProps.ref,
				    restContainerProps = (0, _objectWithoutProperties3.default)(containerProps, ['ref']);

				var callRef = function callRef(isolatedScroll) {
					if (isolatedScroll !== null) {
						ref(isolatedScroll.component);
					}
				};

				var styleObj = { position: "absolute" };
				var _this$state = _this.state,
				    suggestDepRect = _this$state.suggestDepRect,
				    dimensions = _this$state.dimensions;


				if (!(0, _ismobilejs2.default)(window.navigator).any && _this.props.listPosition.toLowerCase() == "right" && dimensions.width < _this.props.horizontalBreakpoint) {
					styleObj.top = '0px';
					styleObj.left = suggestDepRect.width + 'px';
				} else {
					styleObj.top = suggestDepRect.height + 'px';
					styleObj.minWidth = suggestDepRect.width + 'px';
				}
				return (
					//<div {...containerProps} style={styleObj}>
					(0, _preact.h)(
						_reactIsolatedScroll2.default,
						(0, _extends12.default)({ ref: callRef }, restContainerProps, { style: styleObj }),
						children
					)
					//</div>

				);
			}, _this.renderSuggestionsContainerArr = function (_ref12) {
				var containerProps = _ref12.containerProps,
				    children = _ref12.children,
				    query = _ref12.query;
				var ref = containerProps.ref,
				    restContainerProps = (0, _objectWithoutProperties3.default)(containerProps, ['ref']);

				var callRef = function callRef(isolatedScroll) {
					if (isolatedScroll !== null) {
						ref(isolatedScroll.component);
					}
				};
				var styleObj = { position: "absolute" };
				var _this$state2 = _this.state,
				    suggestArrRect = _this$state2.suggestArrRect,
				    dimensions = _this$state2.dimensions;


				if (!(0, _ismobilejs2.default)(window.navigator).any && _this.props.listPosition == "right" && dimensions.width < _this.props.horizontalBreakpoint) {
					styleObj.top = '0px';
					styleObj.left = suggestArrRect.width + 'px';
				} else {
					styleObj.top = suggestArrRect.height + 'px';
					styleObj.minWidth = suggestArrRect.width + 'px';
				}
				return (
					//<div {...containerProps} style={styleObj}>
					(0, _preact.h)(
						_reactIsolatedScroll2.default,
						(0, _extends12.default)({ ref: callRef }, restContainerProps, { style: styleObj }),
						children
					)
					//</div>

				);
			}, _this.getCalendarResetState = function () {
				var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.errors;

				var nextErrors = (0, _extends12.default)({}, errors || {});
				delete nextErrors.outboundDate;
				delete nextErrors.inboundDate;

				return {
					cityPairSearch: [],
					outboundDate: '',
					inboundDate: '',
					gatewaySearch: false,
					gatewayDirect: false,
					autoPromocodeValue: null,
					showAvailableDates: _this.props.showAvailableDates,
					waitingForCalendar: false,
					calendarLoadingCount: 0,
					errors: nextErrors
				};
			}, _this.resetCalendarView = function () {
				if (_this.calendarRef.current && _this.calendarRef.current.resetDateSelection) _this.calendarRef.current.resetDateSelection();
			}, _this.onChangeDeparture = function (event, _ref13) {
				var newValue = _ref13.newValue;

				var nextErrors = (0, _extends12.default)({}, _this.state.errors || {});
				if (newValue) delete nextErrors.departure;
				_this.setState((0, _extends12.default)({}, _this.getCalendarResetState(nextErrors), {
					departureAirportSelection: { name: newValue, code: newValue },
					arrivalAirport: ''
				}), _this.resetCalendarView);
			}, _this.onChangeArrival = function (event, _ref14) {
				var newValue = _ref14.newValue;

				var nextErrors = (0, _extends12.default)({}, _this.state.errors || {});
				if (newValue) delete nextErrors.arrival;
				_this.setState((0, _extends12.default)({}, _this.getCalendarResetState(nextErrors), {
					arrivalAirportSelection: { name: newValue, code: newValue }
				}), _this.resetCalendarView);
			}, _this.departureSelected = function (event, _ref15) {
				var suggestion = _ref15.suggestion,
				    suggestionValue = _ref15.suggestionValue,
				    suggestionIndex = _ref15.suggestionIndex,
				    sectionIndex = _ref15.sectionIndex,
				    method = _ref15.method;

				var nextErrors = (0, _extends12.default)({}, _this.state.errors || {});
				delete nextErrors.departure;

				_this.setState((0, _extends12.default)({}, _this.getCalendarResetState(nextErrors), {
					departureAirportSelection: (0, _extends12.default)({}, suggestion, { name: suggestionValue }),
					arrivalAirportSelection: { code: '', name: '', href: '' }
				}), (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
					var loadedEvent;
					return _regenerator2.default.wrap(function _callee9$(_context9) {
						while (1) {
							switch (_context9.prev = _context9.next) {
								case 0:
									_this.resetCalendarView();

									loadedEvent = new CustomEvent('IASwidgetDepartureSelected', {
										detail: _this.state
									});

									window.dispatchEvent(loadedEvent);
									if (_this.state.autoAdvanceOptions && _this.state.autoAdvanceOptions.includes('arrival') && _this.suggestArrivalRef.current) delayMethodCall(function () {
										return _this.suggestArrivalRef.current.input.focus();
									});

								case 4:
								case 'end':
									return _context9.stop();
							}
						}
					}, _callee9, _this2);
				})));
			}, _this.arrivalSelected = function (event, _ref17) {
				var suggestion = _ref17.suggestion,
				    suggestionValue = _ref17.suggestionValue,
				    suggestionIndex = _ref17.suggestionIndex,
				    sectionIndex = _ref17.sectionIndex,
				    method = _ref17.method;

				var nextErrors = (0, _extends12.default)({}, _this.state.errors || {});
				delete nextErrors.arrival;
				_this.setState({
					arrivalAirportSelection: (0, _extends12.default)({}, suggestion, { name: suggestionValue }),
					errors: nextErrors
				}, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
					var loadedEvent;
					return _regenerator2.default.wrap(function _callee10$(_context10) {
						while (1) {
							switch (_context10.prev = _context10.next) {
								case 0:
									_this.lookupAvailability();
									loadedEvent = new CustomEvent('IASwidgetArrivalSelected', {
										detail: _this.state
									});

									window.dispatchEvent(loadedEvent);
									if (_this.state.autoAdvanceOptions && _this.state.autoAdvanceOptions.includes('calendar') && _this.calendarRef.current.outboundDateRef.current) delayMethodCall(function () {
										return _this.calendarRef.current.outboundDateRef.current.focus();
									}, 150);

								case 4:
								case 'end':
									return _context10.stop();
							}
						}
					}, _callee10, _this2);
				})));
			}, _this.swapAirports = function (e) {
				e.preventDefault();
				_this.setState({
					departureAirportSelection: _this.state.arrivalAirportSelection,
					arrivalAirportSelection: _this.state.departureAirportSelection
				}, _this.lookupAvailability);
			}, _this.clearSelectedSearchContent = function (props) {
				var nextErrors = (0, _extends12.default)({}, _this.state.errors || {});
				_this.setState((0, _extends12.default)({}, _this.getCalendarResetState(nextErrors), {
					departureAirportSelection: props.journey !== "arrival" ? { code: '', name: '', href: '' } : _this.state.departureAirportSelection,
					arrivalAirportSelection: { code: '', name: '', href: '' }
				}), _this.resetCalendarView);
			}, _this.onSuggestionsFetchRequested = function (_ref19) {
				var value = _ref19.value,
				    reason = _ref19.reason;

				_this.setState({
					departureSuggestions: reason == 'input-focused' ? getSuggestions('', _this.props.displayInputAirportCode, _this.props.displayInputAirportCodeFormat) : getSuggestions(value, _this.props.displayInputAirportCode, _this.props.displayInputAirportCodeFormat)
					//suggestions: getSuggestions(value)
				});
			}, _this.onSuggestionsFetchRequestedMatch = function (_ref20) {
				var value = _ref20.value,
				    reason = _ref20.reason;

				_this.setState({
					arrivalSuggestions: reason == 'input-focused' ? getSuggestionsMatch('', _this.state.departureAirportSelection, _this.props.displayInputAirportCode, _this.props.displayInputAirportCodeFormat) : getSuggestionsMatch(value, _this.state.departureAirportSelection, _this.props.displayInputAirportCode, _this.props.displayInputAirportCodeFormat)
				});
			}, _this.onSuggestionsClearRequested = function () {
				_this.setState({
					suggestions: [],
					departureSuggestions: [],
					arrivalSuggestions: []
				});
			}, _this.onChangeForm = function (e) {
				_this.setState({ value: e.target.value });
			}, _this.handleOptionChange = function (e) {
				if (_this.props.lockControlsWhileCalendarLoads.toLowerCase() === 'on' && _this.state.waitingForCalendar) return;
				if (e.target.value === 'mc') window.location = _this.state.soarUrl + '/home?searchType=multicity';
				var value = e.target.value;
				var cleanup = (0, _extends12.default)({}, _this.state.errors || {});
				if (value !== 'rt') delete cleanup.inboundDate;

				_this.setState({ tripType: e.target.value, errors: cleanup }, function () {
					_this.lookupAvailability();
					var loadedEvent = new CustomEvent('IASwidgetTripTypeUpdated', {
						detail: _this.state
					});
					window.dispatchEvent(loadedEvent);
				});
			}, _this.handleServiceChange = function (e) {
				_this.setState({ serviceType: e.target.value }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
					var loadedEvent;
					return _regenerator2.default.wrap(function _callee11$(_context11) {
						while (1) {
							switch (_context11.prev = _context11.next) {
								case 0:
									loadedEvent = new CustomEvent('IASwidgetCabinClassUpdated', {
										detail: _this.state
									});

									window.dispatchEvent(loadedEvent);

								case 2:
								case 'end':
									return _context11.stop();
							}
						}
					}, _callee11, _this2);
				})));
			}, _this.handleCurrencyChange = function (e) {
				if (_this.props.lockControlsWhileCalendarLoads.toLowerCase() === 'on' && _this.state.waitingForCalendar) return;
				_this.setState({ currency: e.target.value }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
					var loadedEvent;
					return _regenerator2.default.wrap(function _callee12$(_context12) {
						while (1) {
							switch (_context12.prev = _context12.next) {
								case 0:
									_this.refreshCalendar();
									loadedEvent = new CustomEvent('IASwidgetCurrencyUpdated', {
										detail: _this.state
									});

									window.dispatchEvent(loadedEvent);

								case 3:
								case 'end':
									return _context12.stop();
							}
						}
					}, _callee12, _this2);
				})));
			}, _this.handlePaxChange = function (e) {
				_this.setState({ paxCount: e.paxCount, paxTypes: e.paxTypes }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
					var loadedEvent;
					return _regenerator2.default.wrap(function _callee13$(_context13) {
						while (1) {
							switch (_context13.prev = _context13.next) {
								case 0:
									loadedEvent = new CustomEvent('IASwidgetPassengersUpdated', {
										detail: _this.state
									});

									window.dispatchEvent(loadedEvent);

								case 2:
								case 'end':
									return _context13.stop();
							}
						}
					}, _callee13, _this2);
				})));
			}, _this.onChangeDate = function (start, end) {
				var nextErrors = (0, _extends12.default)({}, _this.state.errors || {});
				var hasOutbound = !!start && (0, _dayjs2.default)(start).isValid();
				var hasInbound = !!end && (0, _dayjs2.default)(end).isValid();
				var isRT = _this.state.tripType === 'rt';
				var currentOutboundDate = (0, _dayjs2.default)(_this.state.outboundDate);
				var outboundDateChanged = hasOutbound && (!currentOutboundDate.isValid() || !currentOutboundDate.isSame(start, 'day'));
				if (hasOutbound) delete nextErrors.outboundDate;
				if (!isRT || hasInbound) delete nextErrors.inboundDate; // clear if one-way OR valid return


				try {
					if (_this.props.showAvailableDates == 'off' || _this.state.gatewayDirect) {
						_this.setState({
							outboundDate: start,
							inboundDate: end,
							errors: nextErrors
						}, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
							var loadedEvent;
							return _regenerator2.default.wrap(function _callee14$(_context14) {
								while (1) {
									switch (_context14.prev = _context14.next) {
										case 0:
											loadedEvent = new CustomEvent('IASwidgetDateSelectionUpdated', {
												detail: _this.state
											});

											window.dispatchEvent(loadedEvent);
											if (outboundDateChanged) _this.handleDepartureChange(start);

										case 3:
										case 'end':
											return _context14.stop();
									}
								}
							}, _callee14, _this2);
						})));
						// if not searching for availability leave right away
						return false;
					}

					// check and see if additional JSON was provided.
					// if it's there check if citypair matches current search
					// if it matches then check if at least 1 of the flight numbers matches the json
					// add the date to the array to signify that when the date is selected it should send searches to amelia
					var _this$state3 = _this.state,
					    departureAirportSelection = _this$state3.departureAirportSelection,
					    arrivalAirportSelection = _this$state3.arrivalAirportSelection,
					    availableOutboundDates = _this$state3.availableOutboundDates,
					    availableInboundDates = _this$state3.availableInboundDates,
					    gatewaySearch = _this$state3.gatewaySearch,
					    tripType = _this$state3.tripType;


					var outboundAmeliaAvailable = true;
					var inboundAmeliaAvailable = true;

					if (globalExtraData && globalExtraData.gatewayOverride) {

						if (Object.keys(globalExtraData.gatewayOverride).includes(departureAirportSelection.code + '-' + arrivalAirportSelection.code)) {
							outboundAmeliaAvailable = false; // set to false here to so we have to set it back to go to amelia
							if (Object.keys(availableOutboundDates[departureAirportSelection.code + '-' + arrivalAirportSelection.code].flightMetaData).includes('' + start.format('YYYY-MM-DD'))) {
								// we have found that the selected outbound date is available in amelia. now check if the flight number matches one of the options from the JSON data.
								// if it matches then send the search to amelia (BUT both outbound AND inbound have to be available, otherwise send to gateway)
								var flightNumbersFromData = globalExtraData.gatewayOverride[departureAirportSelection.code + '-' + arrivalAirportSelection.code];
								var flightNumbersFromAPI = availableOutboundDates[departureAirportSelection.code + '-' + arrivalAirportSelection.code].flightMetaData['' + start.format('YYYY-MM-DD')].flightNumbers;

								var intersection = flightNumbersFromData.filter(function (element) {
									return flightNumbersFromAPI.includes(element);
								});
								if (intersection.length) outboundAmeliaAvailable = true;
							}
						}

						if (tripType == 'rt') {
							if (Object.keys(globalExtraData.gatewayOverride).includes(arrivalAirportSelection.code + '-' + departureAirportSelection.code)) {
								inboundAmeliaAvailable = false;
								if (Object.keys(availableInboundDates[arrivalAirportSelection.code + '-' + departureAirportSelection.code].flightMetaData).includes('' + end.format('YYYY-MM-DD'))) {
									// we have found that the selected outbound date is available in amelia. now check if the flight number matches one of the options from the JSON data.
									// if it matches then send the search to amelia (BUT both outbound AND inbound have to be available, otherwise send to gateway)
									var flightNumbersFromDataInbound = globalExtraData.gatewayOverride[arrivalAirportSelection.code + '-' + departureAirportSelection.code];
									var flightNumbersFromAPIInbound = availableInboundDates[arrivalAirportSelection.code + '-' + departureAirportSelection.code].flightMetaData['' + end.format('YYYY-MM-DD')].flightNumbers;

									var intersectionInbound = flightNumbersFromDataInbound.filter(function (element) {
										return flightNumbersFromAPIInbound.includes(element);
									});
									if (intersectionInbound.length) inboundAmeliaAvailable = true;
								}
							}
						}

						var sendToGateway = outboundAmeliaAvailable && inboundAmeliaAvailable ? false : true; // if both available in amelia

						_this.setState({
							outboundDate: start,
							inboundDate: end,
							gatewaySearch: sendToGateway,
							errors: nextErrors
						}, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15() {
							var loadedEvent;
							return _regenerator2.default.wrap(function _callee15$(_context15) {
								while (1) {
									switch (_context15.prev = _context15.next) {
										case 0:
											loadedEvent = new CustomEvent('IASwidgetDateSelectionUpdated', {
												detail: _this.state
											});

											window.dispatchEvent(loadedEvent);
											if (outboundDateChanged) _this.handleDepartureChange(start);

										case 3:
										case 'end':
											return _context15.stop();
									}
								}
							}, _callee15, _this2);
						})));
						return; // return otherwise go forward if gateway overide is not happening
					}

					// this is happening if it's checking available dates AND available dates are turned on
					_this.setState({
						outboundDate: start,
						inboundDate: end,
						errors: nextErrors
					}, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
						var loadedEvent;
						return _regenerator2.default.wrap(function _callee16$(_context16) {
							while (1) {
								switch (_context16.prev = _context16.next) {
									case 0:
										loadedEvent = new CustomEvent('IASwidgetDateSelectionUpdated', {
											detail: _this.state
										});

										window.dispatchEvent(loadedEvent);
										if (outboundDateChanged) _this.handleDepartureChange(start);

									case 3:
									case 'end':
										return _context16.stop();
								}
							}
						}, _callee16, _this2);
					})));
				} catch (e) {
					console.log("error", e);
				}
			}, _this.onChangeMonth = function (val) {
				var selectingOutbound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

				_this.setState({ calendarCurrentMonth: val }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17() {
					var outboundLiveDates, inboundLiveDates, loadedEvent, hasSelectedDeparture;
					return _regenerator2.default.wrap(function _callee17$(_context17) {
						while (1) {
							switch (_context17.prev = _context17.next) {
								case 0:
									if (!(_this.props.showAvailableDates == 'off')) {
										_context17.next = 2;
										break;
									}

									return _context17.abrupt('return', false);

								case 2:
									outboundLiveDates = [];
									inboundLiveDates = [];

									// check and see if month was already called for the city pair
									/* const outboundSearchExists = this.checkForCachedCall(true);
	        if(outboundSearchExists) return; */

									loadedEvent = new CustomEvent('IASwidgetCalendarPaged', {
										detail: _this.state
									});

									window.dispatchEvent(loadedEvent);

									hasSelectedDeparture = _this.state.tripType === 'rt' && (0, _dayjs2.default)(_this.state.outboundDate).isValid();

									_this.refreshCalendar({
										includeOutbound: selectingOutbound || !hasSelectedDeparture,
										includeReturn: !selectingOutbound && hasSelectedDeparture
									});

								case 8:
								case 'end':
									return _context17.stop();
							}
						}
					}, _callee17, _this2);
				})));
			}, _this.onPromoBlur = function (e) {
				var value = e.target.value;

				_this.setState({ promocode: value }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18() {
					var loadedEvent;
					return _regenerator2.default.wrap(function _callee18$(_context18) {
						while (1) {
							switch (_context18.prev = _context18.next) {
								case 0:
									loadedEvent = new CustomEvent('IASwidgetPromocodeUpdated', {
										detail: _this.state
									});

									window.dispatchEvent(loadedEvent);

								case 2:
								case 'end':
									return _context18.stop();
							}
						}
					}, _callee18, _this2);
				})));
			}, _this.onCalendarClose = function (e) {
				if (_this.state.autoAdvanceOptions && _this.state.autoAdvanceOptions.includes('passengers') && _this.passengerElementOptionsRef.current) delayMethodCall(function () {
					return _this.passengerElementOptionsRef.current.showPax();
				}, 150);
			}, _this.handleTravelQuestion = function (e) {
				var currentState = _this.state.travelQuestion;
				_this.setState({ travelQuestion: !currentState }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19() {
					var loadedEvent;
					return _regenerator2.default.wrap(function _callee19$(_context19) {
						while (1) {
							switch (_context19.prev = _context19.next) {
								case 0:
									loadedEvent = new CustomEvent('IASwidgetTravelQuestionUpdated', {
										detail: _this.state
									});

									window.dispatchEvent(loadedEvent);

								case 2:
								case 'end':
									return _context19.stop();
							}
						}
					}, _callee19, _this2);
				})));
			}, _this.validateRequired = function () {
				var _this$state4 = _this.state,
				    departureAirportSelection = _this$state4.departureAirportSelection,
				    arrivalAirportSelection = _this$state4.arrivalAirportSelection,
				    outboundDate = _this$state4.outboundDate,
				    inboundDate = _this$state4.inboundDate,
				    tripType = _this$state4.tripType;


				var errors = {};

				// 1) departure required
				if (!departureAirportSelection || !departureAirportSelection.code) {
					errors.departure = translations[_this.props.lang].departureAirportError;
				}

				// 2) arrival required
				if (!arrivalAirportSelection || !arrivalAirportSelection.code) {
					errors.arrival = translations[_this.props.lang].arrivalAirportError;
				}

				// 3) outbound date required
				var hasOutbound = _dayjs2.default.isDayjs(outboundDate) && outboundDate.isValid();
				if (!hasOutbound) {
					errors.outboundDate = translations[_this.props.lang].outboundDateError;
				}

				// 4) inbound required only for roundtrip
				var needsReturn = tripType === 'rt';
				var hasInbound = _dayjs2.default.isDayjs(inboundDate) && inboundDate.isValid();
				if (needsReturn && !hasInbound) {
					errors.inboundDate = translations[_this.props.lang].inboundDateError;
				}

				return errors;
			}, _this.onSubmit = function (e) {
				e.preventDefault();

				if (_this.props.fieldValidation.toLowerCase() === 'on') {
					var errors = _this.validateRequired();
					if (Object.keys(errors).length) {
						_this.setState({ errors: errors });
						return; // stop submit
					}
					// if no errors, clear any previous messages and continue as-is
					if (Object.keys(_this.state.errors || {}).length) _this.setState({ errors: {} });
				}

				var _this$state5 = _this.state,
				    departureAirportSelection = _this$state5.departureAirportSelection,
				    arrivalAirportSelection = _this$state5.arrivalAirportSelection,
				    currency = _this$state5.currency,
				    serviceType = _this$state5.serviceType,
				    inboundDate = _this$state5.inboundDate,
				    outboundDate = _this$state5.outboundDate,
				    promocode = _this$state5.promocode,
				    autoPromocodeValue = _this$state5.autoPromocodeValue,
				    travelQuestion = _this$state5.travelQuestion,
				    saleAffiliateId = _this$state5.saleAffiliateId,
				    tripType = _this$state5.tripType,
				    paxTypes = _this$state5.paxTypes,
				    gatewaySearch = _this$state5.gatewaySearch;


				var loadedEvent = new CustomEvent('IASwidgetFlightSearchSubmitted', {
					detail: _this.state
				});

				var derivedPromocodeValue = void 0;
				if (_this.state.autoPromocodeAssociation.toLowerCase() === 'on') {
					derivedPromocodeValue = autoPromocodeValue; // you can set the value because in this case the question isn't required
					if (_this.props.autoPromocodeRequireQuestion.toLowerCase() === 'on') {
						var acceptableQuestionState = travelQuestion ? 'active' : 'inactive';
						derivedPromocodeValue = acceptableQuestionState !== _this.props.travelQuestionAccept.toLowerCase() ? '' : autoPromocodeValue; // if the question must be answered true and it's false reset to nothing
					}
				}
				if (promocode !== '') derivedPromocodeValue = promocode; // if the user provided their own, do not override.

				// build the SOAR search string. We do this first since we have to deal with the gateway/interline negotiation
				var SOARdestinationUrl = _this.state.soarUrl;
				var SOARdestination = SOARdestinationUrl + '/direct-flight-search?cityPair=' + departureAirportSelection.code + '-' + arrivalAirportSelection.code + '&departure=' + outboundDate.format('YYYY-MM-DD');
				if (tripType == 'rt') SOARdestination = SOARdestination + ('&return=' + inboundDate.format('YYYY-MM-DD'));
				if (currency) SOARdestination = SOARdestination + ('&currency=' + currency);
				if (serviceType) SOARdestination = SOARdestination + ('&cabinClass=' + serviceType);
				if (derivedPromocodeValue) SOARdestination = SOARdestination + ('&promoCode=' + derivedPromocodeValue);
				if (saleAffiliateId) SOARdestination = SOARdestination + ('&saleAffiliateId=' + saleAffiliateId);
				if (_this.props.usePtc.toLowerCase() == 'on') {
					var ptcs = Object.keys(paxTypes).reduce(function (a, p) {
						var pax = p + ':' + paxTypes[p];
						a.push(pax);
						return a;
					}, []).join(',');
					SOARdestination = SOARdestination + ('&passengerCounts=' + ptcs);
				} else {
					var normalPax = Object.keys(paxTypes).reduce(function (a, p) {
						var pax = paxTypeMap[p].ngi + 'Count=' + paxTypes[p];
						a.push(pax);
						return a;
					}, []).join('&');
					SOARdestination = SOARdestination + ('&' + normalPax);
				}
				if (_this.props.lang) SOARdestination = SOARdestination + ('&language=' + _this.props.lang.toLowerCase());

				// if it's a gateway search process it first and leave
				if (gatewaySearch) {

					// figure out if it's time to use the new SOAR interline functionality
					if (_this.props.enableInterline.toLowerCase() === 'on' || (0, _dayjs2.default)().isAfter((0, _dayjs2.default)('2023-07-31'))) {
						SOARdestination = SOARdestination + '&expandInterlineSearch=true';
						window.dispatchEvent(loadedEvent);
						return window.location = SOARdestination; // get them booking now!
					}

					var gatewayLookUpStructure = _this.props.gatewayUrlLegacy.toLowerCase() === "on" ? 'ibe/availability.aspx' : 'Guest/Start';
					var destination = 'https://' + _this.props.gatewayEnv + '.dsolution.eu/' + _this.props.gatewayShortcode + '/dsuite/' + gatewayLookUpStructure + '?Origin=' + departureAirportSelection.code + '&DepDate=' + outboundDate.format('MM-DD-YYYY') + '&LAN=EN';
					if (arrivalAirportSelection.code != '•') destination = destination + ('&Destination=' + arrivalAirportSelection.code);
					if (tripType === 'rt') destination = destination + ('&ReturnDate=' + inboundDate.format('MM-DD-YYYY'));
					var gatewayPassengers = Object.keys(paxTypes).reduce(function (a, p) {
						var pax = paxTypeAltMap[p].gateway + '=' + paxTypes[p];
						a.push(pax);
						return a;
					}, []).join('&');
					destination = destination + ('&' + gatewayPassengers);
					window.dispatchEvent(loadedEvent);
					return window.location = destination; // get them booking now!
				}
				// if it's a search using the abb packaging ibe
				if (_this.props.abbPackagerUrl) {
					var abbRedirectUrlWithParams = _this.props.abbPackagerUrl + '/booking/select?type=' + (tripType === 'rt' ? 'return' : 'oneway') + '&origin=' + departureAirportSelection.code + '&destination=' + arrivalAirportSelection.code + '&departureDate=' + outboundDate.format('YYYY-MM-DD') + '&checkInDate=' + outboundDate.format('YYYY-MM-DD');
					if (tripType === 'rt') abbRedirectUrlWithParams = abbRedirectUrlWithParams + ('&returnDate=' + inboundDate.format('YYYY-MM-DD') + '&checkOutDate=' + inboundDate.format('YYYY-MM-DD'));
					var abbPassengers = Object.keys(paxTypes).reduce(function (a, p) {
						var pax = 'pax' + paxTypeAltMap[p].abbPackager + '=' + paxTypes[p];
						a.push(pax);
						return a;
					}, []).join('&');
					abbRedirectUrlWithParams = abbRedirectUrlWithParams + ('&' + abbPassengers);
					window.dispatchEvent(loadedEvent);
					return window.location = abbRedirectUrlWithParams; // get them booking now!
				}

				if (_this.props.ngi.toLowerCase() == 'mobile' && (0, _ismobilejs2.default)(window.navigator).any || _this.props.ngi.toLowerCase() == 'on') {
					window.dispatchEvent(loadedEvent);
					return window.location = SOARdestination; // get them booking now!
				}

				if (_this.props.ngi.toLowerCase() == 'mobile' && !(0, _ismobilejs2.default)(window.navigator).any || _this.props.ngi.toLowerCase() == 'off') {
					// this submits the form to the legacy IBE:
					if (departureAirportSelection.code !== "" && arrivalAirportSelection.code !== "" && outboundDate != "") {
						window.dispatchEvent(loadedEvent);
						if (_this.props.formAutoSubmit.toLowerCase() === 'on') e.target.submit();
					}
				}
			}, _this.validateForm = function (e) {}, _this.suggestDepartureRef = (0, _preact.createRef)(), _this.suggestArrivalRef = (0, _preact.createRef)(), _this.passengerElementOptionsRef = (0, _preact.createRef)(), _this.calendarRef = (0, _preact.createRef)(), _this.passengerModalIsOpen = { current: false }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
		}

		Widget.prototype.removeTrailingSlash = function removeTrailingSlash(url) {
			return url[url.length - 1] === '/' ? url.slice(0, -1) : url;
		};

		Widget.prototype.componentWillMount = function () {
			var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20() {
				var _this3 = this;

				var sc, clientTranslations, extraDataSet, extraDataParsed, env, cleanSoarUrl, cleanNGIUrl, parsedSoarURL, cachedApiResponses, soarCachedData, cityPairsToRemove, cityPairsToAllow, availableCityPairs, getCityPairIdentifier, getAirportFromCode, getAirportNameFromCode, gatewayCityPairsItems, existingCityPairIdentifiers, gatewayCityPairsOptions, newGatewayCityPairs, parseAirportNameTemplate, airportTemplate, cabinClasses, currencies, currency, allowedCurrencyIndexes, allowedCurrencies, derivedCurrency, paxTypeCodes, paxTypes, paxDefaultArray, paxMinMaxArray, ii, jj, temparrayDefault, paxDefaultObjectDef, chunkDef, i, j, temparray, paxMinMaxObject, chunk, paxDependenciesArray, paxDependenciesObject, paxDefaultObject, derivedCabinClass, defaultCabinClassFromAPI, firstMonth, initialMonth, fareFormats, autoAdvanceParsing, autoAdvanceParsed;
				return _regenerator2.default.wrap(function _callee20$(_context20) {
					while (1) {
						switch (_context20.prev = _context20.next) {
							case 0:
								(0, _utility.logToConsole)("Developer mode on", this.props);

								if (this.state.airline) {
									_context20.next = 3;
									break;
								}

								return _context20.abrupt('return', alert('Airline must be set before using widget: `data-prop-airline`'));

							case 3:

								try {
									sc = document.getElementById('flight-search-widget-translations');
									clientTranslations = JSON.parse(sc.innerHTML.replace(/^[\<][\S ]+|^[\/]\S+/gm, ""));

									if (sc) {
										Object.keys(clientTranslations).forEach(function (key) {
											// This extends the languages to be sure that if a client does not include a key the language will still load properly. Helpful for widget upgrades too!
											clientTranslations[key] = (0, _deepmerge2.default)(translations.en, clientTranslations[key]);
										});
										translations = (0, _deepmerge2.default)(translations, clientTranslations);
									}
									if (!clientTranslations.hasOwnProperty(this.props.lang)) this.props.lang = 'en';
								} catch (e) {
									(0, _utility.logToConsole)(e, this.props);
								}

								if (!translations[this.props.lang]) {
									this.props.lang = 'en';
								}

								try {
									extraDataSet = document.getElementById('flight-search-widget-data-extension');
									extraDataParsed = JSON.parse(extraDataSet.innerHTML.replace(/^[\<][\S ]+|^[\/]\S+/gm, ""));

									if (extraDataParsed) {
										globalExtraData = extraDataParsed;
									}
								} catch (e) {
									(0, _utility.logToConsole)(e, this.props);
								}

								env = this.props.environment.toLowerCase() === 'prod' ? '' : this.props.environment.toLowerCase();

								this.props.environment = env;
								cleanSoarUrl = this.removeTrailingSlash(this.props.soarUrl);
								cleanNGIUrl = this.removeTrailingSlash(this.props.ngiUrl);
								parsedSoarURL = (0, _utility.processMiniHandleBars)(this.props.soarUrl === "/" ? cleanNGIUrl : cleanSoarUrl, this.props);
								_context20.prev = 11;
								cachedApiResponses = void 0;

								if (!(this.props.preferCachedData.toLowerCase() === 'on')) {
									_context20.next = 29;
									break;
								}

								_context20.prev = 14;
								_context20.next = 17;
								return (0, _utility.getAPIGeneric)(parsedSoarURL + '/assets/cms/airlineData.json');

							case 17:
								soarCachedData = _context20.sent;

								cachedApiResponses = soarCachedData;
								_context20.next = 27;
								break;

							case 21:
								_context20.prev = 21;
								_context20.t0 = _context20['catch'](14);

								(0, _utility.logToConsole)(_context20.t0, this.props);
								// if we can't get the cached data fall back to the direct API calls
								_context20.next = 26;
								return (0, _utility.promisedProperties)({
									cityPairs: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'cityPairs' }),
									airports: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'airports' }),
									passengerTypeCodes: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'passengerTypeCodes' }),
									cabinClasses: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'cabinClasses' }),
									currencies: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'currencies' })
								});

							case 26:
								cachedApiResponses = _context20.sent;

							case 27:
								_context20.next = 32;
								break;

							case 29:
								_context20.next = 31;
								return (0, _utility.promisedProperties)({
									cityPairs: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'cityPairs' }),
									airports: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'airports' }),
									passengerTypeCodes: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'passengerTypeCodes' }),
									cabinClasses: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'cabinClasses' }),
									currencies: (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: env, endpoint: 'currencies' })
								});

							case 31:
								cachedApiResponses = _context20.sent;

							case 32:

								// filter cityPairs based on availability rules
								cityPairsToRemove = this.props.disabledCityPairs.replace(/\s/g, '').split(",");
								cityPairsToAllow = this.props.enabledCityPairs.replace(/\s/g, '').split(",");
								availableCityPairs = cachedApiResponses.cityPairs.reduce(function (acc, cp) {
									if (cityPairsToAllow[0] === "" && cityPairsToRemove[0] !== "" && !cityPairsToRemove.includes(cp.identifier)) acc.push(cp);
									if (cityPairsToAllow[0] !== "" && cityPairsToAllow.includes(cp.identifier)) acc.push(cp);
									if (cityPairsToAllow[0] === "" && cityPairsToRemove[0] === "") acc.push(cp);
									return acc;
								}, []);

								getCityPairIdentifier = function getCityPairIdentifier(cityPair) {
									if (cityPair.identifier) return cityPair.identifier;

									var departureCode = cityPair.departure && cityPair.departure.airport && cityPair.departure.airport.code;
									var arrivalCode = cityPair.arrival && cityPair.arrival.airport && cityPair.arrival.airport.code;
									return departureCode && arrivalCode ? departureCode + '-' + arrivalCode : null;
								};

								getAirportFromCode = function getAirportFromCode(code) {
									var item = cachedApiResponses.airports.find(function (a) {
										return a.code === code;
									});
									return item || false;
								};

								getAirportNameFromCode = function getAirportNameFromCode(code) {
									var item = cachedApiResponses.airports.find(function (a) {
										return a.code === code;
									});
									return item && item.name || false;
								};

								// add gateway city pairs


								gatewayCityPairsItems = this.props.gatewayCityPairs !== '' && this.props.gatewayCityPairs.replace(/\s/g, '').split(",") || [];
								existingCityPairIdentifiers = new Set(availableCityPairs.map(function (cityPair) {
									return getCityPairIdentifier(cityPair);
								}).filter(Boolean));
								gatewayCityPairsOptions = gatewayCityPairsItems.reduce(function (acc, item, i) {
									var pairs = item.split("-");
									var identifier = pairs[0] + '-' + pairs[1];
									if (!pairs[0] || !pairs[1]) return acc;

									var obj = {
										identifier: identifier,
										departure: {
											airport: {
												code: pairs[0],
												name: translations[_this3.props.lang].airportLocalization && translations[_this3.props.lang].airportLocalization[pairs[0]] || getAirportNameFromCode(pairs[0]) || "Name Missing",
												interline: true
											}
										},
										arrival: {
											airport: {
												code: pairs[1],
												name: translations[_this3.props.lang].airportLocalization && translations[_this3.props.lang].airportLocalization[pairs[1]] || getAirportNameFromCode(pairs[1]) || "Name Missing",
												interline: true
											}
										}
									};
									acc.push(obj);
									return acc;
								}, []);


								gatewayCityPairsControl = gatewayCityPairsOptions;

								newGatewayCityPairs = gatewayCityPairsOptions.filter(function (obj) {
									if (existingCityPairIdentifiers.has(obj.identifier)) {
										return false;
									}
									existingCityPairIdentifiers.add(obj.identifier);
									return true;
								});


								availableCityPairs = availableCityPairs.concat(newGatewayCityPairs);
								availableCityPairs.sort(function (a, b) {
									return a.departure.airport.name > b.departure.airport.name ? 1 : -1;
								}); // sort from a-z
								cityPairs = availableCityPairs;

								parseAirportNameTemplate = function parseAirportNameTemplate(airportCode, template) {
									var airportData = getAirportFromCode(airportCode);
									return airportData && (0, _utility.processMiniHandleBarsSmart)(template, airportData) || null;
								};

								airportTemplate = this.props.airportNameTemplate || null;


								airports = availableCityPairs.reduce(function (acc, cp) {
									var customDepartureAirportName = _this3.props.airportNameTemplate && parseAirportNameTemplate(cp.departure.airport.code, _this3.props.airportNameTemplate) || cp.departure.airport.name;
									var customArrivalAirportName = _this3.props.airportNameTemplate && parseAirportNameTemplate(cp.arrival.airport.code, _this3.props.airportNameTemplate) || cp.arrival.airport.name;
									var departure = acc.filter(function (a) {
										return a.code === cp.departure.airport.code;
									}) || [];
									cp.departure.airport.name = translations[_this3.props.lang].airportLocalization && translations[_this3.props.lang].airportLocalization[cp.departure.airport.code] || customDepartureAirportName;
									if (departure && departure.length == 0) acc.push(cp.departure.airport);
									var arrival = acc.filter(function (a) {
										return a.code === cp.arrival.airport.code;
									}) || [];
									cp.arrival.airport.name = translations[_this3.props.lang].airportLocalization && translations[_this3.props.lang].airportLocalization[cp.arrival.airport.code] || customArrivalAirportName;
									if (arrival && arrival.length == 0) acc.push(cp.arrival.airport);
									return acc;
								}, []);

								cabinClasses = null;
								currencies = null;
								currency = null;
								allowedCurrencyIndexes = this.props.allowCurrencies && this.props.allowCurrencies.replace(/\s/g, '').split(',') || null;
								allowedCurrencies = cachedApiResponses.currencies;


								if (allowedCurrencyIndexes) {
									allowedCurrencies = cachedApiResponses.currencies.reduce(function (acc, curr) {
										if (allowedCurrencyIndexes.includes(curr.code)) acc.push(curr);
										return acc;
									}, []);
								}

								if (cachedApiResponses.cabinClasses && cachedApiResponses.cabinClasses.length) cabinClasses = cachedApiResponses.cabinClasses;
								//if(cachedApiResponses.cabinClasses && cachedApiResponses.cabinClasses.length) this.setState({cabinClasses: cachedApiResponses.cabinClasses})

								if (cachedApiResponses.currencies && cachedApiResponses.currencies.length) {
									derivedCurrency = (0, _utility.deriveCurrency)(this.props.defaultCurrency, null, allowedCurrencies);

									currency = derivedCurrency;
								}

								paxTypeCodes = cachedApiResponses.passengerTypeCodes.map(function (ptc) {
									return ptc.code;
								}) || [];
								paxTypes = this.props.usePtc.toLowerCase() == 'on' ? this.props.ptcTypes.split(':') : Object.keys(paxTypeMap);
								paxDefaultArray = this.props.ptcDefault.match(/(\w+)|([0-9])*/g) || [];

								paxDefaultArray = paxDefaultArray.filter(function (x) {
									return x !== '';
								});

								paxMinMaxArray = this.props.ptcMinMax.match(/(\w+)|([0-9])\-([0-9])*/g) || [];
								ii = void 0, jj = void 0, temparrayDefault = void 0, paxDefaultObjectDef = {}, chunkDef = 2;
								i = void 0, j = void 0, temparray = void 0, paxMinMaxObject = {}, chunk = 3;


								for (ii = 0, jj = paxDefaultArray.length; ii < jj; ii += chunkDef) {
									temparrayDefault = paxDefaultArray.slice(ii, ii + chunkDef);
									paxDefaultObjectDef['' + temparrayDefault[0]] = { min: parseInt(temparrayDefault[1]) };
								}

								for (i = 0, j = paxMinMaxArray.length; i < j; i += chunk) {
									temparray = paxMinMaxArray.slice(i, i + chunk);
									paxMinMaxObject['' + temparray[0]] = { min: parseInt(temparray[1]), max: parseInt(temparray[2]) };
								}

								paxDependenciesArray = this.props.ptcDependencies ? this.props.ptcDependencies.split(':') : [];
								paxDependenciesObject = paxDependenciesArray.reduce(function (acc, item) {
									var parts = item.split('|');
									if (parts.length === 2 && parts[0] && parts[1]) {
										acc[parts[0]] = parts[1].split(',');
									}
									return acc;
								}, {});
								paxDefaultObject = paxTypes.reduce(function (acc, pt, i) {
									if (_this3.props.usePtc.toLowerCase() == 'on' && paxTypeCodes.length > 0) {
										if (paxTypeCodes.includes(pt)) acc[pt] = paxDefaultObjectDef[pt].min; // make sure PTC actually exists, then use the default min value for it
									} else {

										if (Object.keys(paxTypeMap).includes(pt)) acc[pt] = paxDefaultObjectDef[pt].min; // set the default min value for the pax type
									}
									return acc;
								}, {});
								derivedCabinClass = null;
								defaultCabinClassFromAPI = cabinClasses.find(function (cc) {
									return cc.code === _this3.props.defaultCabinClass;
								}); // if the specified default exists assign it or fallback

								if (cabinClasses.length) derivedCabinClass = ''; // if there is only 1 cabinClass make it the default
								if (defaultCabinClassFromAPI) derivedCabinClass = defaultCabinClassFromAPI; // if some value was found before then actually assign it

								firstMonth = this.state.calendarCurrentMonth;

								if (this.props.initialMonth) {
									initialMonth = (0, _dayjs2.default)(this.props.initialMonth);

									if (initialMonth.isAfter(this.state.calendarCurrentMonth)) firstMonth = initialMonth;
								}

								fareFormats = (0, _utility.parseCurrencyStringFormats)(this.props.fareFormatOverrides);
								autoAdvanceParsing = this.props.autoAdvance.split('|');
								autoAdvanceParsed = autoAdvanceParsing.length === 1 || autoAdvanceParsing.includes('off') ? null : autoAdvanceParsing;


								this.setState((0, _extends12.default)({
									airline: this.state.airline.toLowerCase(),
									soarUrl: parsedSoarURL,
									lang: this.props.lang,
									paxTypes: paxDefaultObject,
									useRTL: this.props.useRtl,
									calendarCurrentMonth: firstMonth,
									ptcMinMax: paxMinMaxObject,
									ptcDefault: paxDefaultObjectDef,
									ptcDependencies: paxDependenciesObject,
									autoAdvanceOptions: autoAdvanceParsed,
									env: env, dataLoaded: true,
									serviceType: derivedCabinClass.code || '' }, fareFormats && { "fareFormats": fareFormats }, cabinClasses && { "cabinClasses": cabinClasses }, currency && { "currency": currency }, allowedCurrencies && { "currencies": allowedCurrencies }), function () {
									var loadedEvent = new CustomEvent('IASwidgetDataLoaded', {
										detail: _this3.state
									});
									window.dispatchEvent(loadedEvent);
								});

								_context20.next = 84;
								break;

							case 81:
								_context20.prev = 81;
								_context20.t1 = _context20['catch'](11);

								(0, _utility.logToConsole)(_context20.t1, this.props);

							case 84:
							case 'end':
								return _context20.stop();
						}
					}
				}, _callee20, this, [[11, 81], [14, 21]]);
			}));

			function componentWillMount() {
				return _ref30.apply(this, arguments);
			}

			return componentWillMount;
		}();

		Widget.prototype.componentDidMount = function componentDidMount() {
			var _this4 = this;

			// For safety: Check if a ref was supplied
			if (this.suggestDepartureRef.current) {
				setTimeout(function () {
					var suggestDepartureRefDimensions = _this4.suggestDepartureRef.current.base.getBoundingClientRect();
					var ssuggestArrivalRefDimensions = _this4.suggestArrivalRef.current.base.getBoundingClientRect();
					_this4.setState({ suggestDepRect: suggestDepartureRefDimensions, suggestArrRect: ssuggestArrivalRefDimensions });
				}, 50);
			}
			(0, _utility.logToConsole)(this.state, this.props);

			var loadedEvent = new CustomEvent('IASwidgetLoaded', {
				detail: this.state
			});
			window.dispatchEvent(loadedEvent);

			// this callback was introduced to call actions on the parent container. specifically once the widget is mounted to the DOM then we show it.
			this.props.callback();
		};

		Widget.prototype.componentWillUnmount = function componentWillUnmount() {};

		Widget.prototype.checkForCachedCall = function checkForCachedCall(outbound) {
			var depAp = outbound ? this.state.cityPairSearch.outbound.dep : this.state.cityPairSearch.inbound.dep;
			var arrAp = outbound ? this.state.cityPairSearch.outbound.arr : this.state.cityPairSearch.inbound.arr;
			var monthLookup = (0, _dayjs2.default)(this.state.calendarCurrentMonth).format('MMMYY');

			if (!outbound) return this.state.inboundCachedApiCalls && this.state.inboundCachedApiCalls[depAp + '-' + arrAp] && this.state.inboundCachedApiCalls[depAp + '-' + arrAp].includes(monthLookup) || false;
			return this.state.outboundCachedApiCalls && this.state.outboundCachedApiCalls[depAp + '-' + arrAp] && this.state.outboundCachedApiCalls[depAp + '-' + arrAp].includes(monthLookup) || false;
		};

		Widget.prototype.queryCalendar = function () {
			var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(outbound, index, searchDates) {
				var isReturnCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
				var depAp, arrAp, monthLoop, daysInMonth, todayDay, todayDayIndex, totalDays, ep, depDateStr, responses;
				return _regenerator2.default.wrap(function _callee21$(_context21) {
					while (1) {
						switch (_context21.prev = _context21.next) {
							case 0:
								depAp = outbound ? this.state.cityPairSearch.outbound.dep : this.state.cityPairSearch.inbound.dep;
								arrAp = outbound ? this.state.cityPairSearch.outbound.arr : this.state.cityPairSearch.inbound.arr;
								monthLoop = searchDates.monthLoop, daysInMonth = searchDates.daysInMonth, todayDay = searchDates.todayDay, todayDayIndex = searchDates.todayDayIndex, totalDays = searchDates.totalDays;
								ep = void 0;

								if (isReturnCall && this.state.outboundDate) {
									depDateStr = (0, _dayjs2.default)(this.state.outboundDate).format('YYYY-MM-DD');

									ep = 'travelOptions?cityPair=' + depAp + '-' + arrAp + '&departure=' + depDateStr + '&currency=' + this.state.currency + '&daysAfterDeparture=0';
									if (this.props.companyKey !== "") ep += '&company=' + this.props.companyKey;
									ep += '&return=' + (0, _dayjs2.default)(todayDay).format('YYYY-MM-DD') + '&daysAfterReturn=' + totalDays;
								} else {
									ep = 'travelOptions?cityPair=' + depAp + '-' + arrAp + '&departure=' + (0, _dayjs2.default)(todayDay).format('YYYY-MM-DD') + '&currency=' + this.state.currency + '&daysAfterDeparture=' + totalDays;
									if (this.props.companyKey !== "") ep += '&company=' + this.props.companyKey;
									if (this.state.tripType === "rt") ep += '&return=' + (0, _dayjs2.default)(todayDay).format('YYYY-MM-DD') + '&daysAfterReturn=0';
								}

								if (this.props.usePtc.toLowerCase() === 'on') {
									ep += '&passengerCounts=ADT:1';
								} else {
									ep += '&adultCount=1&childCount=0&infantCount=0';
								}

								/* //this is for testing API errors
	       var items = [
	       	ep,
	       	ep,
	       	ep,
	       	"travelOptions",
	       	ep,
	       	"travelOptions",
	       	ep
	       ]
	       var item = items[Math.floor(Math.random()*items.length)]; */

								_context21.next = 8;
								return (0, _utility.callAPI)({ apiSetting: this.props.apiSetting, shortname: this.state.airline, env: this.state.env, endpoint: ep });

							case 8:
								responses = _context21.sent;
								return _context21.abrupt('return', responses);

							case 10:
							case 'end':
								return _context21.stop();
						}
					}
				}, _callee21, this);
			}));

			function queryCalendar(_x22, _x23, _x24) {
				return _ref31.apply(this, arguments);
			}

			return queryCalendar;
		}();

		Widget.prototype.handleDepBlur = function handleDepBlur(event, _ref32) {
			var highlightedSuggestion = _ref32.highlightedSuggestion;

			// this has been added to catch wrongful data entry. it will automatically select the first matching option!
			var foundAirport = getSuggestions(event.target.value, this.props.displayInputAirportCode, this.props.displayInputAirportCodeFormat);
			this.setState({
				departureAirportSelection: foundAirport.length ? (0, _extends12.default)({}, foundAirport[0], { name: getSuggestionValue(foundAirport[0], this.props.displayInputAirportCode, this.props.displayInputAirportCodeFormat) }) : { name: "", code: "" }
			});

			// the code below could potentially be removed.
			if (highlightedSuggestion && this.state.departureAirportSelection.name) {
				this.setState({
					departureAirportSelection: (0, _extends12.default)({}, highlightedSuggestion, { name: getSuggestionValue(highlightedSuggestion, this.props.displayInputAirportCode, this.props.displayInputAirportCodeFormat) })
				});
			}
		};

		Widget.prototype.handleArrBlur = function handleArrBlur(event, _ref33) {
			var highlightedSuggestion = _ref33.highlightedSuggestion;

			// same as depature but looks up corresponding
			var foundAirport = getSuggestionsMatch(event.target.value, this.state.departureAirportSelection, this.props.displayInputAirportCode, this.props.displayInputAirportCodeFormat);
			this.setState({
				arrivalAirportSelection: foundAirport.length ? (0, _extends12.default)({}, foundAirport[0], { name: getSuggestionValue(foundAirport[0], this.props.displayInputAirportCode, this.props.displayInputAirportCodeFormat) }) : { name: "", code: "" }
			}, function () {
				//this.lookupAvailability() 
			});

			if (!foundAirport.length) return;

			if (highlightedSuggestion && this.state.arrivalAirportSelection.name) {
				this.setState({
					arrivalAirportSelection: (0, _extends12.default)({}, highlightedSuggestion, { name: getSuggestionValue(highlightedSuggestion, this.props.displayInputAirportCode, this.props.displayInputAirportCodeFormat) })
				}, function () {
					//this.lookupAvailability() 
				});
			}
		};

		Widget.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
			var _this5 = this;

			/* console.log("componentWillReceiveProps nextProps",nextProps)
	  console.log("componentWillReceiveProps nextState",nextState) */

			if (this.props.lang !== nextProps.lang && translations[nextProps.lang]) {
				cityPairs = cityPairs.map(function (cp) {
					cp.departure.airport.name = translations[nextProps.lang].airportLocalization && translations[nextProps.lang].airportLocalization[cp.departure.airport.code] || cp.departure.airport.name;
					cp.arrival.airport.name = translations[nextProps.lang].airportLocalization && translations[nextProps.lang].airportLocalization[cp.arrival.airport.code] || cp.arrival.airport.name;
					return cp;
				}, []);

				airports = cityPairs.reduce(function (acc, cp) {
					var departure = acc.filter(function (a) {
						return a.code === cp.departure.airport.code;
					});
					cp.departure.airport.name = translations[nextProps.lang].airportLocalization && translations[nextProps.lang].airportLocalization[cp.departure.airport.code] || cp.departure.airport.name;
					if (departure.length == 0) acc.push(cp.departure.airport);
					return acc;
				}, []);
			}

			if (!translations[this.props.lang]) {
				this.props.lang = 'en';
				nextProps.lang = 'en';
			}

			var derivedCurrency = this.state.currency;
			if (this.state.currencies && this.state.currencies.length) derivedCurrency = (0, _utility.deriveCurrency)(nextProps.defaultCurrency, this.state.currency, this.state.currencies);

			var incomingDeparture = airports.find(function (ap) {
				return ap.code === (nextProps.departureAirport ? nextProps.departureAirport.code : null);
			}) || null;
			var incomingArrival = airports.find(function (ap) {
				return ap.code === (nextProps.arrivalAirport ? nextProps.arrivalAirport.code : null);
			}) || null;

			this.setState((0, _extends12.default)({
				lang: nextProps.lang,
				currency: derivedCurrency
			}, nextProps.showCurrencies !== this.props.showCurrencies && { showCurrencies: nextProps.showCurrencies }, nextProps.promocode !== this.props.promocode && { promocode: nextProps.promocode }, nextProps.tripType !== this.props.tripType && { tripType: nextProps.tripType }, nextProps.showPromocode !== this.props.showPromocode && { showPromocode: nextProps.showPromocode }, nextProps.saleAffiliateId !== this.props.saleAffiliateId && { saleAffiliateId: nextProps.saleAffiliateId }, nextProps.autoPromocodeAssociation !== this.props.autoPromocodeAssociation && { autoPromocodeAssociation: nextProps.autoPromocodeAssociation }, incomingDeparture && { departureAirportSelection: (0, _extends12.default)({}, incomingDeparture, { name: getSuggestionValue(incomingDeparture, nextProps.displayInputAirportCode, nextProps.displayInputAirportCodeFormat) }) }, incomingArrival && { arrivalAirportSelection: (0, _extends12.default)({}, incomingArrival, { name: getSuggestionValue(incomingArrival, nextProps.displayInputAirportCode, nextProps.displayInputAirportCodeFormat) }) }), (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22() {
				var loadedEvent;
				return _regenerator2.default.wrap(function _callee22$(_context22) {
					while (1) {
						switch (_context22.prev = _context22.next) {
							case 0:
								if (_this5.state.departureAirportSelection.code !== '' && _this5.state.arrivalAirportSelection.code !== '') {
									_this5.lookupAvailability();
								}

								loadedEvent = new CustomEvent('IASwidgetUpdateComplete', {
									detail: _this5.state
								});

								window.dispatchEvent(loadedEvent);

							case 3:
							case 'end':
								return _context22.stop();
						}
					}
				}, _callee22, _this5);
			})));
		};

		Widget.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
			// DO NOT USE THIS FOR UPDATING FROM INCOMING PROPS, USE componentWillReceiveProps INSTEAD
			/* console.log("nextProps",nextProps)
	  console.log("nextState",nextState) */
		};

		Widget.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
			/* console.log("this.props componentDidUpdate prev",prevProps)
	  console.log("this.props componentDidUpdate",this.props) */
		};

		Widget.prototype.componentDidCatch = function componentDidCatch(error) {};

		Widget.prototype.render = function render() {
			var _this6 = this;

			var _state = this.state,
			    suggestions = _state.suggestions,
			    departureSuggestions = _state.departureSuggestions,
			    arrivalSuggestions = _state.arrivalSuggestions,
			    cabinClasses = _state.cabinClasses,
			    currencies = _state.currencies,
			    currency = _state.currency,
			    passengerTypeCodes = _state.passengerTypeCodes,
			    paxCount = _state.paxCount,
			    paxTypes = _state.paxTypes,
			    ptcDefault = _state.ptcDefault,
			    ptcMinMax = _state.ptcMinMax,
			    departureAirportSelection = _state.departureAirportSelection,
			    arrivalAirportSelection = _state.arrivalAirportSelection,
			    serviceType = _state.serviceType,
			    inboundDate = _state.inboundDate,
			    outboundDate = _state.outboundDate,
			    availableInboundDates = _state.availableInboundDates,
			    availableOutboundDates = _state.availableOutboundDates,
			    promocode = _state.promocode,
			    tripType = _state.tripType,
			    showPaxModal = _state.showPaxModal,
			    showLowestFare = _state.showLowestFare,
			    dimensions = _state.dimensions,
			    formValidated = _state.formValidated;

			var calendarControlLockEnabled = this.props.lockControlsWhileCalendarLoads.toLowerCase() === 'on';
			var calendarControlsDisabled = calendarControlLockEnabled && this.state.waitingForCalendar;

			var _state$dimensions = this.state.dimensions,
			    width = _state$dimensions.width,
			    height = _state$dimensions.height,
			    windowWidth = _state$dimensions.windowWidth;
			/* const className = classNames(width < 400 && 'small-width-modifier') */

			var containerClasses = {
				'ias-search-widget': true,
				'notranslate': true,
				'rtlStyles': this.state.useRTL.toLowerCase() === "on" ? true : false,
				'prestyled': this.props.preStyling.toLowerCase() === "on" ? true : false,
				'validate': this.props.fieldValidation.toLowerCase() === "on" ? true : false,
				'horizontal': width > this.props.horizontalBreakpoint,
				'vertical': width < this.props.horizontalBreakpoint,
				'drop': windowWidth < 768
			};

			var filteredContainerClasses = Object.keys(containerClasses).reduce(function (a, c) {
				if (containerClasses[c]) a.push(c);
				return a;
			}, []).join(" ");

			var getSuggestionValueBound = function getSuggestionValueBound(suggestion) {
				return getSuggestionValue(suggestion, _this6.props.displayInputAirportCode, _this6.props.displayInputAirportCodeFormat);
			};

			// Autosuggest will pass through all these props to the input.
			var departureProps = {
				placeholder: translations[this.state.lang].departureAirportPlaceholder,
				value: departureAirportSelection.name,
				className: 'form-control',
				onChange: this.onChangeDeparture,
				onBlur: this.handleDepBlur.bind(this),
				id: this.state.uniqueValue + '-departure',
				closeMethod: this.clearSelectedSearchContent,
				journey: "departure",
				dataIsLoaded: this.state.dataLoaded
			};
			var arrivalProps = {
				placeholder: translations[this.state.lang].arrivalAirportPlaceholder,
				value: arrivalAirportSelection.name,
				className: 'form-control',
				onChange: this.onChangeArrival,
				onBlur: this.handleArrBlur.bind(this),
				id: this.state.uniqueValue + '-arrival',
				closeMethod: this.clearSelectedSearchContent,
				journey: "arrival",
				dataIsLoaded: this.state.dataLoaded
			};

			return (0, _preact.h)(
				_reactMeasure2.default,
				{
					bounds: true,
					onResize: function onResize(contentRect) {
						contentRect.bounds.windowWidth = window.innerWidth;
						_this6.setState({ dimensions: contentRect.bounds });
					}
				},
				function (_ref35) {
					var measureRef = _ref35.measureRef;
					return (0, _preact.h)(
						'div',
						{ ref: measureRef, 'class': filteredContainerClasses, translate: false },
						(0, _preact.h)(
							'form',
							{
								onKeyDownCapture: function onKeyDownCapture(e) {
									var tag = e.target.tagName;
									var type = e.target.type;
									var isTextArea = tag === 'TEXTAREA';
									var isSubmitButton = tag === 'BUTTON' && type === 'submit';
									var isInputSubmit = tag === 'INPUT' && type === 'submit';
									var isSelect = tag === 'SELECT';
									var paxModalOpen = _this6.passengerModalIsOpen && _this6.passengerModalIsOpen.current;

									// STOP enter from submitting if it's not explicitly meant to
									if (e.key === 'Enter' && !isSubmitButton && !isInputSubmit && !isTextArea && !paxModalOpen) {
										if (isSelect) {
											// For native selects, prevent accidental submit
											e.preventDefault();
											// Optionally trigger open? Usually not needed
										} else {
											e.preventDefault();
										}
									}
								},

								onChange: function onChange(event) {
									return _this6.validateForm(event.target.value);
								}, onInput: _this6.validateForm, onSubmit: _this6.onSubmit, method: 'post', action: _this6.props.ngi.toLowerCase() !== 'on' ? '' + _this6.props.ibeUrl + _this6.props.formAction + '?lang=' + _this6.props.lang : '#' },
							(0, _preact.h)(
								'div',
								{ 'class': 'fieldset airportSelection ' + (_this6.props.containAutosuggestScroll.toLowerCase() === "on" ? 'maskAutoSuggestScroll' : '') },
								(0, _preact.h)(
									'div',
									{ 'class': 'departureAirport' },
									(0, _preact.h)(
										'label',
										{ 'class': 'primary--label', 'for': _this6.state.uniqueValue + '-departure' },
										translations[_this6.props.lang].departureAirportLabel
									),
									(0, _preact.h)(_reactAutosuggest2.default, {
										ref: _this6.suggestDepartureRef,
										id: _this6.state.uniqueValue + '-departure',
										suggestions: departureSuggestions,
										onSuggestionsFetchRequested: _this6.onSuggestionsFetchRequested,
										onSuggestionsClearRequested: _this6.onSuggestionsClearRequested,
										onSuggestionSelected: _this6.departureSelected,
										getSuggestionValue: getSuggestionValueBound,
										renderSuggestion: renderSuggestion,
										renderInputComponent: renderInputComponent,
										renderSuggestionsContainer: _this6.renderSuggestionsContainerDep,
										shouldRenderSuggestions: shouldRenderSuggestions,
										inputProps: departureProps,
										highlightFirstSuggestion: false
									}),
									(0, _preact.h)(
										'div',
										{ 'class': 'departure-errors' },
										_this6.state.errors && _this6.state.errors.departure && (0, _preact.h)(
											'div',
											{ 'class': 'field-error', role: 'alert' },
											_this6.state.errors.departure
										)
									)
								),
								(0, _preact.h)(
									'div',
									{ 'class': 'swapAirports' },
									(0, _preact.h)(
										'a',
										{ href: '#', tabindex: '-1', onClick: _this6.swapAirports },
										'\u21C4'
									)
								),
								(0, _preact.h)(
									'div',
									{ 'class': 'arrivalAirport' },
									(0, _preact.h)(
										'label',
										{ 'class': 'primary--label', 'for': _this6.state.uniqueValue + '-arrival' },
										translations[_this6.props.lang].arrivalAirportLabel
									),
									(0, _preact.h)(_reactAutosuggest2.default, {
										id: _this6.state.uniqueValue + '-arrival',
										ref: _this6.suggestArrivalRef,
										suggestions: arrivalSuggestions,
										onSuggestionsFetchRequested: _this6.onSuggestionsFetchRequestedMatch,
										onSuggestionsClearRequested: _this6.onSuggestionsClearRequested,
										onSuggestionSelected: _this6.arrivalSelected,
										getSuggestionValue: getSuggestionValueBound,
										renderSuggestion: renderSuggestion,
										renderInputComponent: renderInputComponent,
										renderSuggestionsContainer: _this6.renderSuggestionsContainerArr,
										shouldRenderSuggestions: shouldRenderSuggestions,
										inputProps: arrivalProps,
										highlightFirstSuggestion: false
									}),
									(0, _preact.h)(
										'div',
										{ 'class': 'arrival-errors' },
										_this6.state.errors && _this6.state.errors.arrival && (0, _preact.h)(
											'div',
											{ 'class': 'field-error', role: 'alert' },
											_this6.state.errors.arrival
										)
									)
								)
							),
							(0, _preact.h)(
								'div',
								{ 'class': 'fieldset dateSelection' },
								(0, _preact.h)(
									'label',
									{ 'class': 'primary--label', 'for': _this6.state.uniqueValue + '-dateRange' },
									translations[_this6.props.lang].dateSelectionLabel
								),
								(0, _preact.h)(_Calendar2.default, {
									ref: _this6.calendarRef,
									tripType: tripType,
									shortname: _this6.state.airline,
									env: _this6.state.env,
									cabinClass: serviceType,
									currency: currency,
									cityPairSearch: _this6.state.cityPairSearch,
									cityPairOutbound: _this6.state.cityPairSearch.outbound && _this6.state.cityPairSearch.outbound.dep ? _this6.state.cityPairSearch.outbound.dep + '-' + _this6.state.cityPairSearch.outbound.arr : '',
									cityPairInbound: _this6.state.cityPairSearch.inbound && _this6.state.cityPairSearch.inbound.dep ? _this6.state.cityPairSearch.inbound.dep + '-' + _this6.state.cityPairSearch.inbound.arr : '',
									outboundDate: outboundDate,
									inboundDate: inboundDate,
									outboundDates: availableOutboundDates,
									inboundDates: availableInboundDates,
									updateTravelDates: _this6.onChangeDate,
									updateCalendarMonth: _this6.onChangeMonth,
									callOnCalendarClose: _this6.onCalendarClose,
									dateFormat: _this6.props.dateFormat,
									startOnMonday: _this6.props.startOnMonday == "on" ? 1 : 0,
									calendarLabels: translations[_this6.props.lang].calendarLabels,
									translations: translations[_this6.props.lang],
									lang: _this6.props.lang,
									showAvailableDates: _this6.state.showAvailableDates,
									showLowestFare: _this6.state.showLowestFare,
									showSoldoutDates: _this6.state.showSoldoutDates,
									listPosition: _this6.props.listPosition,
									horizontalBreakpoint: _this6.props.horizontalBreakpoint,
									isMobile: (0, _ismobilejs2.default)(window.navigator).any,
									componentDimensions: dimensions,
									autoDrop: containerClasses.drop,
									initialMonth: _this6.state.calendarCurrentMonth,
									desktopViewableMonths: _this6.props.desktopViewableMonths,
									mobileViewableMonths: _this6.props.mobileViewableMonths,
									calendarYearFormat: _this6.props.calendarYearFormat,
									uniqueValue: _this6.state.uniqueValue,
									departure: _this6.state.departureAirportSelection.code,
									arrival: _this6.state.arrivalAirportSelection.code,
									waitingForCalendar: calendarControlsDisabled,
									showLoadingIndicator: calendarControlsDisabled,
									cachedApiCalls: _this6.state.cachedApiCalls,
									dateErrors: {
										outbound: _this6.state.errors && _this6.state.errors.outboundDate ? _this6.state.errors.outboundDate : '',
										inbound: _this6.state.tripType === 'rt' && _this6.state.errors && _this6.state.errors.inboundDate ? _this6.state.errors.inboundDate : ''
									},
									clearDateError: function clearDateError(field) {
										var next = _this6.state.errors ? (0, _extends12.default)({}, _this6.state.errors) : {};
										if (next[field]) {
											delete next[field];
											_this6.setState({ errors: next });
										}
									}
								})
							),
							(0, _preact.h)(_TripTypeInput2.default, {
								translations: translations,
								tripType: tripType,
								tripTypeOptions: _this6.state.tripTypeOptions,
								tripTypeDisplay: _this6.props.tripTypeDisplay,
								lang: _this6.props.lang,
								disabled: calendarControlsDisabled,
								showLoadingIndicator: calendarControlsDisabled,
								handleTripChange: _this6.handleOptionChange,
								uniqueValue: _this6.state.uniqueValue
							}),
							paxTypes && (0, _preact.h)(_PassengersInput2.default, {
								ref: _this6.passengerElementOptionsRef,
								paxModalOpenRef: _this6.passengerModalIsOpen,
								translations: translations,
								paxTypes: paxTypes,
								ptcDefault: ptcDefault,
								ptcMinMax: ptcMinMax,
								ptcDependencies: _this6.state.ptcDependencies,
								ptcTotalMax: _this6.props.ptcTotalMax,
								lang: _this6.props.lang,
								handlePaxChange: _this6.handlePaxChange,
								dataIsLoaded: _this6.state.dataLoaded,
								uniqueValue: _this6.state.uniqueValue
							}),
							(0, _preact.h)(
								'div',
								{ 'class': 'fieldset cabinClassSelection' },
								_this6.props.showCabinClass.toLowerCase() == 'on' && (0, _preact.h)(
									_preact.Fragment,
									null,
									(0, _preact.h)(
										'label',
										{ 'class': 'primary--label', 'for': _this6.state.uniqueValue + '-cabinClassSelection' },
										translations[_this6.props.lang].cabinClassLabel
									),
									_this6.state.dataLoaded && (0, _preact.h)(
										'select',
										{
											'class': 'select-css form-control',
											id: _this6.state.uniqueValue + '-cabinClassSelection',
											value: serviceType,
											onChange: _this6.handleServiceChange
										},
										(0, _preact.h)(
											'option',
											{ value: '', selected: !_this6.state.serviceType },
											translations[_this6.props.lang].cabinClassAllClassesOption
										),
										cabinClasses.map(function (cc, i) {
											var code = cc && cc.code ? cc.code : '';
											var apiDesc = cc && cc.description ? cc.description : code;
											var t = translations[_this6.props.lang] && translations[_this6.props.lang].cabinClasses && translations[_this6.props.lang].cabinClasses[code];

											var label = (t || '').trim() || apiDesc;

											return (0, _preact.h)(
												'option',
												{ key: code || 'cc-' + i, value: code },
												label
											);
										})
									),
									!_this6.state.dataLoaded && (0, _preact.h)(
										'div',
										{
											'class': 'form-control' },
										(0, _preact.h)(
											'div',
											{ 'class': 'load-parent--wrapper' },
											(0, _preact.h)(_utility.LoadingSvg, null)
										)
									)
								)
							),
							(0, _preact.h)(
								'div',
								{ 'class': 'fieldset currenciesSelection' },
								_this6.state.showCurrencies.toLowerCase() == 'on' && (0, _preact.h)(
									_preact.Fragment,
									null,
									(0, _preact.h)(
										'label',
										{ 'class': 'primary--label', 'for': _this6.state.uniqueValue + '-currenciesSelection' },
										translations[_this6.props.lang].currenciesLabel
									),
									calendarControlsDisabled && (0, _preact.h)(
										'div',
										{
											'class': 'control-loading-indicator is-visible',
											role: 'status',
											'aria-label': 'Loading live prices'
										},
										(0, _preact.h)(
											'span',
											{ 'class': 'control-loading-indicator__spinner', 'aria-hidden': 'true' },
											(0, _preact.h)(_utility.LoadingSvg, null)
										)
									),
									_this6.state.dataLoaded && (0, _preact.h)(
										'select',
										{
											'class': 'select-css form-control',
											id: _this6.state.uniqueValue + '-currenciesSelection',
											value: currency,
											disabled: calendarControlsDisabled,
											onChange: _this6.handleCurrencyChange
										},
										currencies.map(function (cc, i) {
											var code = cc && cc.code ? cc.code : '';
											var apiDesc = cc && cc.description ? cc.description : code;
											var t = translations[_this6.props.lang] && translations[_this6.props.lang].currencies && translations[_this6.props.lang].currencies[code];

											var label = (t || '').trim() || apiDesc;

											return (0, _preact.h)(
												'option',
												{ key: code || 'cc-' + i, value: code },
												label
											);
										})
									),
									!_this6.state.dataLoaded && (0, _preact.h)(
										'div',
										{
											'class': 'form-control' },
										(0, _preact.h)(
											'div',
											{ 'class': 'load-parent--wrapper' },
											(0, _preact.h)(_utility.LoadingSvg, null)
										)
									)
								)
							),
							(0, _preact.h)(
								'div',
								{ 'class': 'fieldset promocodeField' },
								_this6.state.showPromocode.toLowerCase() == 'on' && (0, _preact.h)(
									_preact.Fragment,
									null,
									(0, _preact.h)(
										'label',
										{ 'class': 'primary--label', 'for': _this6.state.uniqueValue + '-promocode' },
										translations[_this6.props.lang].promocodeLabel
									),
									(0, _preact.h)('input', { id: _this6.state.uniqueValue + '-promocode', type: 'text', name: 'promocode', className: 'form-control', placeholder: translations[_this6.props.lang].promocodePlaceholder, value: promocode, onBlur: _this6.onPromoBlur })
								)
							),
							(0, _preact.h)(
								'div',
								{ 'class': 'fieldset travelQuestion' },
								_this6.props.travelQuestion.toLowerCase() == 'on' && (0, _preact.h)(
									_preact.Fragment,
									null,
									(0, _preact.h)(
										'div',
										{ 'class': 'checkbox-wrapper form-check' },
										(0, _preact.h)('input', { 'class': 'form-check-input', type: 'checkbox', defaultChecked: _this6.state.travelQuestion, id: 'travelQuestion-' + _this6.state.uniqueValue + '-toggle', value: _this6.state.travelQuestion, onChange: _this6.handleTravelQuestion }),
										(0, _preact.h)(
											'label',
											{ 'class': 'form-check-label', 'for': 'travelQuestion-' + _this6.state.uniqueValue + '-toggle' },
											(0, _preact.h)(
												'span',
												{ 'class': '' },
												translations[_this6.props.lang].travelQuestionLabel
											)
										)
									)
								)
							),
							(0, _preact.h)(
								'div',
								{ 'class': 'fieldset formSubmit' },
								(0, _preact.h)('input', { type: 'hidden', value: tripType === 'rt' ? 'on' : '', name: 'chkRoundTrip' }),
								(0, _preact.h)('input', { type: 'hidden', value: departureAirportSelection.code, name: 'lstOrigAP' }),
								(0, _preact.h)('input', { type: 'hidden', value: arrivalAirportSelection.code, name: 'lstDestAP' }),
								(0, _preact.h)('input', { type: 'hidden', value: (0, _dayjs2.default)(outboundDate).isValid() ? outboundDate.format('YYYY-MM-DD') : '', name: 'dlstDepDate' }),
								(0, _preact.h)('input', { type: 'hidden', value: (0, _dayjs2.default)(outboundDate).isValid() ? outboundDate.format('DD') : '', name: 'dlstDepDate_Day' }),
								(0, _preact.h)('input', { type: 'hidden', value: (0, _dayjs2.default)(outboundDate).isValid() ? outboundDate.format('YYYY/MM') : '', name: 'dlstDepDate_Month' }),
								(0, _preact.h)('input', { type: 'hidden', value: 2, name: 'lstDepDateRange' }),
								(0, _preact.h)('input', { type: 'hidden', value: (0, _dayjs2.default)(inboundDate).isValid() ? inboundDate.format('YYYY-MM-DD') : '', name: 'dlstRetDate' }),
								(0, _preact.h)('input', { type: 'hidden', value: (0, _dayjs2.default)(inboundDate).isValid() ? inboundDate.format('DD') : '', name: 'dlstRetDate_Day' }),
								(0, _preact.h)('input', { type: 'hidden', value: (0, _dayjs2.default)(inboundDate).isValid() ? inboundDate.format('YYYY/MM') : '', name: 'dlstRetDate_Month' }),
								(0, _preact.h)('input', { type: 'hidden', value: 2, name: 'lstRetDateRange' }),
								(0, _preact.h)('input', { type: 'hidden', value: serviceType == 'Y' ? 1 : 2, name: 'lstLvlService' }),
								(0, _preact.h)('input', { type: 'hidden', value: currency, name: 'lstResCurrency' }),
								(0, _preact.h)('input', { type: 'hidden', value: currency, name: 'lstCurrency' }),
								(0, _preact.h)('input', { type: 'hidden', value: promocode, name: 'txtPromoCode' }),
								(0, _preact.h)('input', { type: 'hidden', value: _this6.props.lang, name: 'lang' }),
								paxTypes instanceof Object && Object.keys(paxTypes).map(function (ptc, i) {
									return (0, _preact.h)('input', { type: 'hidden', value: paxTypes[ptc], name: _this6.props.usePtc.toLowerCase() == 'on' ? 'txtNum' + ptc : 'txtNum' + paxTypeMap[ptc].ibe });
								}),
								(0, _preact.h)(
									'button',
									{ type: 'submit', className: 'btn btn-primary' },
									translations[_this6.props.lang].searchButtonName
								)
							)
						)
					);
				}
			);
		};

		return Widget;
	}(_preact.Component), _class.defaultProps = {
		ibeUrl: '/',
		ngiUrl: '/',
		soarUrl: '/',
		formAction: 'AmeliaPost.aspx',
		formAutoSubmit: 'on',
		dateFormat: 'DD-MM-YYYY',
		lang: 'en',
		environment: 'prod',
		apiSetting: 'api', // default should become "soarapi"
		startOnMonday: 'off',
		showCabinClass: 'off',
		showCurrencies: 'off',
		showPromocode: 'on',
		showLowestFare: 'off',
		showSoldoutDates: 'off',
		horizontalBreakpoint: 576,
		showAvailableDates: 'off',
		usePtc: 'off',
		ptcTypes: 'ADT:CHD:INF',
		ptcMinMax: 'ADT|0-9:CHD|0-9:INF|0-9',
		ptcDefault: 'ADT|0:CHD|0:INF|0',
		ptcDependencies: '',
		ptcTotalMax: 9,
		ngi: 'on',
		listPosition: 'below',
		containAutosuggestScroll: 'off',
		preStyling: 'on',
		tripType: 'rt',
		tripTypeOptions: 'rt|ow',
		tripTypeDisplay: 'group',
		defaultCurrency: null,
		allowCurrencies: null,
		defaultCabinClass: '',
		initialMonth: null,
		mobileViewableMonths: 2,
		desktopViewableMonths: 2,
		calendarYearFormat: null,
		disabledCityPairs: '',
		enabledCityPairs: '',
		gatewayCityPairs: '',
		gatewayEnv: 'vision',
		gatewayShortcode: '',
		gatewayUrlLegacy: 'off',
		abbPackagerUrl: '',
		enableInterline: 'off',
		fareRounding: 'up',
		fareDecimals: 'off',
		fareBaseOnly: 'off',
		fareFormatOverride: '',
		fareFormatOverrides: '',
		developerMode: 'off',
		preferCachedData: 'on',
		lockControlsWhileCalendarLoads: 'off',
		promocode: '',
		widgetId: '',
		companyKey: '',
		autoAdvance: 'off',
		travelQuestion: 'off',
		travelQuestionDefault: 'off',
		travelQuestionAccept: 'inactive',
		autoPromocodeAssociation: 'off',
		autoPromocodeRequireQuestion: 'on',
		airportNameTemplate: null,
		useRtl: 'off',
		fieldValidation: 'off',
		displayInputAirportCode: 'on',
		displayInputAirportCodeFormat: '({{code}})'
	}, _temp2);
	exports.default = Widget;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _regenerator = __webpack_require__(17);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(16);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	var _typeof2 = __webpack_require__(25);

	var _typeof3 = _interopRequireDefault(_typeof2);

	var _lib = __webpack_require__(89);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var habitat = function habitat(Widget) {
	  var accumulatedProps = {}; // NEW

	  function mergeDefined(base, patch) {
	    var out = {},
	        k,
	        v;
	    for (k in base) {
	      out[k] = base[k];
	    }patch = patch || {};
	    for (k in patch) {
	      v = patch[k];
	      if (v === undefined) continue;
	      if (v && (typeof v === "undefined" ? "undefined" : (0, _typeof3.default)(v)) === 'object' && !Array.isArray(v)) {
	        out[k] = mergeDefined(out[k] || {}, v);
	      } else {
	        out[k] = v;
	      }
	    }
	    return out;
	  }

	  var tabInit = function tabInit(params) {
	    (0, _lib.tabRender)(Widget, params);
	  };

	  var render = function render() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$selector = _ref.selector,
	        selector = _ref$selector === undefined ? null : _ref$selector,
	        _ref$inline = _ref.inline,
	        inline = _ref$inline === undefined ? false : _ref$inline,
	        _ref$clean = _ref.clean,
	        clean = _ref$clean === undefined ? false : _ref$clean,
	        _ref$clientSpecified = _ref.clientSpecified,
	        clientSpecified = _ref$clientSpecified === undefined ? false : _ref$clientSpecified,
	        _ref$defaultProps = _ref.defaultProps,
	        defaultProps = _ref$defaultProps === undefined ? {} : _ref$defaultProps,
	        _ref$source = _ref.source,
	        source = _ref$source === undefined ? "init" : _ref$source;

	    var loaded = function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var elements, newNodes;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                elements = source === 'init' ? (0, _lib.widgetDOMHostElements)({ selector: selector, inline: inline, clientSpecified: clientSpecified }) : (0, _lib.widgetScriptLookup)();
	                _context.next = 3;
	                return (0, _lib.findNewHostNodes)(elements);

	              case 3:
	                newNodes = _context.sent;

	                if (newNodes.length > 0) {
	                  // accumulate the last props with the new ones
	                  accumulatedProps = mergeDefined(accumulatedProps, defaultProps || {});
	                  (0, _lib.preactRender)(Widget, newNodes, clean, accumulatedProps, source);
	                }

	              case 5:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined);
	      }));

	      return function loaded() {
	        return _ref2.apply(this, arguments);
	      };
	    }();

	    loaded();
	    // Page lifecycle retries are needed for the initial mount only. Keeping
	    // update callbacks would replay every historical patch on later events.
	    if (source === 'init') {
	      document.addEventListener("DOMContentLoaded", loaded);
	      document.addEventListener("load", loaded);
	      document.addEventListener("pageshow", loaded);
	    }
	  };

	  return { render: render, tabInit: tabInit };
	}; // habitat.js
	exports.default = habitat;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;
	exports.findNewHostNodes = exports.getHabitatSelectorFromClient = exports.tabRender = exports.preactRender = exports.camelcasize = exports.getExecutedScript = exports.widgetScriptLookup = exports.widgetDOMHostElements = exports.collectPropsFromElement = undefined;

	var _regenerator = __webpack_require__(17);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(16);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	var _preact = __webpack_require__(4);

	var _deepmerge = __webpack_require__(49);

	var _deepmerge2 = _interopRequireDefault(_deepmerge);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Removes `-` fron a string and capetalize the letter after
	 * example: data-props-hello-world =>  dataPropsHelloWorld
	 * Used for props passed from host DOM element
	 * @param  {String} str string
	 * @return {String} Capetalized string
	 */
	var camelcasize = function camelcasize(str) {
	  return str.replace(/-([a-z])/gi, function (all, letter) {
	    return letter.toUpperCase();
	  });
	};

	/**
	 * [getExecutedScript internal widget to provide the currently executed script]
	 * @param  {document} document [Browser document object]
	 * @return {HTMLElement}     [script Element]
	 */
	var getExecutedScript = function getExecutedScript() {
	  return document.currentScript || function () {
	    var scripts = document.getElementsByTagName("script");
	    return scripts[scripts.length - 1];
	  }();
	};

	/**
	 * Get the props from a host element's data attributes
	 * @param  {Element} tag The host element
	 * @return {Object}  props object to be passed to the component
	 */
	var collectPropsFromElement = function collectPropsFromElement(element) {
	  var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  var attrs = element.attributes;

	  var props = Object.assign({}, defaultProps);

	  // collect from element
	  Object.keys(attrs).forEach(function (key) {
	    if (attrs.hasOwnProperty(key)) {
	      var dataAttrName = attrs[key].name;
	      if (!dataAttrName || typeof dataAttrName !== "string") {
	        return false;
	      }
	      var propName = dataAttrName.split(/(data-props?-)/).pop() || '';
	      propName = camelcasize(propName);
	      if (dataAttrName !== propName) {
	        var propValue = attrs[key].nodeValue;
	        props[propName] = propValue;
	      }
	    }
	  });

	  // check for child script text/props or application/json
	  [].forEach.call(element.getElementsByTagName('script'), function (scrp) {
	    var propsObj = {};
	    if (scrp.hasAttribute('type')) {
	      if (scrp.getAttribute("type") !== "text/props" && scrp.getAttribute("type") !== "application/json") return;
	      try {
	        propsObj = JSON.parse(scrp.innerHTML);
	      } catch (e) {
	        throw new Error(e);
	      }
	      Object.assign(props, propsObj);
	    }
	  });

	  return props;
	};

	var getHabitatSelectorFromClient = function getHabitatSelectorFromClient(currentScript, dataAttrib) {
	  var scriptTagAttrs = currentScript.attributes;
	  var selector = null;

	  // check for another props attached to the tag
	  Object.keys(scriptTagAttrs).forEach(function (key) {
	    if (scriptTagAttrs.hasOwnProperty(key)) {
	      var dataAttrName = scriptTagAttrs[key].name;
	      if (dataAttrName === dataAttrib) {
	        selector = scriptTagAttrs[key].nodeValue;
	      }
	    }
	  });
	  return selector;
	};

	/**
	 * Return array of 0 or more elements that will host our widget
	 * @param  {id} attrId the data widget id attribute the host should have
	 * @param  {document} scope  Docuemnt object or DOM Element as a scope
	 * @return {Array}        Array of matching habitats
	 */
	var widgetDOMHostElements = function widgetDOMHostElements(_ref) {
	  var selector = _ref.selector,
	      inline = _ref.inline,
	      clientSpecified = _ref.clientSpecified;

	  var hostNodes = [];
	  var currentScript = getExecutedScript();

	  if (inline === true) {
	    var parentNode = currentScript.parentNode;
	    hostNodes.push(parentNode);
	  }
	  if (clientSpecified === true && !selector) {
	    // user did not specify where to mount - get it from script tag attributes
	    selector = getHabitatSelectorFromClient(currentScript, 'data-mount-in');
	  }
	  if (selector) {
	    [].forEach.call(document.querySelectorAll(selector), function (queriedTag) {
	      hostNodes.push(queriedTag);
	    });
	  }
	  return selector;
	};

	var widgetScriptLookup = function widgetScriptLookup() {
	  var tag = document.querySelector("[data-mount-in]");

	  if (!tag) return null;
	  return tag.dataset.mountIn;
	};

	function waitForElm(selector) {
	  return new Promise(function (resolve) {
	    if (document.querySelector(selector)) {
	      return resolve(document.querySelector(selector));
	    }

	    var observer = new MutationObserver(function (mutations) {
	      if (document.querySelector(selector)) {
	        resolve(document.querySelector(selector));
	        observer.disconnect();
	      }
	    });

	    observer.observe(document.body, {
	      childList: true,
	      subtree: true
	    });
	  });
	}

	var findNewHostNodes = function () {
	  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(selector) {
	    var hostNodes, elm;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            hostNodes = [];
	            _context.next = 3;
	            return waitForElm(selector);

	          case 3:
	            elm = _context.sent;

	            if (!selector) {
	              _context.next = 6;
	              break;
	            }

	            return _context.abrupt("return", Array.from(document.querySelectorAll(selector), function (item) {
	              return item;
	            }));

	          case 6:
	            return _context.abrupt("return", []);

	          case 7:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));

	  return function findNewHostNodes(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();

	/**
	 * preact render function that will be queued if the DOM is not ready
	 * and executed immeidatly if DOM is ready
	 */
	var preactRender = function preactRender(widget, hostElements, cleanRoot, defaultProps, source) {
	  return hostElements.map(function (elm, i) {
	    var hostNode = elm;
	    var props = void 0;
	    var autoLoading = true;
	    var requestedWidgetId = defaultProps.widgetId;

	    var l = collectPropsFromElement(elm);

	    if (l && l.autoLoad && l.autoLoad.toLowerCase() === 'off') autoLoading = false; // if no value is passed auto load

	    var singleWidgetId = hostNode.id ? hostNode.id : l && l.widgetId ? l.widgetId : "flight-search-widget-" + i;
	    if (source === 'update' && requestedWidgetId && requestedWidgetId !== singleWidgetId) return null;
	    hostNode.id = singleWidgetId;

	    /* console.log("singleWidgetId",singleWidgetId)
	    console.log("defaultProps.widgetId",defaultProps.widgetId)
	    console.log("autoLoading",autoLoading)
	    console.log("about to render from",source) */

	    if (source === 'init') {
	      if (!autoLoading) return null;
	    }

	    //if(source === 'render') // we let render run regardless if a proper id is sent in


	    /* console.log("collectPropsFromElement",l)
	    console.log("defaultProps",defaultProps)
	    console.log("props",props)
	    console.log("hostNode",hostNode) */

	    // Clear placeholder content on the first mount only. Later renders must
	    // leave Preact's existing tree attached so component state survives.
	    if (!hostNode._habitat) {
	      if (cleanRoot) hostNode.innerHTML = "";
	      while (hostNode.firstChild) {
	        hostNode.removeChild(hostNode.firstChild);
	      }
	    }

	    props = (0, _deepmerge2.default)(l, defaultProps); // explicit props override HTML data props
	    props.widgetId = singleWidgetId;

	    props['callback'] = function () {
	      elm.classList.remove("ias-search-preload");
	    };

	    var renderedComponent = (0, _preact.h)(widget, props);
	    (0, _preact.render)(renderedComponent, hostNode);
	    hostNode._habitat = true;
	    return renderedComponent;
	  });
	};
	var tabRender = function tabRender(widget, defaultProps) {
	  var currentScript = getExecutedScript();
	  var selector = getHabitatSelectorFromClient(currentScript, 'data-tab-container');

	  if (!selector) selector = defaultProps && defaultProps.selector || null;
	  if (!selector) return; // if selector isn't provide abort.

	  var elm = document.querySelector(selector);
	  if (!elm) return;
	  var l = collectPropsFromElement(elm, {});

	  var renderedComponent = (0, _preact.h)(widget, l);
	  elm.innerHTML = ''; // remove any existing content
	  (0, _preact.render)(renderedComponent, elm);
	  return renderedComponent;
	};

	exports.collectPropsFromElement = collectPropsFromElement;
	exports.widgetDOMHostElements = widgetDOMHostElements;
	exports.widgetScriptLookup = widgetScriptLookup;
	exports.getExecutedScript = getExecutedScript;
	exports.camelcasize = camelcasize;
	exports.preactRender = preactRender;
	exports.tabRender = tabRender;
	exports.getHabitatSelectorFromClient = getHabitatSelectorFromClient;
	exports.findNewHostNodes = findNewHostNodes;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.getAPIGeneric = exports.callAPI = exports.prepareIASapiUrl = exports.test = undefined;

	var _regenerator = __webpack_require__(17);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(16);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Delete session in browser cookie
	 */
	var test = exports.test = function test() {
	  console.log("test");
	};

	var prepareIASapiUrl = exports.prepareIASapiUrl = function prepareIASapiUrl(input) {
	  var env = input.env.toLowerCase() === 'prod' || input.env.toLowerCase() === '' ? '' : input.env.toLowerCase();
	  if (env === '' && input.apiSetting.toLowerCase() === 'soarapi') {
	    return 'https://' + input.shortname + '-' + input.apiSetting + '.ameliares.ca';
	  }
	  return 'https://' + input.shortname + '-' + input.apiSetting + '.intelisys' + env + '.ca';
	};

	var callAPI = exports.callAPI = function () {
	  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(input) {
	    var response;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return fetch(prepareIASapiUrl(input) + '/RESTv1/' + input.endpoint, {
	              method: 'GET',
	              headers: { 'Content-Type': 'application/json' }
	            });

	          case 2:
	            response = _context.sent;

	            if (response.ok) {
	              _context.next = 5;
	              break;
	            }

	            return _context.abrupt('return', null);

	          case 5:
	            _context.next = 7;
	            return response.json();

	          case 7:
	            return _context.abrupt('return', _context.sent);

	          case 8:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));

	  return function callAPI(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();

	var getAPIGeneric = exports.getAPIGeneric = function () {
	  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(input) {
	    var response;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return fetch('' + input);

	          case 2:
	            response = _context2.sent;
	            _context2.next = 5;
	            return response.json();

	          case 5:
	            return _context2.abrupt('return', _context2.sent);

	          case 6:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));

	  return function getAPIGeneric(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.ArrowSvg = exports.LoadingSvg = exports.joinAndKeepUnique = exports.parseCurrencyStringFormats = exports.calculateFare = exports.deriveCurrency = exports.groupBy = exports.processMiniHandleBars = exports.logToConsole = exports.uniqueValueGenerator = undefined;

	var _typeof2 = __webpack_require__(25);

	var _typeof3 = _interopRequireDefault(_typeof2);

	var _regenerator = __webpack_require__(17);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(16);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	exports.processMiniHandleBarsSmart = processMiniHandleBarsSmart;
	exports.promisedProperties = promisedProperties;

	var _preact = __webpack_require__(4);

	var _numberFormatter = __webpack_require__(92);

	var _numberFormatter2 = _interopRequireDefault(_numberFormatter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var uniqueValueGenerator = exports.uniqueValueGenerator = function uniqueValueGenerator() {
	  return Math.random().toString(18).substring(2, 15);
	};

	var logToConsole = exports.logToConsole = function () {
	  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(msg, props) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (props.developerMode.toLowerCase() === "on") console.log(msg);

	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));

	  return function logToConsole(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();

	var processMiniHandleBars = exports.processMiniHandleBars = function processMiniHandleBars(str, props) {
	  return str.replace(/{{\s*(.*?)\s*}}/g, function (match, path) {
	    var parts = path.split(".");
	    var value = props;
	    for (var i = 0; i < parts.length; i++) {
	      if (value && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === "object" && parts[i] in value) {
	        value = value[parts[i]];
	      } else {
	        value = undefined;
	        break;
	      }
	    }
	    return value !== undefined && value !== null ? value : "";
	  });
	};

	// Helper: safely get nested value by dot path
	function getByPath(obj, path) {
	  var parts = path.split('.');
	  var cur = obj;
	  for (var i = 0; i < parts.length; i++) {
	    if (cur && (typeof cur === 'undefined' ? 'undefined' : (0, _typeof3.default)(cur)) === 'object' && parts[i] in cur) {
	      cur = cur[parts[i]];
	    } else {
	      return undefined;
	    }
	  }
	  return cur;
	}

	// Strip single quotes only
	function unquoteSingle(s) {
	  if (!s) return s;
	  s = s.trim();
	  if (s.charAt(0) === "'" && s.charAt(s.length - 1) === "'") {
	    return s.slice(1, -1);
	  }
	  return s;
	}

	// Updated function (single-quote suffix only)
	function processMiniHandleBarsSmart(str, props) {
	  return str.replace(/\{\{\s*([^}]+?)\s*\}\}/g, function (match, inner) {
	    var pipeIdx = inner.indexOf('|');
	    var path = pipeIdx === -1 ? inner.trim() : inner.slice(0, pipeIdx).trim();
	    var suffixRaw = pipeIdx === -1 ? "" : inner.slice(pipeIdx + 1).trim();

	    var suffix = unquoteSingle(suffixRaw);

	    var val = getByPath(props, path);

	    var present = !(val === undefined || val === null || val === "" || val === "NA");

	    if (!present) return "";

	    var out = String(val);
	    if (suffix) out += suffix;
	    return out;
	  });
	}

	function promisedProperties(object) {

	  var promisedProperties = [];
	  var objectKeys = Object.keys(object);

	  objectKeys.forEach(function (key) {
	    return promisedProperties.push(object[key]);
	  });

	  return Promise.all(promisedProperties).then(function (resolvedValues) {
	    return resolvedValues.reduce(function (resolvedObject, property, index) {
	      resolvedObject[objectKeys[index]] = property;
	      return resolvedObject;
	    }, object);
	  });
	}

	var groupBy = exports.groupBy = function groupBy(key) {
	  return function (array) {
	    return array.reduce(function (objectsByKeyValue, obj) {
	      var value = obj[key];
	      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
	      return objectsByKeyValue;
	    }, {});
	  };
	};

	var deriveCurrency = exports.deriveCurrency = function deriveCurrency(incomingCurrency, currentCurrency, currencyFromAPI) {
	  // check to see if the default provided in the props actually exists in ameliaRES settings
	  var currencyObject = currencyFromAPI.find(function (c) {
	    return c.code === incomingCurrency;
	  });
	  /* console.log("currencyFromAPI",currencyFromAPI) */
	  if (!currencyObject && currentCurrency) return currentCurrency;
	  if (!currencyObject) return currencyFromAPI[0].code;
	  return currencyObject.code;
	};

	var calculateFare = exports.calculateFare = function calculateFare(r, rounding, decimals, baseOnly, curr, fareFormatOverride) {
	  var singleFareTotal = null;
	  var avail = 0;

	  if (r.fareCharges.length > 0) {
	    var mandatoryFareCharges = r.fareCharges.filter(function (charge) {
	      return charge.bookingApplicability && charge.bookingApplicability.optional === false;
	    });

	    avail = r.availability;
	    singleFareTotal = mandatoryFareCharges.reduce(function (acc, curr) {
	      var charge = 0;
	      if (curr.passengerApplicability.adult && (!curr.passengerApplicability.child || !curr.passengerApplicability.infant)) {
	        charge = curr.currencyAmounts[0].totalAmount; // API only returns one currency at a time
	      }
	      return Math.round((acc + charge) * 100) / 100;
	    }, 0);

	    if (baseOnly === 'on') {
	      var baseFare = mandatoryFareCharges.find(function (f) {
	        return f.chargeType.code === 'FA';
	      });
	      singleFareTotal = baseFare ? baseFare.currencyAmounts[0].baseAmount : 0;
	    }
	    if (fareFormatOverride !== '') curr.format = fareFormatOverride;

	    var polishedTotal = rounding === "up" ? Math.ceil(singleFareTotal) : Math.floor(singleFareTotal);
	    polishedTotal = (0, _numberFormatter2.default)(decimals === "on" ? curr.format : curr.format.replace("0.00", ""), polishedTotal);
	    return { fareTotal: polishedTotal, fareDirty: singleFareTotal, availability: avail, class: r.fareClass.code };
	  } else {
	    return { fareTotal: 0, fareDirty: 0, availability: 0, class: '' // NOT SURE ABOUT THIS
	    };
	  }
	};

	var parseCurrencyStringFormats = exports.parseCurrencyStringFormats = function parseCurrencyStringFormats(s) {
	  // const s = "USD:$#,##0.00|EUR:#,##0.00 EUR|CAD:#,##0.00$"; // example of expected input

	  var regex = /([A-Z]{3}):([^|]+)/g;
	  var result = {};
	  var match = void 0;

	  try {
	    while ((match = regex.exec(s)) !== null) {
	      var key = match[1];
	      var value = match[2];
	      result[key] = value.trim();
	    }

	    return result;
	  } catch (e) {
	    console.log(e);
	    return null;
	  }
	};

	var joinAndKeepUnique = exports.joinAndKeepUnique = function joinAndKeepUnique(array1, array2) {
	  // Combine arrays into a Set to automatically remove duplicates
	  var uniqueSet = new Set([].concat(array1, array2));
	  // Convert the Set back to an array
	  return Array.from(uniqueSet);
	};

	var LoadingSvg = exports.LoadingSvg = function LoadingSvg() {
	  return (0, _preact.h)(
	    'svg',
	    { 'class': 'ias-loader-spin', xmlns: 'http://www.w3.org/2000/svg', style: 'margin: auto; background: none; display: block; shape-rendering: auto;', viewBox: '0 0 20 20', preserveAspectRatio: 'xMidYMid' },
	    (0, _preact.h)(
	      'circle',
	      { cx: '10', cy: '10', fill: 'none', 'stroke-width': '1', r: '4', 'stroke-dasharray': '18.84955592153876 8.283185307179586' },
	      (0, _preact.h)('animateTransform', { attributeName: 'transform', type: 'rotate', repeatCount: 'indefinite', dur: '1s', values: '0 10 10;360 10 10', keyTimes: '0;1' })
	    )
	  );
	};

	var ArrowSvg = exports.ArrowSvg = function ArrowSvg() {
	  return (0, _preact.h)(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: '16',
	      height: '16',
	      fill: 'currentColor',
	      'class': 'icon-right-arrow',
	      id: 'right-arrow',
	      size: '16',
	      color: 'currentColor',
	      viewBox: '0 0 24 24'
	    },
	    (0, _preact.h)('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
	    (0, _preact.h)('path', { d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z' })
	  );
	};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	/**
	 * Javascript-number-formatter
	 * Lightweight & Fast JavaScript Number Formatter
	 *
	 * @preserve IntegraXor Web SCADA - JavaScript Number Formatter (http://www.integraxor.com/)
	 * @author KPL
	 * @maintainer Rob Garrison
	 * @copyright 2019 ecava
	 * @license MIT
	 * @link http://mottie.github.com/javascript-number-formatter/
	 * @version 2.0.9
	 */
	var maskRegex = /[0-9\-+#]/;
	var notMaskRegex = /[^\d\-+#]/g;

	function getIndex(mask) {
	  return mask.search(maskRegex);
	}

	function processMask() {
	  var mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#.##";

	  var maskObj = {};
	  var len = mask.length;
	  var start = getIndex(mask);
	  maskObj.prefix = start > 0 ? mask.substring(0, start) : "";

	  // Reverse string: not an ideal method if there are surrogate pairs
	  var end = getIndex(mask.split("").reverse().join(""));
	  var offset = len - end;
	  var substr = mask.substring(offset, offset + 1);
	  // Add 1 to offset if mask has a trailing decimal/comma
	  var indx = offset + (substr === "." || substr === "," ? 1 : 0);
	  maskObj.suffix = end > 0 ? mask.substring(indx, len) : "";

	  maskObj.mask = mask.substring(start, indx);
	  maskObj.maskHasNegativeSign = maskObj.mask.charAt(0) === "-";
	  maskObj.maskHasPositiveSign = maskObj.mask.charAt(0) === "+";

	  // Search for group separator & decimal; anything not digit,
	  // not +/- sign, and not #
	  var result = maskObj.mask.match(notMaskRegex);
	  // Treat the right most symbol as decimal
	  maskObj.decimal = result && result[result.length - 1] || ".";
	  // Treat the left most symbol as group separator
	  maskObj.separator = result && result[1] && result[0] || ",";

	  // Split the decimal for the format string if any
	  result = maskObj.mask.split(maskObj.decimal);
	  maskObj.integer = result[0];
	  maskObj.fraction = result[1];
	  return maskObj;
	}

	function processValue(value, maskObj, options) {
	  var isNegative = false;
	  var valObj = {
	    value: value
	  };
	  if (value < 0) {
	    isNegative = true;
	    // Process only abs(), and turn on flag.
	    valObj.value = -valObj.value;
	  }

	  valObj.sign = isNegative ? "-" : "";

	  // Fix the decimal first, toFixed will auto fill trailing zero.
	  valObj.value = Number(valObj.value).toFixed(maskObj.fraction && maskObj.fraction.length);
	  // Convert number to string to trim off *all* trailing decimal zero(es)
	  valObj.value = Number(valObj.value).toString();

	  // Fill back any trailing zero according to format
	  // look for last zero in format
	  var posTrailZero = maskObj.fraction && maskObj.fraction.lastIndexOf("0");

	  var _valObj$value$split = valObj.value.split("."),
	      _valObj$value$split$ = _valObj$value$split[0],
	      valInteger = _valObj$value$split$ === undefined ? "0" : _valObj$value$split$,
	      _valObj$value$split$2 = _valObj$value$split[1],
	      valFraction = _valObj$value$split$2 === undefined ? "" : _valObj$value$split$2;

	  if (!valFraction || valFraction && valFraction.length <= posTrailZero) {
	    valFraction = posTrailZero < 0 ? "" : Number("0." + valFraction).toFixed(posTrailZero + 1).replace("0.", "");
	  }

	  valObj.integer = valInteger;
	  valObj.fraction = valFraction;
	  addSeparators(valObj, maskObj);

	  // Remove negative sign if result is zero
	  if (valObj.result === "0" || valObj.result === "") {
	    // Remove negative sign if result is zero
	    isNegative = false;
	    valObj.sign = "";
	  }

	  if (!isNegative && maskObj.maskHasPositiveSign) {
	    valObj.sign = "+";
	  } else if (isNegative && maskObj.maskHasPositiveSign) {
	    valObj.sign = "-";
	  } else if (isNegative) {
	    valObj.sign = options && options.enforceMaskSign && !maskObj.maskHasNegativeSign ? "" : "-";
	  }

	  return valObj;
	}

	function addSeparators(valObj, maskObj) {
	  valObj.result = "";
	  // Look for separator
	  var szSep = maskObj.integer.split(maskObj.separator);
	  // Join back without separator for counting the pos of any leading 0
	  var maskInteger = szSep.join("");

	  var posLeadZero = maskInteger && maskInteger.indexOf("0");
	  if (posLeadZero > -1) {
	    while (valObj.integer.length < maskInteger.length - posLeadZero) {
	      valObj.integer = "0" + valObj.integer;
	    }
	  } else if (Number(valObj.integer) === 0) {
	    valObj.integer = "";
	  }

	  // Process the first group separator from decimal (.) only, the rest ignore.
	  // get the length of the last slice of split result.
	  var posSeparator = szSep[1] && szSep[szSep.length - 1].length;
	  if (posSeparator) {
	    var len = valObj.integer.length;
	    var offset = len % posSeparator;
	    for (var indx = 0; indx < len; indx++) {
	      valObj.result += valObj.integer.charAt(indx);
	      // -posSeparator so that won't trail separator on full length
	      if (!((indx - offset + 1) % posSeparator) && indx < len - posSeparator) {
	        valObj.result += maskObj.separator;
	      }
	    }
	  } else {
	    valObj.result = valObj.integer;
	  }

	  valObj.result += maskObj.fraction && valObj.fraction ? maskObj.decimal + valObj.fraction : "";
	  return valObj;
	}

	var format = function format(mask, value) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	  if (!mask || isNaN(Number(value))) {
	    // Invalid inputs
	    return value;
	  }

	  var maskObj = processMask(mask);
	  var valObj = processValue(value, maskObj, options);
	  return maskObj.prefix + valObj.sign + valObj.result + maskObj.suffix;
	};

	exports.default = format;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(100), __esModule: true };

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(102), __esModule: true };

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(103), __esModule: true };

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(104), __esModule: true };

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(105), __esModule: true };

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	exports.default = function (obj, keys) {
	  var target = {};

	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }

	  return target;
	};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(132);
	module.exports = __webpack_require__(3).Object.assign;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(133);
	var $Object = __webpack_require__(3).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134);
	module.exports = __webpack_require__(3).Object.setPrototypeOf;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(135);
	__webpack_require__(137);
	__webpack_require__(138);
	module.exports = __webpack_require__(3).Promise;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(136);
	__webpack_require__(64);
	__webpack_require__(139);
	__webpack_require__(140);
	module.exports = __webpack_require__(3).Symbol;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(65);
	__webpack_require__(66);
	module.exports = __webpack_require__(48).f('iterator');


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    return;(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(15);
	var toLength = __webpack_require__(63);
	var toAbsoluteIndex = __webpack_require__(128);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(27);
	var gOPS = __webpack_require__(41);
	var pIE = __webpack_require__(28);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(19);
	var call = __webpack_require__(114);
	var isArrayIter = __webpack_require__(112);
	var anObject = __webpack_require__(5);
	var toLength = __webpack_require__(63);
	var getIterFn = __webpack_require__(130);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') return;(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(21);
	var ITERATOR = __webpack_require__(2)('iterator');
	var ArrayProto = Array.prototype;

	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(18);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(5);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(40);
	var descriptor = __webpack_require__(29);
	var setToStringTag = __webpack_require__(30);
	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(11)(IteratorPrototype, __webpack_require__(2)('iterator'), function () { return this; });

	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(2)('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(31)('meta');
	var isObject = __webpack_require__(8);
	var has = __webpack_require__(10);
	var setDesc = __webpack_require__(12).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(20)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var macrotask = __webpack_require__(62).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(18)(process) == 'process';

	module.exports = function () {
	  var head, last, notify;

	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };

	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }

	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(6);
	var getKeys = __webpack_require__(27);
	var gOPS = __webpack_require__(41);
	var pIE = __webpack_require__(28);
	var toObject = __webpack_require__(45);
	var IObject = __webpack_require__(53);
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(20)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(12);
	var anObject = __webpack_require__(5);
	var getKeys = __webpack_require__(27);

	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(15);
	var gOPN = __webpack_require__(56).f;
	var toString = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(10);
	var toObject = __webpack_require__(45);
	var IE_PROTO = __webpack_require__(42)('IE_PROTO');
	var ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(11);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(8);
	var anObject = __webpack_require__(5);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) return;(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(19)(Function.call, __webpack_require__(55).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(1);
	var core = __webpack_require__(3);
	var dP = __webpack_require__(12);
	var DESCRIPTORS = __webpack_require__(6);
	var SPECIES = __webpack_require__(2)('species');

	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(44);
	var defined = __webpack_require__(36);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(44);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var navigator = global.navigator;

	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(50);
	var ITERATOR = __webpack_require__(2)('iterator');
	var Iterators = __webpack_require__(21);
	module.exports = __webpack_require__(3).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(106);
	var step = __webpack_require__(117);
	var Iterators = __webpack_require__(21);
	var toIObject = __webpack_require__(15);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(54)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(7);

	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(120) });


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(40) });


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(7);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(125).set });


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(22);
	var global = __webpack_require__(1);
	var ctx = __webpack_require__(19);
	var classof = __webpack_require__(50);
	var $export = __webpack_require__(7);
	var isObject = __webpack_require__(8);
	var aFunction = __webpack_require__(26);
	var anInstance = __webpack_require__(107);
	var forOf = __webpack_require__(110);
	var speciesConstructor = __webpack_require__(61);
	var task = __webpack_require__(62).set;
	var microtask = __webpack_require__(119)();
	var newPromiseCapabilityModule = __webpack_require__(39);
	var perform = __webpack_require__(58);
	var userAgent = __webpack_require__(129);
	var promiseResolve = __webpack_require__(59);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(2)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();

	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) return;("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};

	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(124)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(30)($Promise, PROMISE);
	__webpack_require__(126)(PROMISE);
	Wrapper = __webpack_require__(3)[PROMISE];

	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(116)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(1);
	var has = __webpack_require__(10);
	var DESCRIPTORS = __webpack_require__(6);
	var $export = __webpack_require__(7);
	var redefine = __webpack_require__(60);
	var META = __webpack_require__(118).KEY;
	var $fails = __webpack_require__(20);
	var shared = __webpack_require__(43);
	var setToStringTag = __webpack_require__(30);
	var uid = __webpack_require__(31);
	var wks = __webpack_require__(2);
	var wksExt = __webpack_require__(48);
	var wksDefine = __webpack_require__(47);
	var enumKeys = __webpack_require__(109);
	var isArray = __webpack_require__(113);
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(8);
	var toObject = __webpack_require__(45);
	var toIObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(46);
	var createDesc = __webpack_require__(29);
	var _create = __webpack_require__(40);
	var gOPNExt = __webpack_require__(122);
	var $GOPD = __webpack_require__(55);
	var $GOPS = __webpack_require__(41);
	var $DP = __webpack_require__(12);
	var $keys = __webpack_require__(27);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) return;('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });

	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(56).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(28).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;

	  if (DESCRIPTORS && !__webpack_require__(22)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) return;(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(7);
	var core = __webpack_require__(3);
	var global = __webpack_require__(1);
	var speciesConstructor = __webpack_require__(61);
	var promiseResolve = __webpack_require__(59);

	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(7);
	var newPromiseCapability = __webpack_require__(39);
	var perform = __webpack_require__(58);

	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(47)('asyncIterator');


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(47)('observable');


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(67)();
	// imports


	// module
	exports.push([module.id, ".ias-search-preload,.ias-tab-preload{position:absolute;left:-9999em}.ias-tab-list{margin:0;padding:0;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:start}.ias-tab-list .ias-tab-item{display:-ms-flexbox;display:flex;padding:.5rem 1rem;margin-left:1px;background-color:var(--theme-tab-background-inactive);border-top-left-radius:.4rem;border-top-right-radius:.4rem;cursor:pointer}.ias-tab-list .ias-tab-item:first-child{margin-left:0}.ias-tab-list .ias-tab-item.ias-tab-active,.ias-tab-panel{background-color:var(--theme-tab-background)}.ias-tab-panel{padding:1rem;border-radius:.4rem;border-top-left-radius:0}.ias-hidden-tab{display:none}.ias-visible-tab{display:inherit}", ""]);

	// exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(67)();
	// imports


	// module
	exports.push([module.id, "@media (max-width:480px){body.ias-calendar-open{overflow:hidden!important}}.ias-search-widget{--primary-color:var(--theme-primary-color,#0c4678);--primary-color-lighter:var(--theme-primary-color-lighter,#1174ca);--primary-color-lightest:var(--theme-primary-color-lightest,#1887e7);--primary-dark:var(--theme-primary-dark,#000);--primary-dark-lighter:var(--theme-primary-dark-lighter,#444);--primary-light:var(--theme-primary-light,#fff);--secondary-color:var(--theme-secondary-color,#3d6c95);--text-color:#777;--text-color-light:#ccc;--border-color:#ced4da;--bg-color:#f9f9f9;--neutral-color:#fff;--neutral-grey:#eaeaea}.ias-search-widget .ias-loader-spin{width:1.825rem}.ias-search-widget .ias-loader-spin circle{stroke:var(--primary-color)}.ias-search-widget .ias-year{padding-left:.5em}.ias-search-widget .field-error{margin-top:6px;font-size:12px;line-height:1.3;color:#b00020}.ias-search-widget.prestyled .load-parent--wrapper{position:absolute;top:0;right:0;transform:translate(-.5rem,30%)}.ias-search-widget.prestyled .calendar-errors{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;gap:12px;margin-top:6px}.ias-search-widget.prestyled .form-control,.ias-search-widget.prestyled .passengerCount,.ias-search-widget.prestyled input[type=email],.ias-search-widget.prestyled input[type=number],.ias-search-widget.prestyled input[type=password],.ias-search-widget.prestyled input[type=search],.ias-search-widget.prestyled input[type=tel],.ias-search-widget.prestyled input[type=text],.ias-search-widget.prestyled input[type=url],.ias-search-widget.prestyled select,.ias-search-widget.prestyled textarea{appearance:none;background-color:#fff;border:.1rem solid var(--neutral-grey);border-radius:.4rem;box-shadow:none;box-sizing:inherit;height:3rem;padding:.6rem 1rem;width:100%;font-size:clamp(16px,1rem,2rem);position:relative}.ias-search-widget.prestyled .passengerCount.form-control.show,.ias-search-widget.prestyled .passengerCount:focus,.ias-search-widget.prestyled input[type=email]:focus,.ias-search-widget.prestyled input[type=number]:focus,.ias-search-widget.prestyled input[type=password]:focus,.ias-search-widget.prestyled input[type=search]:focus,.ias-search-widget.prestyled input[type=tel]:focus,.ias-search-widget.prestyled input[type=text]:focus,.ias-search-widget.prestyled input[type=url]:focus,.ias-search-widget.prestyled select:focus,.ias-search-widget.prestyled textarea:focus{border-color:var(--primary-color);outline:0}.ias-search-widget.prestyled .button,.ias-search-widget.prestyled button,.ias-search-widget.prestyled input[type=button],.ias-search-widget.prestyled input[type=reset],.ias-search-widget.prestyled input[type=submit]{background-color:var(--secondary-color);border:.1rem solid var(--secondary-color);color:#fff;cursor:pointer;display:inline-block;font-weight:700;border-radius:.4rem;box-shadow:none;box-sizing:inherit;height:3rem;padding:0 1rem;width:100%;font-size:1rem;line-height:3rem;text-decoration:none;text-transform:uppercase;white-space:nowrap;appearance:button}.ias-search-widget.prestyled button:disabled{background-color:var(--primary-color-lightest);border-color:var(--primary-color-lightest);cursor:not-allowed}.ias-search-widget.prestyled .select-css{width:100%;max-width:100%;box-sizing:border-box;margin:0;border-radius:.5em;appearance:none;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");background-repeat:no-repeat,repeat;background-position:right 1em top 50%,0 0;background-size:.6em auto,100%}.ias-search-widget.prestyled .select-css::-ms-expand{display:none}.ias-search-widget.prestyled .select-css option{font-weight:400}.ias-search-widget.prestyled .stv-radio-button+label{height:3rem;padding:.6rem 1rem;color:var(--primary-dark);border:1px solid var(--border-color);background-color:var(--primary-light)}.ias-search-widget.prestyled .stv-radio-button+label:first-of-type{border-radius:.4em 0 0 .4em}.ias-search-widget.prestyled .stv-radio-button+label:last-of-type{border-radius:0 .4em .4em 0}.ias-search-widget.prestyled .radio-buttons-wrapper,.ias-search-widget.prestyled .radio-buttons-wrapper .radio-option{display:-ms-flexbox;display:flex}.ias-search-widget.prestyled .form-check-label{cursor:pointer}.ias-search-widget.prestyled .form-check-input{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid var(--border-color);appearance:none;cursor:pointer}.ias-search-widget.prestyled .form-check-input:checked[type=radio]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.ias-search-widget.prestyled .form-check{display:-ms-flexbox;display:flex}.ias-search-widget.prestyled .form-check-input:checked{background-color:var(--secondary-color);border-color:var(--secondary-color)}.ias-search-widget.prestyled .form-check-input[type=radio]{border-radius:50%}.ias-search-widget.prestyled .form-check-input[type=checkbox]{border-radius:.25em}.ias-search-widget.prestyled .form-check-input:checked[type=checkbox]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.ias-search-widget.prestyled .passengerTypes{border-top:1px solid var(--border-color);padding:1rem 0}.ias-search-widget.prestyled .passengerTypes:first-child{border:none;padding-top:0}.ias-search-widget.prestyled .passengerTypes:last-child{padding-bottom:0}.ias-search-widget.prestyled .stepper{position:relative}.ias-search-widget.prestyled .stepper button{background-color:transparent;color:var(--primary-dark);border:none;position:relative}.ias-search-widget.prestyled .stepper button:focus{outline:none}.ias-search-widget.prestyled .stepper button:disabled{color:var(--neutral-grey)!important}.ias-search-widget.prestyled .passengerSelection .optionContainer{border-radius:.4rem}.ias-search-widget input[type=number]{-moz-appearance:textfield!important}.ias-search-widget input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.ias-search-widget *{box-sizing:border-box}.ias-search-widget .select-css{-webkit-appearance:none;-moz-appearance:none;text-indent:1px;text-overflow:\"\";background-color:#fff;background-image:url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");background-repeat:no-repeat,repeat;background-position:right 1em top 50%,0 0;background-size:.6em auto,100%}.ias-search-widget .fieldset{border:none;margin-top:1rem;position:relative}.ias-search-widget .switch .control-loading-indicator{bottom:.25rem;left:.25rem}.ias-search-widget .control-loading-indicator{position:absolute;bottom:1rem;left:.125rem;width:1rem;height:1rem;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;color:#5f6368;z-index:1;visibility:hidden;opacity:0;transition:opacity .12s ease}.ias-search-widget .control-loading-indicator.is-visible{visibility:visible;opacity:1;pointer-events:none}.ias-search-widget .control-loading-indicator.is-hidden{pointer-events:none}.ias-search-widget .control-loading-indicator__spinner{width:1rem;height:1rem;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex:0 0 1rem;flex:0 0 1rem}.ias-search-widget .control-loading-indicator__spinner .ias-loader-spin{width:1rem;height:1rem;stroke:var(--primary-color)}.ias-search-widget label{display:block}.ias-search-widget a{text-decoration:none;color:#000}.ias-search-widget a:focus{border:none;outline:none}.ias-search-widget .form-control:disabled,.ias-search-widget .form-control[readonly]{background-color:#fff;opacity:1}.ias-search-widget button{background-color:var(--secondary-color);border:.1rem solid var(--secondary-color);color:#fff}.ias-search-widget button.clear-selected{position:absolute;background-color:#fff;outline:none;background-position:50%;background-repeat:no-repeat;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd'%3E%3Cpath fill='%23d1d1d1' d='M24 21H7l-7-7.972L7 5h17v16zM7.91 7l-5.252 6.023L7.905 19H22V7H7.91zM14 11.586L16.586 9 18 10.414 15.414 13 18 15.586 16.586 17 14 14.414 11.414 17 10 15.586 12.586 13 10 10.414 11.414 9 14 11.586z'/%3E%3C/svg%3E\");right:.125rem;top:.125rem;width:auto;height:calc(100% - .25rem)!important;border:none;border-left:none;padding:0 1rem 0 2rem;border-radius:0;border-top-right-radius:.4rem;border-bottom-right-radius:.4rem}.ias-search-widget button.clear-selected:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd'%3E%3Cpath d='M24 21H7l-7-7.972L7 5h17v16zM7.91 7l-5.252 6.023L7.905 19H22V7H7.91zM14 11.586L16.586 9 18 10.414 15.414 13 18 15.586 16.586 17 14 14.414 11.414 17 10 15.586 12.586 13 10 10.414 11.414 9 14 11.586z'/%3E%3C/svg%3E\");outline:none}.ias-search-widget button.clear-selected span{display:none}.ias-search-widget .passengerCount{display:none;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");background-repeat:no-repeat,repeat;background-position:right 1em top 50%,0 0;background-size:.6em auto,100%}.ias-search-widget .passengerCount.show{background-image:url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%22293px%22%20height%3D%22165px%22%20viewBox%3D%220%200%20293%20165%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20id%3D%22up%22%20transform%3D%22translate%28146.500000%2C%2083.000000%29%20rotate%28180.000000%29%20translate%28-146.500000%2C%20-83.000000%29%20%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%3Cpath%20d%3D%22M287%2C6.4%20C283.606525%2C2.86996354%20278.895845%2C0.913219359%20274%2C1%20L18.4%2C1%20C13.4%2C1%209.1%2C2.8%205.5%2C6.4%20C1.98414291%2C9.72855936%20-0.005266583%2C14.3584578%20-1.04301756e-05%2C19.2%20C-1.04301756e-05%2C24.2%201.8%2C28.5%205.4%2C32.1%20L133.4%2C160%20C137%2C163.6%20141.2%2C165.4%20146.2%2C165.4%20C151.2%2C165.4%20155.4%2C163.6%20159%2C160%20L287%2C32%20C290.5%2C28.5%20292.4%2C24.2%20292.4%2C19.2%20C292.4%2C14.2%20290.5%2C10%20286.9%2C6.4%20L287%2C6.4%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E\")}.ias-search-widget .passengerSelection{cursor:pointer}.ias-search-widget .swapAirports{text-align:right;padding:10px 10px 0 0}.ias-search-widget .swapAirports a{transform:rotate(90deg);display:inline-block}.ias-search-widget .toggle-checkbox{display:none}.ias-search-widget .iasslidertg{position:relative}.ias-search-widget .iasslidertg:before{background:var(--primary-light);border-radius:34px;bottom:0;content:\"\";height:24px;margin:auto;position:absolute;top:0;width:40px;cursor:pointer}.ias-search-widget .iasslidertg:after{background:var(--secondary-color);border-radius:50%;bottom:0;content:\"\";height:16px;left:4px;margin:auto;position:absolute;top:0;transition:.4s;width:16px;cursor:pointer}.ias-search-widget .toggle-switch{margin-left:50px;cursor:pointer}.ias-search-widget .toggle-switch.opt2{display:none}.ias-search-widget .toggle-checkbox:checked+.iasslidertg:before{background-color:var(--primary-light)}.ias-search-widget .toggle-checkbox:checked+.iasslidertg:after{background-color:var(--primary-dark-lighter);transform:translateX(16px)}.ias-search-widget .toggle-checkbox:checked~.iasslidertg>.toggle-switch.opt1{display:none}.ias-search-widget .toggle-checkbox:checked~.iasslidertg>.toggle-switch.opt2{display:inline-block}.ias-search-widget .stv-radio-buttons-wrapper{display:-ms-flexbox;display:flex;width:100%}.ias-search-widget .stv-radio-buttons-wrapper label{width:auto}.ias-search-widget .stv-radio-button{display:none}.ias-search-widget .stv-radio-button+label{-ms-flex:1;flex:1;cursor:pointer;margin-right:-1px;color:var(--primary-dark);border:1px solid var(--border-color);background-color:var(--primary-light);width:50%;text-align:center;margin-bottom:0}.ias-search-widget .stv-radio-button+label:first-of-type{border-top-right-radius:0 0;border-bottom-right-radius:0 0}.ias-search-widget .stv-radio-button+label:last-of-type{border-top-left-radius:0 0;border-bottom-left-radius:0 0}.ias-search-widget .stv-radio-button:checked+label{background-color:var(--primary-color);color:var(--primary-light)}.ias-search-widget .passengerSelection .optionContainer{-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:stretch;align-items:stretch;border:1px solid var(--border-color)}.ias-search-widget .react-autosuggest__container{position:relative}.ias-search-widget .react-autosuggest__suggestions-container{display:none;z-index:500}.ias-search-widget .react-autosuggest__suggestions-container--open{display:block;position:absolute;width:auto;border:1px solid var(--border-color);background-color:#fff;z-index:501}.ias-search-widget .maskAutoSuggestScroll .react-autosuggest__suggestions-container--open{max-height:12rem;overflow-y:auto}.ias-search-widget .react-autosuggest__suggestion--highlighted{background-color:var(--primary-color-lightest)}.ias-search-widget .react-autosuggest__suggestions-list{list-style:none;padding:.6rem 1rem;padding-top:0;min-width:320px}.ias-search-widget .react-autosuggest__suggestion{padding:.4rem 1rem;border-radius:.4rem}.ias-search-widget .react-autosuggest__suggestion div{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.ias-search-widget .react-autosuggest__suggestion div span{display:inline}.ias-search-widget .react-autosuggest__suggestion div span.name{-ms-flex:3;flex:3}.ias-search-widget .react-autosuggest__suggestion div span.code{-ms-flex:1;flex:1;text-align:center;border-radius:1.8rem;padding:.4rem;background-color:var(--neutral-grey)}@media (max-width:480px){.ias-search-widget .calendar__item{display:block}}.ias-search-widget .icon{font-style:normal;display:inline-block;vertical-align:middle;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\"}.ias-search-widget .calendar-window{position:absolute;z-index:100;display:-ms-flexbox;display:flex}@media (max-width:480px){.ias-search-widget .calendar-window{top:0!important;left:0!important;display:block;width:100vw;height:100dvh;overflow:scroll;position:fixed;background-color:#fff;transform:translateX(0)!important}}.ias-search-widget .calendar-window h2{padding-left:1em;padding-top:1rem;display:none}@media (max-width:480px){.ias-search-widget .calendar-window h2{display:block}}.ias-search-widget .calendar{display:inline-block;position:relative;min-width:auto;width:320px;background:var(--neutral-color);border:1px solid var(--border-color);vertical-align:top}@media (max-width:480px){.ias-search-widget .calendar{width:100%}.ias-search-widget .calendar .footer{position:fixed;bottom:1rem;left:0;width:100%}}.ias-search-widget .calendar .row{margin:0;padding:0;width:100%;display:-ms-grid;display:grid;-ms-grid-columns:(1fr)[7];grid-template-columns:repeat(7,1fr)}.ias-search-widget .calendar .row-middle{-ms-flex-align:center;align-items:center}.ias-search-widget .calendar .footer,.ias-search-widget .calendar .header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.ias-search-widget .calendar .col{height:auto;max-width:100%}.ias-search-widget .calendar .col:before{content:\"\";padding-top:100%}.ias-search-widget .calendar .col-start{-ms-flex-pack:start;justify-content:flex-start;text-align:left}.ias-search-widget .calendar .col-center{-ms-flex-pack:center;justify-content:center;text-align:center;-ms-flex:7;flex:7}.ias-search-widget .calendar .col-end{-ms-flex-pack:end;justify-content:flex-end;text-align:right}.ias-search-widget .calendar .header{text-transform:uppercase;font-weight:700;font-size:115%;padding:1.5em 0;border-bottom:1px solid var(--border-color)}.ias-search-widget .calendar .footer button{width:auto;margin-bottom:1rem}.ias-search-widget .calendar .header .icon{cursor:pointer;transition:.15s ease-out}.ias-search-widget .calendar .header .icon:hover{transform:scale(1.75);transition:.25s ease-out;color:var(--primary-color-lighter)}.ias-search-widget .calendar .header .icon:first-of-type{margin-left:1em}.ias-search-widget .calendar .header .icon:last-of-type{margin-right:1em}.ias-search-widget .calendar .days{text-transform:uppercase;font-weight:400;color:var(--text-color-light);font-size:70%;padding:.75em 0;border-bottom:1px solid var(--border-color)}.ias-search-widget .calendar .body .cell{position:relative;overflow:hidden;cursor:pointer;background:var(--neutral-color);transition:.25s ease-out}.ias-search-widget .calendar .body .cell:hover{background:var(--neutral-grey);transition:.5s ease-out}.ias-search-widget .calendar .body .selected,.ias-search-widget .calendar .body .selected:hover{background-color:var(--primary-color-lighter);color:#fff}.ias-search-widget .calendar .body .between{background-color:var(--primary-color-lightest)}.ias-search-widget .calendar .body .cell:last-child{border-right:none}.ias-search-widget .calendar .body .cell .number{position:relative;font-size:.825rem;height:75%;font-weight:700;width:100%;display:block}.ias-search-widget .calendar .body .cell .number span{position:relative;bottom:-.625rem}.ias-search-widget .calendar .row:before{display:none}.ias-search-widget .calendar:not(.lowFares) .body .cell .number{margin:.5rem 0}.ias-search-widget .calendar:not(.lowFares) .body .cell .number span{position:relative;bottom:auto}.ias-search-widget .calendar .body .cell .lowestPrice{font-size:.75rem}.ias-search-widget .calendar .body .cell .lowestPrice span{position:relative;top:-.125rem}.ias-search-widget .calendar .body .disabled{color:var(--text-color-light);background-color:inherit;pointer-events:none}.ias-search-widget .calendar .body .disabled .lowestPrice,.ias-search-widget .calendar .body .disabled .number{display:none}.ias-search-widget .calendar .body .befortoday .load,.ias-search-widget .calendar .body .disabled .load,.ias-search-widget .calendar .body .notavailable .lowestPrice{visibility:hidden}.ias-search-widget .calendar .body .notavailable{color:var(--text-color-light);pointer-events:none}.ias-search-widget .calendar.lowFares .cell.notavailable .lowestPrice{font-size:0}.ias-search-widget .calendar.hideSoldout .soldout{pointer-events:none;color:var(--text-color-light)}.ias-search-widget .calendar .body .soldout{pointer-events:none}.ias-search-widget .calendar .body .soldout .lowestPrice{font-size:.4rem;text-transform:uppercase}.ias-search-widget .calendar .body .cell .load .ias-loader-spin{width:1rem}.ias-search-widget .calendar .body .cell.disabled.between{border:none;background-color:transparent}.ias-search-widget .calendar .body .col{padding:0 0 .5rem;text-align:center}.ias-search-widget .secondary--label{display:none!important}.ias-search-widget .dateRangeControls{display:-ms-flexbox;display:flex;width:auto;-ms-flex-align:end;align-items:end}.ias-search-widget .dateRangeControls span{-ms-flex-preferred-size:auto;flex-basis:auto;-ms-flex:1;flex:1}.ias-search-widget .dateRangeControls span.dateInputControl{position:relative}.ias-search-widget .dateRangeControls span.dateIcon{-ms-flex:0;flex:0;height:3rem;display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.ias-search-widget .passengerSelection{grid-area:pax}.ias-search-widget .passengerSelection .optionContainer{height:0;opacity:0;visibility:hidden;pointer-events:none;position:absolute;display:-ms-flexbox;display:flex;padding:1rem;background-color:#fff}.ias-search-widget .passengerSelection .optionContainer.show{opacity:1;visibility:visible;pointer-events:all;height:auto;width:100%;min-width:275px;z-index:2}.ias-search-widget .passengerSelection .passengerCount{display:block;min-width:190px}.ias-search-widget .passengerSelection .passengerCount span{display:inline-block;margin-right:.3em}.ias-search-widget .passengerSelection .passengerTypes{width:100%;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.ias-search-widget .passengerSelection .passengerTypes:first-child{margin-top:0}.ias-search-widget .passengerSelection .passengerTypes .field{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.ias-search-widget .passengerSelection .passengerTypes .field .stepper{display:-ms-flexbox;display:flex;-ms-flex-negative:1;flex-shrink:1;-ms-flex-pack:end;justify-content:end}.ias-search-widget .passengerSelection .passengerTypes .field label{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:distribute;justify-content:space-around;margin:0;min-width:30%}.ias-search-widget .passengerSelection .passengerTypes .field input{min-width:3rem;-ms-flex-preferred-size:3rem;flex-basis:3rem;text-align:center;padding:0!important}.ias-search-widget .passengerSelection .passengerTypes .field button{-ms-flex-preferred-size:1rem;flex-basis:1rem}.ias-search-widget .passengerSelection .passengerTypes .desc{font-size:.8rem}.ias-search-widget.horizontal label{display:block;overflow:hidden;white-space:nowrap}.ias-search-widget.horizontal button{height:auto}.ias-search-widget.horizontal form{display:-ms-grid;display:grid;-ms-grid-columns:2fr 2fr 1fr 1fr;grid-template-columns:2fr 2fr 1fr 1fr;-ms-flex-align:end;align-items:end;grid-column-gap:1em;-ms-grid-rows:1fr 1fr;grid-template-rows:1fr 1fr;grid-template-areas:\"airports dates pax submit\" \"trip cabin currencies promocode\"}.ias-search-widget.horizontal form .airportSelection{grid-area:airports;display:-ms-flexbox;display:flex;min-width:0!important}.ias-search-widget.horizontal form .airportSelection div{-ms-flex:1;flex:1;min-width:0;max-width:100%}.ias-search-widget.horizontal form .airportSelection .swapAirports{-ms-flex:0;flex:0;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;padding:0 5px;min-width:1.5rem!important}.ias-search-widget.horizontal form .airportSelection .swapAirports a{transform:rotate(0deg);position:relative;top:12px}.ias-search-widget.horizontal form .dateSelection{grid-area:dates}.ias-search-widget.horizontal form .react-autosuggest__suggestions-container--open{min-width:320px!important}.ias-search-widget.horizontal form .passengerSelection .passengerCount{min-width:9rem!important}.ias-search-widget.horizontal form .formSubmit{grid-area:submit}.ias-search-widget.horizontal form .tripTypeSelection{grid-area:trip;-ms-flex-item-align:end;-ms-grid-row-align:end;align-self:end}.ias-search-widget.horizontal form .tripTypeSelection .stv-radio-buttons-wrapper label{width:50%}.ias-search-widget.horizontal form .cabinClassSelection{grid-area:cabin;-ms-flex-item-align:end;-ms-grid-row-align:end;align-self:end}.ias-search-widget.horizontal form .currenciesSelection{grid-area:currencies;-ms-flex-item-align:end;-ms-grid-row-align:end;align-self:end}.ias-search-widget.horizontal form .promocodeField{grid-area:promocode;-ms-flex-item-align:end;-ms-grid-row-align:end;align-self:end}.ias-search-widget.rtlStyles{direction:rtl}.ias-search-widget.rtlStyles button.clear-selected{right:auto!important;left:.125rem!important;rotate:180deg}.ias-search-widget.rtlStyles .passengerCount,.ias-search-widget.rtlStyles .select-css{background-position:left 1em top 50%,0 0!important}.ias-search-widget.rtlStyles span.dateIcon{rotate:180deg}.ias-search-widget.rtlStyles .stv-radio-button+label:first-of-type{border-radius:0 .4em .4em 0}.ias-search-widget.rtlStyles .stv-radio-button+label:last-of-type{border-radius:.4em 0 0 .4em}.ias-search-widget.rtlStyles .iasslidertg:before{bottom:0;top:0}.ias-search-widget.rtlStyles .iasslidertg:after{right:20px;left:0;top:0;margin-left:0;margin-right:0}.ias-search-widget.rtlStyles .toggle-switch{margin-right:50px;margin-left:0}.ias-search-widget.validate .dateRangeControls{-ms-flex-align:baseline;align-items:baseline}.ias-search-widget.validate .dateRangeControls span.dateIcon{height:auto}.ias-search-widget.validate form{-ms-grid-rows:1fr 0fr;grid-template-rows:1fr 0fr;-ms-flex-align:start;align-items:flex-start}.ias-search-widget.validate form .airportSelection .swapAirports{-ms-flex-item-align:baseline;align-self:baseline;height:3rem}.ias-search-widget.validate form .airportSelection .swapAirports a{top:2.25rem}.ias-search-widget.validate form .formSubmit{margin-top:2.25rem}", ""]);

	// exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,i){ true?module.exports=i():"function"==typeof define&&define.amd?define(i):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_isBetween=i()}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	exports.__esModule = true;
	__export(__webpack_require__(69));
	var isMobile_1 = __webpack_require__(69);
	exports["default"] = isMobile_1["default"];
	//# sourceMappingURL=index.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateHeight = function calculateHeight(el) {
	  // Source adapted from: http://youmightnotneedjquery.com/#outer_height_with_margin
	  var height = el.offsetHeight;

	  var _getComputedStyle = getComputedStyle(el);

	  var marginTop = _getComputedStyle.marginTop;
	  var marginBottom = _getComputedStyle.marginBottom;


	  height += parseInt(marginTop, 10) + parseInt(marginBottom, 10);
	  return height;
	};

	// Source adapted from: http://stackoverflow.com/a/16324762
	var makeHandler = function makeHandler(el) {
	  return function (event) {
	    var scrollTop = el.scrollTop;
	    var scrollHeight = el.scrollHeight;
	    var type = event.type;
	    var detail = event.detail;
	    var wheelDelta = event.wheelDelta;

	    var height = calculateHeight(el);
	    var delta = type === 'DOMMouseScroll' ? detail * -40 : wheelDelta;
	    var up = delta > 0;

	    var prevent = function prevent() {
	      event.stopPropagation();
	      event.preventDefault();
	      event.returnValue = false;

	      return false;
	    };

	    if (!up && -delta > scrollHeight - height - scrollTop) {
	      el.scrollTop = scrollHeight;
	      return prevent();
	    } else if (up && delta > scrollTop) {
	      el.scrollTop = 0;
	      return prevent();
	    }
	  };
	};

	exports.default = function (el) {
	  var handler = makeHandler(el);

	  var addEvent = (el.addEventListener || el.attachEvent).bind(el);
	  var removeEvent = (el.removeEventListener || el.detachEvent).bind(el);

	  addEvent('mousewheel', handler);
	  addEvent('DOMMouseScroll', handler);

	  return function () {
	    removeEvent('mousewheel', handler);
	    removeEvent('DOMMouseScroll', handler);
	  };
	};

	module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/

	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			return;('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';

	var ReactPropTypesSecret = __webpack_require__(148);

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	module.exports = ReactPropTypesSecret;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(9);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(14);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _isolatedScroll = __webpack_require__(145);

	var _isolatedScroll2 = _interopRequireDefault(_isolatedScroll);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { return;("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { return;("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { return;("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var unbindHandlersKey = '__unbind_handlers__';

	var IsolatedScroll = function (_Component) {
	  _inherits(IsolatedScroll, _Component);

	  function IsolatedScroll() {
	    _classCallCheck(this, IsolatedScroll);

	    var _this = _possibleConstructorReturn(this, (IsolatedScroll.__proto__ || Object.getPrototypeOf(IsolatedScroll)).call(this));

	    _this.storeComponentReference = _this.storeComponentReference.bind(_this);
	    return _this;
	  }

	  _createClass(IsolatedScroll, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this[unbindHandlersKey] = (0, _isolatedScroll2.default)(this.component);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this[unbindHandlersKey]();
	    }
	  }, {
	    key: 'storeComponentReference',
	    value: function storeComponentReference(component) {
	      if (component !== null) {
	        this.component = component;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;


	      return _react2.default.createElement(
	        'div',
	        _extends({ ref: this.storeComponentReference }, this.props),
	        children
	      );
	    }
	  }]);

	  return IsolatedScroll;
	}(_react.Component);

	IsolatedScroll.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	exports.default = IsolatedScroll;
	module.exports = exports['default'];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', { value: true });

	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

	var _extends = _interopDefault(__webpack_require__(79));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(81));
	var _inheritsLoose = _interopDefault(__webpack_require__(80));
	var react = __webpack_require__(9);
	var PropTypes = _interopDefault(__webpack_require__(14));
	var ResizeObserver = _interopDefault(__webpack_require__(154));

	var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
	function getTypes(props) {
	  var allowedTypes = [];
	  types.forEach(function (type) {
	    if (props[type]) {
	      allowedTypes.push(type);
	    }
	  });
	  return allowedTypes;
	}

	function getContentRect(node, types) {
	  var calculations = {};

	  if (types.indexOf('client') > -1) {
	    calculations.client = {
	      top: node.clientTop,
	      left: node.clientLeft,
	      width: node.clientWidth,
	      height: node.clientHeight
	    };
	  }

	  if (types.indexOf('offset') > -1) {
	    calculations.offset = {
	      top: node.offsetTop,
	      left: node.offsetLeft,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    };
	  }

	  if (types.indexOf('scroll') > -1) {
	    calculations.scroll = {
	      top: node.scrollTop,
	      left: node.scrollLeft,
	      width: node.scrollWidth,
	      height: node.scrollHeight
	    };
	  }

	  if (types.indexOf('bounds') > -1) {
	    var rect = node.getBoundingClientRect();
	    calculations.bounds = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.width,
	      height: rect.height
	    };
	  }

	  if (types.indexOf('margin') > -1) {
	    var styles = getComputedStyle(node);
	    calculations.margin = {
	      top: styles ? parseInt(styles.marginTop) : 0,
	      right: styles ? parseInt(styles.marginRight) : 0,
	      bottom: styles ? parseInt(styles.marginBottom) : 0,
	      left: styles ? parseInt(styles.marginLeft) : 0
	    };
	  }

	  return calculations;
	}

	/**
	 * Returns the global window object associated with provided element.
	 */
	function getWindowOf(target) {
	  // Assume that the element is an instance of Node, which means that it
	  // has the "ownerDocument" property from which we can retrieve a
	  // corresponding global object.
	  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local window object if it's not possible extract one from
	  // provided element.

	  return ownerGlobal || window;
	}

	function withContentRect(types) {
	  return function (WrappedComponent) {
	    var _class, _temp;

	    return _temp = _class =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithContentRect, _Component);

	      function WithContentRect() {
	        var _this;

	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }

	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          contentRect: {
	            entry: {},
	            client: {},
	            offset: {},
	            scroll: {},
	            bounds: {},
	            margin: {}
	          }
	        };
	        _this._animationFrameID = null;
	        _this._resizeObserver = null;
	        _this._node = null;
	        _this._window = null;

	        _this.measure = function (entries) {
	          var contentRect = getContentRect(_this._node, types || getTypes(_this.props));

	          if (entries) {
	            contentRect.entry = entries[0].contentRect;
	          }

	          _this._animationFrameID = _this._window.requestAnimationFrame(function () {
	            if (_this._resizeObserver !== null) {
	              _this.setState({
	                contentRect: contentRect
	              });

	              if (typeof _this.props.onResize === 'function') {
	                _this.props.onResize(contentRect);
	              }
	            }
	          });
	        };

	        _this._handleRef = function (node) {
	          if (_this._resizeObserver !== null && _this._node !== null) {
	            _this._resizeObserver.unobserve(_this._node);
	          }

	          _this._node = node;
	          _this._window = getWindowOf(_this._node);
	          var innerRef = _this.props.innerRef;

	          if (innerRef) {
	            if (typeof innerRef === 'function') {
	              innerRef(_this._node);
	            } else {
	              innerRef.current = _this._node;
	            }
	          }

	          if (_this._resizeObserver !== null && _this._node !== null) {
	            _this._resizeObserver.observe(_this._node);
	          }
	        };

	        return _this;
	      }

	      var _proto = WithContentRect.prototype;

	      _proto.componentDidMount = function componentDidMount() {
	        this._resizeObserver = this._window !== null && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new ResizeObserver(this.measure);

	        if (this._node !== null) {
	          this._resizeObserver.observe(this._node);

	          if (typeof this.props.onResize === 'function') {
	            this.props.onResize(getContentRect(this._node, types || getTypes(this.props)));
	          }
	        }
	      };

	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this._window !== null) {
	          this._window.cancelAnimationFrame(this._animationFrameID);
	        }

	        if (this._resizeObserver !== null) {
	          this._resizeObserver.disconnect();

	          this._resizeObserver = null;
	        }
	      };

	      _proto.render = function render() {
	        var _this$props = this.props,
	            innerRef = _this$props.innerRef,
	            onResize = _this$props.onResize,
	            props = _objectWithoutPropertiesLoose(_this$props, ["innerRef", "onResize"]);

	        return react.createElement(WrappedComponent, _extends({}, props, {
	          measureRef: this._handleRef,
	          measure: this.measure,
	          contentRect: this.state.contentRect
	        }));
	      };

	      return WithContentRect;
	    }(react.Component), _class.propTypes = {
	      client: PropTypes.bool,
	      offset: PropTypes.bool,
	      scroll: PropTypes.bool,
	      bounds: PropTypes.bool,
	      margin: PropTypes.bool,
	      innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	      onResize: PropTypes.func
	    }, _temp;
	  };
	}

	var Measure = withContentRect()(function (_ref) {
	  var measure = _ref.measure,
	      measureRef = _ref.measureRef,
	      contentRect = _ref.contentRect,
	      children = _ref.children;
	  return children({
	    measure: measure,
	    measureRef: measureRef,
	    contentRect: contentRect
	  });
	});
	Measure.displayName = 'Measure';
	Measure.propTypes.children = PropTypes.func;

	exports.default = Measure;
	exports.withContentRect = withContentRect;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { return;('Invalid attempt to destructure non-iterable instance'); } }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

	var _objectAssign = __webpack_require__(146);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	var truthy = function truthy(x) {
	  return x;
	};

	exports['default'] = function (input) {
	  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

	  var _ref2 = _slicedToArray(_ref, 2);

	  var theme = _ref2[0];
	  var classNameDecorator = _ref2[1];

	  return function (key) {
	    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      names[_key - 1] = arguments[_key];
	    }

	    var styles = names.map(function (name) {
	      return theme[name];
	    }).filter(truthy);

	    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
	  };
	};

	module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();

	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;

	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;

	module.exports = __webpack_require__(153);

	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	!(function(global) {
	  "use strict";

	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };

	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }

	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };

	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      context.method = method;
	      context.arg = arg;

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }

	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;

	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }

	          context.dispatchException(context.arg);

	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          if (record.arg === ContinueSentinel) {
	            continue;
	          }

	          return {
	            value: record.arg,
	            done: context.done
	          };

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }

	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;

	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);

	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }

	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);

	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    var info = record.arg;

	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;

	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;

	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }

	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }

	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[toStringTagSymbol] = "Generator";

	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.method = "next";
	      this.arg = undefined;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;

	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }

	        return !! caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }

	      return this.complete(record);
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }

	      return ContinueSentinel;
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }

	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';

	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();

	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();

	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();

	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }

	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());

	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });

	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });

	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }

	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());

	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());

	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                return;('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                return;('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                return;('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                return;('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                return;('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());

	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                return;('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                return;('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });

	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();

	    return index;

	})));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	"use strict";

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { return;("Invalid attempt to destructure non-iterable instance"); } }; }();

	module.exports = function (_ref) {
	  var data = _ref.data;
	  var multiSection = _ref.multiSection;

	  function nextNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = 0;
	    } else {
	      sectionIndex++;
	    }

	    while (sectionIndex < data.length && data[sectionIndex] === 0) {
	      sectionIndex++;
	    }

	    return sectionIndex === data.length ? null : sectionIndex;
	  }

	  function prevNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = data.length - 1;
	    } else {
	      sectionIndex--;
	    }

	    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
	      sectionIndex--;
	    }

	    return sectionIndex === -1 ? null : sectionIndex;
	  }

	  function next(position) {
	    var _position = _slicedToArray(position, 2);

	    var sectionIndex = _position[0];
	    var itemIndex = _position[1];


	    if (multiSection) {
	      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
	        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

	        if (sectionIndex === null) {
	          return [null, null];
	        }

	        return [sectionIndex, 0];
	      }

	      return [sectionIndex, itemIndex + 1];
	    }

	    if (data === 0 || itemIndex === data - 1) {
	      return [null, null];
	    }

	    if (itemIndex === null) {
	      return [null, 0];
	    }

	    return [null, itemIndex + 1];
	  }

	  function prev(position) {
	    var _position2 = _slicedToArray(position, 2);

	    var sectionIndex = _position2[0];
	    var itemIndex = _position2[1];


	    if (multiSection) {
	      if (itemIndex === null || itemIndex === 0) {
	        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

	        if (sectionIndex === null) {
	          return [null, null];
	        }

	        return [sectionIndex, data[sectionIndex] - 1];
	      }

	      return [sectionIndex, itemIndex - 1];
	    }

	    if (data === 0 || itemIndex === 0) {
	      return [null, null];
	    }

	    if (itemIndex === null) {
	      return [null, data - 1];
	    }

	    return [null, itemIndex - 1];
	  }

	  function isLast(position) {
	    return next(position)[1] === null;
	  }

	  return {
	    next: next,
	    prev: prev,
	    isLast: isLast
	  };
	};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	'use strict';

	function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }

	  if (!arrA || !arrB) {
	    return false;
	  }

	  var len = arrA.length;

	  if (arrB.length !== len) {
	    return false;
	  }

	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }

	  return true;
	}

	module.exports = shallowEqualArrays;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(141);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(71)(content, {"singleton":true});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap=false!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?sourceMap=false!./tabs.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap=false!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?sourceMap=false!./tabs.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(142);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(71)(content, {"singleton":true});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap=false!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?sourceMap=false!./widget.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap=false!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?sourceMap=false!./widget.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// lib.js